{
  "common": {
    "resending": "Resending...",
    "loading": "Loading...",
    "loadingData": "Loading data...",
    "saving": "Saving...",
    "adding": "Adding...",
    "sending": "Sending...",
    "deleting": "Deleting...",
    "solving": "Solving...",
    "removing": "Removing...",
    "creating": "Creating...",
    "confirming": "Confirming...",
    "calling": "Calling...",
    "activating": "Activating...",
    "deactivating": "Deactivating...",
    "generating": "Generating...",
    "downloading": "Downloading...",
    "uploading": "Uploading...",
    "upgrading": "Upgrading...",
    "checking": "Checking...",
    "updating": "Updating...",
    "submitting": "Submitting...",
    "closing": "Closing...",
    "reopening": "Reopening...",
    "duplicating": "Duplicating...",
    "canceling": "Canceling...",
    "restoring": "Restoring...",
    "scheduling": "Scheduling...",
    "continuing": "Continuing...",
    "processing": "Processing...",
    "retrying": "Retrying...",
    "create": "Create",
    "submit": "Submit",
    "unknown": "Unknown",
    "tryAgain": "Try again",
    "notAvailable": "N/A",
    "never": "Never",
    "forever": "Forever",
    "Y": "Yes",
    "N": "No",
    "all": "All",
    "any": "Any",
    "add": "Add",
    "send": "Send",
    "sendMms": "Send MMS",
    "stop": "Stop",
    "learnMore": "Learn more",
    "seeExample": "See example",
    "settings": "Settings",
    "watchTutorial": "Watch tutorial",
    "download": "Download",
    "downloadPdf": "Download PDF",
    "downloadFile": "Download file",
    "upload": "Upload",
    "rename": "Rename",
    "editName": "Edit name",
    "update": "Update",
    "viewDetails": "View details",
    "viewReport": "View report",
    "archive": "Archive",
    "archived": "Archived",
    "saveAsTemplate": "Save as template",
    "duplicate": "Duplicate",
    "cost": "Cost",
    "costWithColon": "Cost:",
    "csv": "Comma-separated values (.csv)",
    "xlsx": "Microsoft Excel workbook (.xlsx)",
    "expand": "Expand",
    "collapse": "Collapse",
    "status": "Status | Statuses",
    "phone": "Phone",
    "email": "Email",
    "supportEmailAddress": "support{'@'}textmagic.com",
    "phones": "Phones",
    "emails": "Emails",
    "save": "Save",
    "apply": "Apply",
    "discard": "Discard",
    "createAnother": "Add another after saving",
    "address": "Address",
    "country": "Country",
    "destinationCountry": "Destination country | Destination countries",
    "price": "Price",
    "minute": "Minute",
    "min": "min",
    "search": "Search",
    "searchFields": "Search fields",
    "showMore": "Show more",
    "hideMore": "Hide more",
    "showLess": "Show less",
    "hide": "Hide",
    "cancel": "Cancel",
    "back": "Back",
    "edit": "Edit",
    "or": "or",
    "delete": "Delete",
    "remove": "Remove",
    "solve": "Solve",
    "fileName": "File name",
    "fileSize": "File size",
    "deleteFile": "Delete file",
    "change": "Change",
    "noResults": "No results",
    "more": "More",
    "actions": "Actions",
    "success": "Success",
    "services": "services",
    "response": "response",
    "schedule": "Schedule",
    "clearAll": "Clear all",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "clearSelection": "Clear selection",
    "recipients": "Recipients",
    "recipient": "Recipient",
    "recipientsWithColon": "Recipients:",
    "permissionDenied": "You are not allowed to perform this action. Please check your account permissions.",
    "paidServicesDisabled": "This functionality is currently disabled for your account. Please <a href=\"{supportLink}\" target=\"_blank\">contact support</a> for more details.",
    "pleaseRetryLaterOrContactSupport": "Please try again later or contact us at {supportEmail}.",
    "unexpectedPleaseRetryLaterOrContactSupport": "An unexpected error has been occurred. Please try again later or contact support.",
    "internalError": "Internal error",
    "confirmations": {
      "defaultTitle": "Are you sure?",
      "delete": "Do you want to delete {entity}?",
      "leavePageUploadingAttachments": "Some files are not finished uploading. If you continue, the upload will be canceled. Are you sure you want to continue?"
    },
    "sorting": {
      "asc": "Ascending",
      "desc": "Descending"
    },
    "from": "From",
    "to": "To",
    "replyTo": "Reply-to",
    "preview": "Preview",
    "date": "Date",
    "none": "None",
    "copy": "Copy",
    "copied": "Copied",
    "textCopied": "Text copied to clipboard",
    "filters": "Filters",
    "import": "Import",
    "logout": "Log out",
    "block": "Block",
    "unblock": "Unblock",
    "close": "Close",
    "addBlockedNumber": "Add blocked number",
    "viewContact": "View contact",
    "addToContacts": "Add to contacts",
    "deleteCall": "Delete call",
    "sendSMS": "Send SMS",
    "sendEmail": "Send email",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "sharedBy": "Shared by",
    "verified": "Verified",
    "notVerified": "Not verified",
    "verify": "Verify",
    "verifyNow": "Verify now",
    "verifying": "Verifying",
    "addNumber": "Add number",
    "addEmail": "Add email",
    "12hFormat": "12-hour clock",
    "24hFormat": "24-hour clock",
    "on": "On",
    "off": "Off",
    "buyNumber": "Buy number",
    "history": "History",
    "addCustomField": "Add new custom field",
    "browseFiles": "Browse files",
    "browseFilesWithDots": "Browse files...",
    "completeWithDots": "complete...",
    "sorryTheLinkToThisAudioIsIncorrect": "Sorry, the link to this audio is incorrect.",
    "pause": "Pause",
    "pausing": "Pausing...",
    "stopping": "Stopping...",
    "resume": "Resume",
    "resuming": "Resuming...",
    "continue": "Continue",
    "confirm": "Confirm",
    "next": "Next",
    "previous": "Previous",
    "outOf": "{count} out of {total}",
    "of": "{count} of {total}",
    "previewOf": "Preview {count} of {total}",
    "saveChanges": "Save changes",
    "discardChanges": "Discard changes",
    "resent": "Resent",
    "resend": "Resend",
    "emoji": "Emoji",
    "pickYourEmoji": "Pick your emoji",
    "dateCreated": "Date created",
    "lastUpdated": "Last updated",
    "lastTriggeredAt": "Last triggered at",
    "createdBy": "Created by",
    "can": "Can",
    "cannot": "Cannot",
    "reset": "Reset",
    "valid": "Valid",
    "invalid": "Invalid",
    "finish": "Finish",
    "move": "Move",
    "moving": "Moving...",
    "copying": "Copying...",
    "person": "{value} person | {value} people",
    "active": "Active",
    "inactive": "Inactive",
    "waitingTime": "Waiting time",
    "show": "Show",
    "decline": "Decline",
    "accept": "Accept",
    "profile": "Profile",
    "deactivate": "Deactivate",
    "pleaseWait": "Please wait...",
    "reopen": "Reopen",
    "saveAndContinue": "Save and continue",
    "who": "who",
    "what": "what",
    "monthly": "monthly",
    "quarterly": "quarterly",
    "how": "how",
    "field": "Field",
    "description": "Description",
    "documentation": "Documentation",
    "createdAt": "Created at",
    "totalCost": "Total cost",
    "networkError": "Network error. Could not connect to the server!",
    "ellipsis": "…",
    "goBack": "Go back",
    "password": "Password",
    "helpAndSupport": "Help & support",
    "whatsNew": "What’s new",
    "soon": "soon",
    "comingSoon": "Coming soon",
    "beta": "BETA",
    "insert": "Insert",
    "copyText": "Copy text",
    "link": "Link",
    "retry": "Retry",
    "shareWithSubAccounts": "Share with sub-accounts",
    "viewChat": "View chat",
    "chat": "Chat",
    "newSms": "New SMS",
    "newEmail": "New email",
    "backToApp": "Back to Textmagic",
    "saved": "Saved",
    "leavePageUnsavedChanges": "You have unsaved changes. If you continue, your changes will be discarded. Are you sure you want to continue?",
    "getStarted": "Get started",
    "connect": "Connect",
    "default": "Default",
    "contactUs": "Contact us",
    "contactUsInline": "contact us",
    "contactSupport": "Contact support",
    "contactSupportInline": "contact support",
    "textmagic": "Textmagic",
    "clear": "Clear",
    "replace": "Replace",
    "copyLink": "Copy link",
    "openInNewTab": "Open in new tab",
    "added": "Added",
    "addedOn": "Added on",
    "viewMore": "View more",
    "required": "Required",
    "received": "Received",
    "pending": "Pending",
    "call": "Call",
    "details": "Details",
    "buyCredit": "Buy credit",
    "unlink": "Unlink",
    "free": "Free",
    "andTemplate": "{first} and {second}",
    "orTemplate": "{first} or {second}",
    "sms": "SMS",
    "senderId": "Sender ID",
    "restore": "Restore",
    "manage": "Manage",
    "downgrade": "Downgrade",
    "upgrade": "Upgrade",
    "videoTutorial": "video tutorial",
    "supportArticle": "support article",
    "dropFilesHere": "Drop files here",
    "and": "and",
    "addAnother": "Add another",
    "url": "URL",
    "you": "You",
    "addFile": "Add file",
    "channels": "Channels",
    "new": "New",
    "reconnect": "Reconnect",
    "reload": "Reload",
    "reloading": "Reloading...",
    "appliedFilter": "{count} applied filter | {count} applied filters",
    "system": "System",
    "unset": "Unset",
    "custom": "Custom",
    "undo": "Undo",
    "redo": "Redo",
    "refresh": "Refresh",
    "refreshing": "Refreshing...",
    "imageUploadFailed": "Image upload failed. Please try again.",
    "unsubscribe": "Unsubscribe",
    "other": "Other",
    "previewInCalendar": "Preview in calendar",
    "insertContent": "Insert content",
    "resetFilters": "Reset filters",
    "replaceImage": "Replace image",
    "features": "Features",
    "administration": "Administration",
    "gettingStarted": "Getting started",
    "codeEditor": "Code editor",
    "newCategory": "New category",
    "attachments": {
      "uploadButton": {
        "title": "Upload a new file",
        "subtitle": "or drag and drop to add more."
      },
      "showMore": "Show next {count} file | Show next {count} files"
    },
    "refreshPage": "Refresh page",
    "tags": "Tags",
    "poor": "Poor",
    "good": "Good",
    "isEmpty": "Is empty",
    "platform": "Platform",
    "clickToEdit": "Click to edit",
    "copyEmbedCode": "Copy embed code",
    "notAvailableFull": "Not available",
    "optional": "Optional"
  },
  "units": {
    "datetime": {
      "second": "second | seconds",
      "minute": "minute | minutes",
      "hour": "hour | hours",
      "day": "day | days",
      "week": "week | weeks",
      "month": "month | months",
      "quarter": "quarter | quarters",
      "year": "year | years",
      "period": {
        "days": "{count} day | {count} days",
        "hours": "{count} hour | {count} hours",
        "minutes": "{count} minute | {count} minutes",
        "weeks": "{count} week | {count} weeks",
        "months": "{count} month | {count} months"
      },
      "ranges": {
        "ALL_TIME": "All time",
        "LAST": "In the last",
        "NOT_LAST": "Not in the last",
        "NEXT": "Due in next",
        "CUSTOM": "Custom range",
        "THIS_DAY": "Today",
        "LAST_DAY": "Yesterday",
        "LAST_7_DAYS": "Last 7 days",
        "LAST_30_DAYS": "Last 30 days",
        "LAST_90_DAYS": "Last 90 days",
        "THIS_MONTH": "This month",
        "LAST_MONTH": "Last month",
        "LAST_THREE_MONTH": "Last three month",
        "THIS_YEAR": "This year",
        "LAST_YEAR": "Last year",
        "NOW_OVERDUE": "Now overdue",
        "NO_DATE": "No due date",
        "EVER": "All time",
        "NEVER": "Never",
        "BEFORE": "Before",
        "AFTER": "After",
        "TIME_FROM_NOW": "Time from now",
        "overdueMoreThen": "Overdue more than",
        "from": "From",
        "to": "To"
      },
      "holiday": "no holidays | {count} holiday | {count} holidays",
      "timeFormat": {
        "h": "12 hours",
        "H": "24 hours"
      },
      "hoursIntervalType": {
        "am": "am",
        "pm": "pm"
      },
      "utc": "UTC",
      "weekDays": {
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        "7": "Sunday"
      },
      "weekday": "weekday",
      "weekend": "weekend day",
      "weekDaysShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      "months": {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
      },
      "monthsShort": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      "from": "from",
      "till": "till",
      "dateCannotBeLessThen": "\"To\" date cannot be less than \"from\" date",
      "dateCannotBeMoreThen": "\"To\" date cannot be more than current date",
      "formatDistance": {
        "lessThanXSeconds": {
          "one": "less than a second",
          "other": "less than {count} seconds"
        },
        "xSeconds": {
          "one": "1 second",
          "other": "{count} seconds"
        },
        "halfAMinute": "half a minute",
        "lessThanXMinutes": {
          "one": "less than a minute",
          "other": "less than {count} minutes"
        },
        "xMinutes": {
          "one": "1 minute",
          "oneShort": "1 min",
          "other": "{count} minutes",
          "otherShort": "{count} min"
        },
        "aboutXHours": {
          "one": "about 1 hour",
          "other": "about {count} hours"
        },
        "xHours": {
          "one": "1 hour",
          "oneShort": "1 h",
          "other": "{count} hours",
          "otherShort": "{count} h"
        },
        "xDays": {
          "one": "1 day",
          "other": "{count} days"
        },
        "aboutXWeeks": {
          "one": "about 1 week",
          "other": "about {count} weeks"
        },
        "xWeeks": {
          "one": "1 week",
          "other": "{count} weeks"
        },
        "aboutXMonths": {
          "one": "about 1 month",
          "other": "about {count} months"
        },
        "xMonths": {
          "one": "1 month",
          "other": "{count} months"
        },
        "aboutXYears": {
          "one": "about 1 year",
          "other": "about {count} years"
        },
        "xYears": {
          "one": "1 year",
          "other": "{count} years"
        },
        "overXYears": {
          "one": "over 1 year",
          "other": "over {count} years"
        },
        "almostXYears": {
          "one": "almost 1 year",
          "other": "almost {count} years"
        },
        "fewSeconds": "few seconds"
      }
    },
    "message": "message|messages",
    "recipient": "recipient|recipients",
    "row": "row|rows",
    "px": "px"
  },
  "status": {
    "undefined": "Undefined",
    "unknown": "Unknown",
    "user": {
      "closed": "Closed",
      "active": "Active",
      "trial": "Trial",
      "subInvited": "Invited",
      "confirm": "Invited",
      "oauthRequest": "Oauth registration request",
      "suspend": "Suspended",
      "pfraud": "Possible fraud",
      "fraud": "Fraud",
      "manualApprove": "Waiting for manual activation",
      "wizard": "Wizard",
      "personalUse": "Personal use",
      "neverLoggedIn": "Never logged in"
    },
    "account": {
      "user": "User",
      "admin": "Admin",
      "superAdmin": "Parent superuser",
      "accountOwner": "Account owner"
    },
    "invoice": {
      "paid": "Paid",
      "pending": "Pending"
    },
    "sms": {
      "none": "None",
      "queue": "Queue",
      "scheduledQueue": "Scheduled queue",
      "sendingError": "Error",
      "enroute": "Enroute",
      "acked": "Acked",
      "delivered": "Delivered",
      "buffered": "Buffered",
      "failed": "Failed",
      "unknown": "Unknown",
      "rejected": "Rejected",
      "bulkInsert": "Bulk insert",
      "scheduledSuspend": "Scheduled suspend",
      "queueSuspend": "Queue suspend",
      "bulkDelivered": "{percent} delivered",
      "sent": "Sent",
      "read": "Read"
    },
    "session": {
      "none": "None",
      "email": "Email to SMS",
      "e2s": "E2S",
      "webApp": "Web App",
      "messenger": "Textmagic Messenger",
      "list": "Distribution List",
      "api": "API",
      "widget": "Widget",
      "mobile": "Mobile",
      "automation": "Automation rules",
      "iosMobile": "iOS App",
      "androidMobile": "Android App",
      "smsChat": "SMS Chat",
      "survey": "SMS Survey",
      "automationFlow": "Automation flows",
      "desktop": "Desktop App",
      "reserved": "Reserved",
      "mcp": "MCP"
    },
    "emailSession": {
      "webApp": "Web App",
      "api": "API",
      "iosApp": "iOS App",
      "androidApp": "Android App",
      "automation": "Automation flows"
    },
    "smsRejection": {
      "byocFreeTrialHasExpired": "Your BYOC (Bring your own CPaaS) free trial has expired. Please {chooseAPlan} to continue using this service.",
      "byocNumberNotSupportSms": {
        "text": "The BYOC number you selected doesn't support SMS. Please {connect} a different number with SMS capabilities to send messages.",
        "connect": "connect"
      },
      "byocNumberDeactivated": "The sender's number was deactivated before the message was sent.",
      "userCarrierMmsNotSupported": "Textmagic doesn't support MMS for this CPaaS provider.",
      "chooseAPlan": "choose a plan",
      "missingNumber": "To activate sending to this country please {buyNumber}.",
      "failedNumber": "To activate sending to this country please {buyNumber}.",
      "contactUnsubscribed": "This contact has unsubscribed from your lists.",
      "contactBlocked": "This contact has been blocked.",
      "disabledVoiceNumber": "Voice message must be sent from a voice enabled number.",
      "suspiciousSession": "Suspicious session.",
      "restrictedCountry": "Your account does not have permission to send messages to this country. Please {contactSupport} for more details.",
      "supplierRestriction": "The message was rejected by the supplier. Please {contactSupport} for more information.",
      "mmsRestriction": "MMS message must be sent from a USA toll-free number.",
      "invalidNumber": "The recipient number is invalid or missing",
      "sendingDisabledOnAccount": "Message rejected by Textmagic. Please {contactSupport} for more details.",
      "smsSurveyRestriction": "The SMS Survey feature is not supported in this country.",
      "urlShortener": "Messages that contain publicly available URL shorteners are rejected. Please avoid using short links in your messages.",
      "undetected": "Unknown reject reason. Please {contactSupport}.",
      "tollFreeUnverified": "Please {complete} to send messages from this number.",
      "tollFreeUnverifiedComplete": "complete the toll-free verification",
      "regultionAu": "Messages to Australia can only be sent from an Australian {dedicateVirtualNumber} or an alphanumeric {senderId}. Please check your {senderSettings} and try again.",
      "regultionGb": "Messages to the United Kingdom can only be sent from a UK {dedicateVirtualNumber} or an alphanumeric {senderId}. Please check your {senderSettings} and try again.",
      "tenDlcRequired": "Please {complete} to send messages from this number.",
      "completeTenDLc": "complete the 10DLC registration",
      "dedicateVirtualNumber": "dedicated virtual number",
      "senderId": "Sender ID",
      "senderSettings": "sender settings",
      "buyNumber": "buy a number",
      "cpaasAuthIssue": "There is an authorization issue with your connected CPaaS provider. Please {update} the provider’s login credentials.",
      "updateCpass": "update",
      "cpaasPhoneIssue": "The linked number is unavailable for use in Textmagic. Please check with {yourProvider} to resolve any issues.",
      "yourProvider": "your provider",
      "connectProvider": "To activate sending to this country, please {action} using the BYOC feature.",
      "connectProviderAction": "connect a CPaaS provider",
      "mmsFormatNotSupported": "The file format in the message is not supported.",
      "byocProviderReason": {
        "text": "The {label} CPaaS provider has rejected your message. Please check the {logs} on their end.",
        "logs": "log details"
      },
      "support": "Please contact support at {supportEmail}"
    },
    "automationRule": {
      "completed": "Completed",
      "lowBalance": "Low Balance",
      "error": "Error"
    },
    "tenDlcPhoneNumber": {
      "approved": "registered",
      "pending": "pending",
      "declined": "declined",
      "failed": "failed"
    },
    "tenDlcCampaigns": {
      "draft": "draft",
      "pending": "pending",
      "inReview": "in review",
      "actionRequired": "action required",
      "active": "registered",
      "pendingCancellation": "pending cancellation",
      "canceled": "canceled",
      "suspended": "suspended",
      "terminated": "terminated"
    },
    "tenDlcBrandStatus": {
      "draft": "draft",
      "pending": "pending",
      "inReview": "in review",
      "verified": "registered",
      "actionRequired": "action required"
    },
    "chat": {
      "w": "Waiting now",
      "a": "Open",
      "c": "Solved",
      "d": "Deleted"
    }
  },
  "currency": {
    "USD": "USD",
    "EUR": "EUR"
  },
  "pageTabTitle": {
    "withoutColon": "Textmagic",
    "withColon": "{title} - Textmagic",
    "consent": "Authorize application",
    "user": {
      "gettingStarted": "Getting started",
      "compose": {
        "compose": "Compose",
        "message": "New text message",
        "email": "New email",
        "sentSmsDetails": "Outbound SMS: {id}",
        "sentSmsBulkDetailsSummary": "SMS session: {id}",
        "scheduledDetails": "Scheduled message: {id}"
      },
      "contacts": {
        "imports": "Imports",
        "import": "Import contacts",
        "importDetails": "Import results",
        "blocked": "Blocked",
        "unsubscribed": "Unsubscribed",
        "lists": "Lists",
        "listsFolders": "@:entities.contactList.title",
        "tags": "Tags",
        "notes": "Notes"
      },
      "history": {
        "history": "History",
        "messageDetails": "Message details",
        "sentSms": "Outbound SMS",
        "sentSmsDetails": "Outbound SMS: {sentSmsId}",
        "sentSmsBulkDetailsSummary": "SMS session: {sessionId}",
        "receivedSms": "Inbound SMS",
        "receivedSmsDetails": "Inbound SMS: {receivedSmsId}",
        "forwardedCalls": "Forwarded calls",
        "outboundCalls": "Outbound calls",
        "inboundCalls": "Inbound calls",
        "inboundCallDetails": "Inbound call: {inboundCallId}",
        "outboundCallDetails": "Outbound call: {outboundCallId}",
        "forwardedCallDetails": "Forwarded call: {forwardedCallId}",
        "outboundEmail": "Outbound email: {id}"
      },
      "templates": "Templates",
      "services": {
        "buyNumber": {
          "callForwardingNoPhone": "Call forwarding"
        }
      },
      "accounts": {
        "subAccounts": {
          "importDetails": "Sub-accounts import results",
          "importFlow": "Import sub-accounts"
        }
      },
      "settings": {
        "numbers": "Numbers",
        "senderIds": "Sender IDs",
        "buyNumber": {
          "number": "Buy a virtual number",
          "callForwarding": "Call forwarding: {phone}",
          "callForwardingNoPhone": "Call forwarding"
        },
        "byoc": {
          "providers": "Providers",
          "phones": "Numbers",
          "senderIds": "Sender IDs",
          "flow": "Create CPaaS provider settings",
          "details": "Edit CPaaS provider settings",
          "callForwarding": "Call forwarding: {phone}"
        },
        "senderSettings": "Sender settings",
        "tollFree": "Toll-free: Overview",
        "tenDlc": "10DLC: Overview",
        "tenDlcRegistration": "10DLC registration",
        "tenDlcCampaignDetails": "10DLC: Campaign details",
        "tollFreeVerification": "Toll-free verification",
        "emailSettings": "Email settings",
        "users": "Users",
        "subAccounts": "Sub-accounts",
        "messenger": "Messenger settings",
        "contacts": "Contacts settings",
        "integrations": "Integrations",
        "integrationSetup": "Connect {provider}",
        "integrationDetails": "{provider} settings",
        "integrationSyncDetails": "{provider} customers sync results"
      }
    },
    "wizard": {
      "base": "How are you planning to use Textmagic?"
    },
    "auth": {
      "login": "Log in to continue",
      "logout": "Logging out...",
      "signup": "Create a free account",
      "signupUnavailable": "Sign up unavailable",
      "notApproved": "We couldn't activate your account",
      "loginPersonal": "Free trial not available",
      "accountSuspended": "Account suspended",
      "accountUnderReview": "Account under review",
      "accountDeletedByOwner": "Account deleted by owner",
      "accountClosed": "Account closed",
      "signupConfirmRegistration": "Verifying...",
      "signupConfirmEmail": "Verifying...",
      "forgotPassword": "Forgot password",
      "verifyEmail": "Verify your email",
      "verifyPhone": "Verify your phone",
      "resetPassword": "Reset password",
      "emailCode": "Enter 2FA code",
      "smsCode": "Enter 2FA code",
      "invite": "Activate your account"
    },
    "payment": "Buy SMS credit",
    "tokenIsLocked": "Too many active sessions"
  },
  "pageTitle": {
    "user": {
      "gettingStarted": "Getting started",
      "chats": "Messenger",
      "chatsSettings": {
        "webWidgets": "Chat widget"
      },
      "compose": {
        "compose": "Compose"
      },
      "contacts": {
        "contacts": "Contacts",
        "lists": "Lists",
        "listsFolders": "@:entities.contactList.title",
        "myContacts": "My contacts",
        "allContacts": "All contacts",
        "import": "Import contacts",
        "imports": "Imports",
        "blocked": "Blocked",
        "tags": "Tags",
        "notes": "Notes",
        "settings": {
          "settings": "Settings",
          "unsubscribeRules": {
            "successful": "The unsubscribe settings have been successfully updated.",
            "defaultReplyMessage": "Thank you - You have been opted out. Text JOIN to opt-in.",
            "alert": {
              "pleaseNote": "Please note:",
              "message": "Unsubscribe settings are shared and affect all your sub-accounts.",
              "messageForUsers": "Unsubscribe settings are shared and affect all your users."
            },
            "optOutConfirmation": {
              "label": "Opt-out confirmation",
              "description": "A confirmation text message will be sent to the number that has unsubscribed. Every message costs credit.",
              "manualLabel": "Manual unsubscribes",
              "manualDescription": "Also send opt-out confirmation when manually unsubscribing a contact.",
              "messageTemplate": "Message template"
            },
            "autoUnsubscribe": {
              "label": "Auto-unsubscribe",
              "description": "Automatically unsubscribe numbers where a network operator was not able to deliver your messages and has returned a \"Failed\" status. You can manually resubscribe these numbers later.",
              "unsubscribeAfter": "Unsubscribe after",
              "option": "{count} outbound message with status \"Failed\" | {count} outbound messages with status \"Failed\""
            },
            "smsChatSettings": {
              "label": "SMS chat settings",
              "closeChat": "Mark chats as solved when unsubscribed",
              "leaveChat": "Leave chats open when unsubscribed",
              "description": "When a contact is unsubscribed, the chat is left open by default and needs to be closed manually later."
            }
          },
          "sharing": {
            "sectionTitle": "Shared contacts settings",
            "onlyMyContacts": "Only my contacts",
            "onlyMyContactsDescription": "This page will only display the contacts that belong to your account.",
            "myContactsAndShared": "My contacts and \"shared to me\" contacts",
            "myContactsAndSharedDescription": "This page will display your contacts and the contacts that have been shared to you by sub-accounts.",
            "contactsPageDisplays": "Contacts page displays",
            "successNotification": "The contacts sharing settings have been successfully saved."
          }
        }
      },
      "scheduled": {
        "scheduled": "Scheduled",
        "upcoming": "Upcoming",
        "paused": "Paused",
        "notSent": "Not sent",
        "completed": "Completed",
        "calendar": "Calendar",
        "details": "{which} message details",
        "detailsEmail": "{which} email details",
        "detailsSms": "{which} SMS details",
        "edit": "Scheduled messages"
      },
      "history": {
        "history": "History",
        "sentSms": "Outbound SMS",
        "sentSmsDetails": "Outbound SMS details",
        "sentMessageDetails": "Outbound message details",
        "receivedSms": "Inbound SMS",
        "receivedSmsDetails": "Inbound SMS details",
        "receivedMessageDetails": "Inbound message details",
        "forwardedCalls": "Forwarded calls",
        "outboundCalls": "Outbound calls",
        "inboundCalls": "Inbound calls",
        "outboundEmails": "Outbound emails",
        "outboundEmailsDetails": "Outbound email details",
        "inboundCallDetails": "Inbound call details",
        "outboundCallDetails": "Outbound call details",
        "forwardedCallDetails": "Forwarded call details",
        "commonSms": "SMS",
        "commonEmails": "Emails",
        "commonCalls": "Calls",
        "commonOutbound": "Outbound",
        "commonInbound": "Inbound",
        "commonForwarded": "Forwarded"
      },
      "templates": "Templates",
      "allTemplates": "All templates",
      "newCategory": "New category",
      "forms": {
        "forms": "Forms",
        "subscribe": "Subscribe forms",
        "clickToText": "Click-to-text forms"
      },
      "services": {
        "autoResponders": {
          "title": "Automation rules",
          "new": "Create a new rule"
        },
        "smsSurveys": "SMS Surveys",
        "forms": {
          "forms": "Forms"
        },
        "carrierLookup": {
          "title": "Carrier lookup",
          "flow": "Bulk carrier lookup"
        },
        "emailLookup": {
          "title": "Email lookup",
          "flow": "Bulk email lookup"
        },
        "byoc": "Bring your own CPaaS",
        "pointAi": "Point AI"
      },
      "accounts": {
        "newBilling": {
          "title": "Billing overview"
        },
        "billing": "Billing",
        "users": "Users",
        "monthlyPlans": "Plans",
        "invoices": "Invoices",
        "subAccounts": {
          "title": "Sub-accounts",
          "importFlow": "Import sub-accounts"
        },
        "notifications": "Notifications",
        "dataRetention": "Data retention",
        "statements": "Statements",
        "workspace": "Workspace",
        "personal": "Personal",
        "details": "My account",
        "sso": "Single Sign-On (SSO)",
        "security": "Security"
      },
      "reporting": {
        "reporting": "Reports",
        "overview": "Overview",
        "messages": "Messages",
        "sms": "SMS",
        "email": "Email",
        "calls": "Calls",
        "auditLogs": "Audit logs",
        "numbers": "Numbers"
      },
      "reportingEmail": {
        "overview": "Overview",
        "trends": "Trends",
        "users": "Users",
        "subAccounts": "Sub-accounts",
        "senders": "Senders",
        "links": "Links"
      },
      "reportingSms": {
        "overview": "Overview",
        "trends": "Trends",
        "numbers": "Numbers",
        "subAccounts": "Sub-accounts",
        "users": "Users"
      },
      "tasks": {
        "tasks": "Tasks",
        "settings": "Tasks settings"
      },
      "tickets": {
        "tickets": "Tickets"
      },
      "deals": {
        "deals": "Deals",
        "settings": "Deals settings"
      },
      "settings": {
        "settings": "Settings",
        "smsVoice": "SMS & voice",
        "email": "Email",
        "liveChat": "Chat widget",
        "whatsApp": "WhatsApp",
        "facebook": "Facebook",
        "instagram": "Instagram",
        "messenger": "Messenger",
        "contacts": "Contacts",
        "api": "API",
        "emailToSms": "Email to SMS",
        "autoResponders": "Auto-responders",
        "tickets": "Tickets",
        "tasks": "Tasks",
        "deals": "Deals",
        "pointAi": "Point AI",
        "workspace": "Workspace",
        "billing": "Billing",
        "billingOverview": "Overview",
        "billingPlans": "Plans",
        "billingInvoices": "Invoices",
        "billingStatements": "Statements",
        "account": "My account",
        "domainsAndSenders": "Domains & senders",
        "unsubscribeRules": "Unsubscribe rules",
        "sharing": "Contacts sharing",
        "customFields": "Custom fields",
        "apiv2Keys": "API v2 keys",
        "apiv2Settings": "API v2 settings",
        "integrations": "Integrations",
        "integrationsMcp": "AI agents (MCP)",
        "apiv1": "API v1 (legacy)",
        "emailToSmsAllowedEmails": "Allowed emails",
        "emailToSmsSendReceiveSettings": "Send & receive settings",
        "emailToSmsDistributionLists": "Distribution lists",
        "emailToSmsDistributionListsCreate": "New distribution list",
        "emailToSmsDistributionListsEdit": "Edit distribution list",
        "autoRespondersKeywords": "Auto-responders: Keywords",
        "autoRespondersLogs": "Auto-responders: Logs",
        "autoRespondersNew": "Create a new rule",
        "autoRespondersEdit": "Edit rule",
        "autoRespondersNewRule": "New auto-responder",
        "autoRespondersDetails": "Auto-responder details",
        "autoRespondersLogDetails": "Auto-responder log details",
        "accountDetails": "Account details",
        "accountSecurity": "Security",
        "accountSecurity2faSetup": "Two-factor authentication",
        "accountNotifications": "Notifications",
        "accountConnectedApps": "Connected apps",
        "ticketsConnectedInboxes": "Connected inboxes",
        "ticketsSpamFilter": "Spam filter",
        "ticketsGeneral": "General",
        "distributionListsEdit": "Distribution list details"
      }
    }
  },
  "entities": {
    "deletedEntity": "(Deleted {entity})",
    "emailLink": {
      "name": "link | links"
    },
    "segments": {
      "addSegmentsWithCount": "Add {count} segments | Add {count} segment | Add {count} segments",
      "addSegment": "Add segment",
      "searchPlaceholder": "Search segments"
    },
    "filteredView": {
      "name": "filtered view | filtered views"
    },
    "reportingNumber": {
      "name": "report | reports"
    },
    "loginHistory": {
      "name": "session | sessions"
    },
    "unsubscribedContact": {
      "menuTitle": "Unsubscribed",
      "name": "contact | contacts",
      "searchPlaceholder": "Search unsubscribers"
    },
    "users": {
      "name": "user | users",
      "searchPlaceholder": "Search sub-accounts"
    },
    "contactList": {
      "name": "list | lists",
      "title": "Lists",
      "private": "Private",
      "filterLists": "Filter lists",
      "sharedToMe": "Shared to me",
      "sharedByMe": "Shared by me",
      "sendSMSToList": "Send SMS to this list",
      "makeListPrivate": "Make this list private",
      "shareThisList": "Share this list with sub-accounts",
      "hideList": "Hide list",
      "editList": "Edit list",
      "deleteList": "Delete list",
      "newList": "New list",
      "newContact": "New contact",
      "visible": "visible",
      "hidden": "hidden",
      "hide": "Hide",
      "unhide": "Unhide",
      "unhideAll": "Unhide all",
      "visiblityChangeSuccessMessage": "The selected lists have been successfully updated.",
      "membersCountText": "0 contacts | {countText} contact | {countText} contacts",
      "hiddenListsTooltip": "No hidden lists | {count} hidden list | {count} hidden lists",
      "foldersCountText": "{countText} folder | {countText} folders",
      "listsCountText": "{countText} list | {countText} lists",
      "searchPlaceholder": "Search lists"
    },
    "contacts": {
      "name": "contact | contacts",
      "count": "{count} contact | {count} contacts",
      "viewTitle": "View contact",
      "editTitle": "Edit contact",
      "addListsWithCount": "Add {count} lists | Add {count} list | Add {count} lists",
      "addList": "Add list",
      "addNewContact": "Add new contact",
      "importContacts": "Import contacts",
      "imports": "Imports",
      "import": {
        "statusFailed": "Error",
        "statusSuccess": "Completed",
        "statusImporting": "Importing...({percent}%)",
        "statusCleaningUp": "Cleaning up...({percent}%)"
      },
      "fields": {
        "firstName": "First name",
        "firstNamePlaceholder": "Enter first name",
        "lastNamePlaceholder": "Enter last name",
        "lastName": "Last name",
        "lists": "Lists",
        "email": "Email address",
        "phone": "Phone number",
        "whatsappPhone": "WhatsApp number",
        "company": "Company",
        "emailPlaceholder": "Enter email address",
        "companyPlaceholder": "Enter company",
        "phonePlaceholder": "Enter phone",
        "whatsappPhonePlaceholder": "Enter WhatsApp phone",
        "whatsappPhoneActivator": "Connect WhatsApp",
        "ownerId": "Contact owner",
        "tagIds": "Tags",
        "tagIdsPlaceholder": "Add Tags"
      },
      "addContact": "Add contact",
      "viewContact": "View contact",
      "myContacts": "My contacts",
      "allContacts": "All contacts",
      "customFields": "Custom fields",
      "blockedContacts": "Blocked",
      "addNumberContact": "Add 0 contacts | Add {count} contact | Add {count} contacts",
      "searchLists": "Search lists",
      "createNewList": "Create new list",
      "customFieldPlaceholder": "Enter {name}",
      "customFieldSelectPlaceholder": "Select {name}",
      "searchPlaceholder": "Search contacts",
      "deleteContact": "Delete contact",
      "showCustomFields": {
        "show": "Show {customFields}",
        "customFields": "{count} more field | {count} more fields"
      },
      "validation": {
        "create": {
          "atLeastOneRequired": "You should specify at least one of the following fields: First name, Last name, Email address, Phone number, or WhatsApp number."
        },
        "update": {
          "atLeastOneRequired": "Please fill more contact details to update this contact."
        }
      },
      "updateWhatsAppNumber": "Update WhatsApp number",
      "ifYouUpdateTheWhatsAppNumber": "<p>If you update the WhatsApp number for <b>{name}</b>, the current chat will be unlinked from this contact and remain in Messenger without a linked contact.</p><p>The new WhatsApp number will be assigned to <b>{name}</b>, but the contact needs to initiate a new WhatsApp conversation from the updated number before you can message them.</p>Are you sure you want to update this contact’s WhatsApp number?",
      "contactWithEmailAlreadyExists": "A contact with this email address already exists.",
      "contactWithPhoneAlreadyExists": "A contact with this phone number already exists."
    },
    "contactImport": {
      "name": "file | files",
      "importedCountText": "0 contacts | {count} contact | {count} contacts",
      "fix": "Fix",
      "searchPlaceholder": "Search imported files"
    },
    "contactImportResult": {
      "name": "contact | contacts",
      "searchPlaceholder": "Search contacts",
      "errors": {
        "invalidEmailFormat": "Invalid email address format.",
        "invalidPhoneFormat": "Invalid phone number format.",
        "conflictedContacts": "Different contacts with this phone and email already exist.",
        "unsubscribedEmail": "Email address is unsubscribed.",
        "unsubscribedPhone": "Phone number is unsubscribed.",
        "blockedPhone": "Phone number is blocked.",
        "blockedEmail": "Email address is blocked.",
        "invalidCustomFields": "Invalid or unsupported value in custom fields.",
        "invalidCustomField": "Invalid or unsupported value."
      }
    },
    "blockedContacts": {
      "name": "contact | contacts",
      "searchPlaceholder": "Search blocked contacts"
    },
    "customFields": {
      "name": "custom field |  fields",
      "editTitle": "Edit custom field",
      "newTitle": "New custom field",
      "addOption": "Add option",
      "fieldTypeLabels": {
        "text": "Text",
        "checkbox": "Checkbox",
        "dropdown": "Drop-down list",
        "datetime": "Date",
        "number": "Number"
      },
      "searchPlaceholder": "Search custom fields"
    },
    "imports": {
      "name": "import | imports",
      "newTitle": "New import",
      "tabs": {
        "imported": "Imported",
        "duplicates": "Duplicates excluded",
        "duplicatesShort": "Duplicates excl.",
        "failed": "Failed to import",
        "failedShort": "Failed",
        "excluded": "Landlines excluded",
        "excludedShort": "Landlines excl.",
        "unsubscribed": "Unsubscribed (Cleanup)",
        "unsubscribedShort": "Unsubscribed"
      },
      "downloadOriginalFile": "Download original file",
      "downloadLookupFile": "Download lookup file"
    },
    "baseModel": {
      "fields": {
        "createdAt": "Created at",
        "updatedAt": "Updated at"
      }
    },
    "sentSms": {
      "name": "message | messages",
      "sendTime": "Send time",
      "messageContent": "Message content",
      "sendReply": "Send reply",
      "messageId": "Message ID",
      "editAndResend": "Edit SMS and resend",
      "source": "Source",
      "totalCharacters": "Total characters",
      "charactersNumber": "{number} character | {number} characters",
      "messageParts": "Message parts",
      "messagePartsNumber": "{number} part | {number} parts",
      "recipientsNumber": "{number} recipient | {number} recipients",
      "encoding": "Encoding",
      "unicode": "Unicode",
      "plainText": "Plain text",
      "searchPlaceholder": "Search messages",
      "fromEmail": "From email"
    },
    "sentSmsShort": {
      "name": "message | messages"
    },
    "bulkSentSms": {
      "name": "message | messages",
      "sessionId": "Session ID",
      "sendTime": "Send time",
      "receivedTime": "Received time",
      "phonesNumber": "{number} numbers"
    },
    "receivedSms": {
      "name": "message | messages",
      "tabTitle": "Inbound SMS details",
      "receivedTime": "Received time",
      "messageContent": "Message content",
      "messageId": "Message ID"
    },
    "template": {
      "name": "template | templates",
      "saveAsTemplate": "Save as template",
      "useTemplate": "Use template",
      "searchPlaceholder": "Search templates",
      "deleteTemplate": "Delete template",
      "editTemplate": "Edit template",
      "newTemplate": "New template",
      "modalTitle": "Templates"
    },
    "smsTemplate": {
      "name": "SMS template | SMS templates"
    },
    "templateCategory": {
      "name": "category | categories",
      "allCategories": "All categories",
      "editCategory": "Edit category"
    },
    "sendReceiveSettings": {
      "name": "send & receive setting | send & receive settings"
    },
    "inboundCall": {
      "name": "inbound call | inbound calls",
      "id": "Call ID",
      "direction": "Direction",
      "answeredCall": "Inbound call",
      "missedCall": "Missed call",
      "callTime": "Call time",
      "callLength": "Call length",
      "searchPlaceholder": "Search calls"
    },
    "outboundCall": {
      "name": "outbound call | outbound calls",
      "id": "Call ID",
      "direction": "Direction",
      "outboundCall": "Outbound call",
      "callTime": "Call time",
      "callLength": "Call length",
      "searchPlaceholder": "Search calls"
    },
    "forwardedCall": {
      "name": "forwarded call | forwarded calls",
      "id": "Call ID",
      "forwardedCall": "Forwarded call",
      "callTime": "Call time",
      "callLength": "Call length",
      "editSettings": "Edit forwarding settings",
      "caller": "Caller",
      "numberDialed": "Number dialed",
      "forwardedTo": "Call forwarded to",
      "greetingUsed": "Greeting used",
      "searchPlaceholder": "Search calls"
    },
    "invoices": {
      "name": "invoices",
      "searchPlaceholder": "Search invoices"
    },
    "unsubscribedSettings": {
      "name": "unsubscribed settings | unsubscribed settings"
    },
    "notes": {
      "name": "Note"
    },
    "userCustomField": {
      "name": "field | fields",
      "newCustomField": "New custom field"
    },
    "forwardAudio": {
      "name": "file | files"
    },
    "senderId": {
      "name": "Sender ID | Sender IDs",
      "lowerCaseName": "ID | IDs",
      "status": {
        "A": "Accepted",
        "R": "Rejected",
        "P": "Pending"
      },
      "searchPlaceholder": "Search sender IDs",
      "bySenderId": "{name} (Sender ID)"
    },
    "activityCall": {
      "name": "Call"
    },
    "activitySentSms": {
      "name": "Sent SMS"
    },
    "activityReply": {
      "name": "Inbound SMS"
    },
    "activitySchedule": {
      "name": "Scheduled SMS"
    },
    "subAccountsImport": {
      "name": "file | files"
    },
    "subAccountsImportDetails": {
      "name": "sub-account | sub-accounts"
    },
    "auditLog": {
      "name": "log | logs"
    },
    "emailLookup": {
      "name": "lookup | lookups"
    },
    "emailLookupSession": {
      "name": "lookup | lookups",
      "searchPlaceholder": "Search lookup history",
      "searchPlaceholderBulk": "Search bulk lookup"
    },
    "tenDlcPhoneNumber": {
      "name": "number | numbers"
    },
    "tollFreePhoneNumber": {
      "name": "number | numbers"
    },
    "tenDlcCampaign": {
      "name": "campaign | campaigns"
    },
    "taskBoard": {
      "name": "task board | tasks boards"
    },
    "taskStage": {
      "name": "task stage | tasks stages"
    },
    "task": {
      "name": "task | tasks"
    },
    "attachmentFile": {
      "name": "file | files"
    },
    "recipient": {
      "name": "recipient | recipients"
    },
    "subAccounts": {
      "name": "sub-account | sub-accounts",
      "searchPlaceholder": "Search sub-accounts"
    },
    "scheduledEmailFetch": {
      "name": "email | emails",
      "searchPlaceholder": "Search emails"
    },
    "emailCampaignOpen": {
      "name": "open | opens"
    },
    "emailCampaignClickSummary": {
      "name": "link | links"
    },
    "emailCampaignClick": {
      "name": "click | clicks"
    },
    "emailCampaignUnsubscribe": {
      "name": "unsubscribe | unsubscribes"
    },
    "emailCampaignSpamReport": {
      "name": "spam report | spam reports"
    },
    "tagAnalytics": {
      "name": "tag | tags"
    },
    "tag": {
      "title": "Tags",
      "name": "tag | tags"
    },
    "note": {
      "title": "Notes",
      "name": "note | notes"
    },
    "automationFlow": {
      "name": "flow | flows"
    },
    "automationLog": {
      "name": "log | logs"
    },
    "automationTemplate": {
      "name": "automation template | automation templates"
    },
    "externalIntegrationCustomer": {
      "name": "contact | contacts"
    },
    "shopifyStore": {
      "name": "Shopify store | Shopify stores"
    },
    "wooCommerceStore": {
      "name": "WooCommerce store | WooCommerce stores"
    },
    "subscribeForm": {
      "name": "subscribe form | subscribe forms"
    }
  },
  "notifications": {
    "delete": {
      "successful": "The selected {entity} has been successfully deleted."
    },
    "create": {
      "successful": "The {entity} has been successfully created.",
      "view": "View {entity}"
    },
    "duplicate": {
      "successful": "The {entity} has been successfully duplicated."
    },
    "update": {
      "successful": "The {entity} has been successfully updated.|The {entity} have been successfully updated."
    }
  },
  "filters": {
    "receivedSmsModalTitle": "Inbound SMS filter",
    "receivedSmsFilterTitle": "Inbound messages with no outbound sent",
    "receivedSmsFilterDescription": "Display only the inbound messages with no outbound message sent beforehand.",
    "sentSmsModalTitle": "Sent SMS filter",
    "sentSmsFilterTitle": "Messages with no replies",
    "sentSmsFilterDescription": "Display only the outbound messages with no replies received.",
    "noResults": "There are no matching results",
    "datetime": {
      "rangeLast": "In the last",
      "rangeNotLast": "Not in the last",
      "rangeFrom": "From",
      "rangeTo": "To"
    }
  },
  "sidebarForm": {
    "placeholder": "Add {field}",
    "fields": {
      "username": "Username",
      "fullName": "Full name",
      "phone": "Phone",
      "whatsappPhone": "WhatsApp",
      "fbMessengerSenderId": "Facebook",
      "instagramSenderId": "Instagram",
      "email": "Email",
      "companyName": "Company",
      "listIds": "Lists",
      "segments": "Segments",
      "assigneeId": "Assignee",
      "ownerId": "Contact owner",
      "tagIds": "Tags",
      "status": "Status",
      "statusId": "Status",
      "channel": "Channel",
      "chatTagIds": "Tags",
      "priority": "Priority",
      "carbonCopies": "CCs",
      "dueDate": "Due date",
      "subaccountType": "Role",
      "stage": "Stage"
    },
    "leavePage": "You have unsaved changes. If you continue, your changes will be discarded. Are you sure you want to continue?",
    "contactInfo": "Contact info",
    "customFields": "Custom fields",
    "newCustomField": "New custom field",
    "emptyState": {
      "title": "No search results found",
      "description": "Please try a different keyword"
    }
  },
  "tmSidebarFullNameForm": {
    "youShouldSpecify": "You should specify at least one of \"First name\", \"Last name\", \"Email address\", \"Phone number\", \"WhatsApp number\" fields."
  },
  "filteredView": {
    "viewSaver": {
      "unsavedChanges": "Unsaved changes",
      "discardBtnLabel": "Discard",
      "saveInPlace": "Save changes",
      "saveAsNew": "Save as new view"
    }
  },
  "bulkDelete": {
    "defaultSuccessNotification": "The selected item has been successfully deleted. | The selected items have been successfully deleted.",
    "blockedContacts": {
      "title": "Delete contact | Delete contacts",
      "text": "Selected contact will be deleted permanently. Are you sure you would like to delete it? | All selected contacts will be deleted permanently. Are you sure you would like to delete selected contacts?",
      "successNotification": "The selected contact has been successfully deleted. | The selected contacts have been successfully deleted."
    },
    "sentSmsShort": {
      "title": "Delete outbound message | Delete outbound messages",
      "text": "Are you sure you would like to delete the selected outbound message? This action cannot be undone. | Are you sure you would like to delete the selected outbound messages? This action cannot be undone.",
      "successNotification": "The selected outbound message has been successfully deleted. | The selected outbound messages have been successfully deleted."
    },
    "emailCampaign": {
      "title": "Delete email | Delete emails",
      "text": "Are you sure you would like to delete the selected email? This action cannot be undone. | Are you sure you would like to delete the selected emails? This action cannot be undone.",
      "successNotification": "The selected email has been successfully deleted. | The selected emails have been successfully deleted."
    },
    "receivedSms": {
      "title": "Delete inbound message | Delete inbound messages",
      "text": "Are you sure you would like to delete the selected inbound message? This action cannot be undone. | Are you sure you would like to delete the selected inbound messages? This action cannot be undone.",
      "successNotification": "The selected inbound message has been successfully deleted. | The selected inbound messages have been successfully deleted."
    },
    "contacts": {
      "title": "Delete contact | Delete contacts",
      "text": "Selected contact will be deleted permanently. Are you sure you would like to delete the selected contact? | All selected contacts will be deleted permanently. Are you sure you would like to delete the selected contacts?",
      "successNotification": "The selected contact has been successfully deleted. | The selected contacts have been successfully deleted."
    },
    "contactList": {
      "title": "Delete list | Delete lists",
      "text": "The selected list will be deleted permanently. Are you sure you would like to delete the selected list? | The selected lists will be deleted permanently. Are you sure you would like to delete the selected lists?",
      "successNotification": "The selected list has been successfully deleted. | The selected lists have been successfully deleted."
    },
    "contactImport": {
      "title": "Delete imported file | Delete imported files",
      "text": "Are you sure you would like to delete this file? This action cannot be undone. | Are you sure you would like to delete these files? This action cannot be undone.",
      "successNotification": "The import file has been successfully deleted. | The import files have been successfully deleted"
    },
    "inboundCall": {
      "title": "Delete inbound call | Delete inbound calls",
      "text": "Are you sure you would like to delete the selected inbound call? This action cannot be undone. | Are you sure you would like to delete the selected inbound calls? This action cannot be undone.",
      "successNotification": "The selected inbound call has been successfully deleted. | The selected inbound calls have been successfully deleted."
    },
    "outboundCall": {
      "title": "Delete outbound call | Delete outbound calls",
      "text": "Are you sure you would like to delete the selected outbound call? This action cannot be undone. | Are you sure you would like to delete the selected outbound calls? This action cannot be undone.",
      "successNotification": "The selected outbound call has been successfully deleted. | The selected outbound calls have been successfully deleted."
    },
    "forwardedCall": {
      "title": "Delete forwarded call | Delete forwarded calls",
      "text": "Are you sure you would like to delete the selected forwarded call? This action cannot be undone. | Are you sure you would like to delete the selected forwarded calls? This action cannot be undone.",
      "successNotification": "The selected forwarded calls has been successfully deleted. | The selected forwarded calls have been successfully deleted."
    },
    "userCustomField": {
      "title": "Delete custom field | Delete custom fields",
      "text": "{warning} Any data that was contained in field will be permanently deleted. Are you sure you would like to delete the selected field? | {warning} Any data that was contained in fields will be permanently deleted. Are you sure you would like to delete the selected fields?",
      "successNotification": "The selected custom field has been successfully deleted. | The selected custom fields have been successfully deleted."
    },
    "subAccountsImport": {
      "title": "Delete imported file | Delete imported files",
      "text": "Are you sure you would like to delete this file? This action cannot be undone | Are you sure you would like to delete these files? This action cannot be undone.",
      "successNotification": "The import file has been successfully deleted. | The import files have been successfully deleted."
    },
    "allContacts": {
      "title": "Delete all your contacts",
      "target": "all your contacts",
      "successNotification": "All contacts have been successfully deleted."
    },
    "allMessages": {
      "title": "Delete all your messages",
      "target": "all your messages",
      "successNotification": "All messages have been successfully deleted."
    },
    "ticket": {
      "title": "Delete tickets",
      "text": "You are going to delete {ticketsCount}. This action cannot be undone. Are you sure you would like to continue?"
    },
    "tagAnalytics": {
      "title": "Delete tag | Delete tags",
      "text": "Are you sure you want to delete the selected tag from all entities? This action will not delete any entities associated with it. | Are you sure you want to delete the selected tags from all entities? This action will not delete any entities associated with it.",
      "successNotification": "The selected tag has been successfully deleted. | The selected tags have been successfully deleted."
    },
    "automationFlow": {
      "title": "Delete flow | Delete flows",
      "text": "Selected flow will be deleted permanently. Are you sure you would like to delete the selected flow? | All selected flows will be deleted permanently. Are you sure you would like to delete the selected flows?",
      "successNotification": "The automation flow has been successfully deleted. | The automation flows have been successfully deleted."
    }
  },
  "bulkEditForm": {
    "selectFields": "Select fields to edit",
    "fieldValue": "New field value",
    "action": "Action",
    "valueWillBeCleared": "Value will be cleared",
    "addAnotherField": "Add another field",
    "selectField": "- Select field -",
    "updateN": "Update {count}",
    "operations": {
      "tags": {
        "attach": "Add to existing tags",
        "detach": "Remove these tags",
        "replace": "Replace all tags with",
        "detachAll": "Remove all tags"
      },
      "simpleField": {
        "updateValue": "Update value",
        "clearFieldValue": "Clear field value"
      }
    },
    "tagsPlaceholder": "Enter tag name",
    "tagsRequired": "Select new tags value",
    "companyPlaceholder": "Enter company name",
    "allTagsWillBeRemoved": "All tags will be removed"
  },
  "bulkUpdateModals": {
    "contactTagsBulkModal": {
      "title": "Bulk edit contacts",
      "submitText": "Update {count} contact | Update {count} contacts",
      "successNotification": "We are updating the selected contact. The changes may take a few moments to appear. | We are updating the selected contacts. The changes may take a few moments to appear."
    }
  },
  "header": {
    "admin": "Go to Admin",
    "balance": "Balance",
    "pending": "pending",
    "buyCredit": "Buy credit",
    "subAccountSwitch": "Switch to another sub-account",
    "subAccountSwitchShort": "Switch sub-account",
    "newSms": "New SMS",
    "newChat": "New chat",
    "newContact": "New contact",
    "newList": "New list",
    "newSurvey": "New survey",
    "newTask": "New task",
    "newDeal": "New deal",
    "importContacts": "Import contacts",
    "autoRecharge": "Auto-recharge",
    "invoices": "Invoices",
    "subAccounts": "Sub-accounts",
    "notifications": "Notifications",
    "myData": "My data",
    "myAccount": "My account",
    "billing": "Billing",
    "newTemplate": "New template",
    "newAutomation": "New automation",
    "inviteUsers": "Invite users",
    "inviteSubAccounts": "Invite sub-accounts"
  },
  "headerTakeNextRequest": {
    "label": "Take next live chat",
    "tooltip": "You have {count} waiting live chat in the queue. | You have {count} waiting live chats in the queue.",
    "livechat": "Live chat",
    "nextWaiting": "Next waiting live chat",
    "name": "Name",
    "email": "Email",
    "message": "Message"
  },
  "tmTableFooter": {
    "pageNavigationTextFull": "**{itemsRange}** of **{itemsTotal}** {entity}",
    "pageNavigationTextShort": "**{itemsRange}** / **{itemsTotal}**",
    "rowsPerPage": "Show on page",
    "perPageOption": "{count} rows"
  },
  "tableNoData": {
    "noMatchingResults": "There are no results with the applied filters",
    "refineRequest": "Please try to change your search request or filters"
  },
  "notFound": {
    "header": "Sorry, we can’t find the page you’re looking for.",
    "text": "The link you followed may be broken, or the page may have been removed.",
    "backText": "Go to Home page",
    "entity": "{entity} not found"
  },
  "errorPage": {
    "title": "Sorry, the app has crashed. Please try refreshing.",
    "description": "Apologies, we are experiencing difficulty in loading the app. This may be due to internal errors or temporary network disruptions.",
    "contactUs": "If this error persists, please contact us on {supportEmail}",
    "refreshApp": "Refresh app",
    "buildId": "Build ID"
  },
  "baseFiltersService": {
    "onlyWithoutOutbound": "Without outbound",
    "onlyWithoutInbound": "Without inbound",
    "status": "Status",
    "searchTags": "Search tags",
    "searchChannels": "Search channels"
  },
  "errors": {
    "pleaseTryAgainInAFewMinutesOrRefreshThePageNow": "Please try again in a few minutes or refresh the page now.",
    "itLooksLikeSomethingWentWrong": "It looks like something went wrong",
    "tooManyRequests": "Too many attempts. Please try again later.",
    "userNotFound": "Sorry, we couldn't find an account with that email/username.",
    "default": "Server error",
    "resendEmailTimer": "Re-sending of the email will be available in {seconds} seconds",
    "tryAnotherEmail": "Please, try out another email",
    "verificationCodeNotFound": "Verification code not found.",
    "verificationAttemptsLimit": "You have tried too many times. Please wait, then try again in 60 seconds.",
    "password": {
      "letters": "{count} to 48 characters",
      "numbers": "One number",
      "specialChars": "One special character",
      "lowercaseAndUppercase": "Lower and uppercase",
      "requiresEmailVerification": "Email is already registered, please verify your email and log in"
    },
    "valueIsTooShort": "This value is too short. It should have {minLength} characters or more.",
    "confirmationCode": "The {length}-digit number you entered is incorrect. Please try again.",
    "valueIsTooLarge": "This value is too large. It should have {maxLength} characters or less.",
    "theFieldsMustMatch": "The {fieldName} fields must match.",
    "youAreNotAllowedToPerformThisAction": "You are not allowed to perform this action. Please check your account permissions.",
    "maxLength": "Max length {params0} characters",
    "newPasswordMustDifferent": "New password must be different from the old one.",
    "fieldIsNotValid": "This field is not valid",
    "notEnoughBalanceError": "Sorry, but you do not have enough credit to perform this action. {buyCreditLink} credit to continue.",
    "notEnoughBalanceLink": "Please buy"
  },
  "tableColumns": {
    "cost": "Cost",
    "firstName": "First name",
    "lastName": "Last name",
    "fullName": "Full name",
    "phone": "Phone",
    "createdAt": "Date created",
    "createdBy": "Created by",
    "updatedAt": "Last updated",
    "lastUpdatedAt": "Last updated",
    "lastUpdatedBy": "Last updated by",
    "country": "Country",
    "fieldName": "Field name",
    "name": "Name",
    "status": "Status",
    "from": "From",
    "message": "Message",
    "timeReceived": "Time received",
    "companyName": "Company",
    "category": "Category",
    "content": "Content",
    "lastModified": "Last modified",
    "lastTriggeredAt": "Last triggered at",
    "membersCount": "Contacts",
    "shared": "Type",
    "dateCreated": "Date created",
    "unsubscribeTime": "Date unsubscribed",
    "reason": "Reason",
    "shopifyCustomerId": "Shopify customer ID",
    "platformCustomerId": "{platformName} customer ID",
    "unsubscribeText": "Unsubscribed text",
    "dateBlocked": "Date blocked",
    "to": "To",
    "isAnswered": "",
    "callLength": "Call length",
    "callTime": "Call time",
    "email": "Email",
    "emailForSharing": "Email for sharing",
    "logInButton": "Log in",
    "role": "Role",
    "subaccountType": "Role",
    "invoice": "Invoice",
    "amount": "Amount",
    "paymentMethod": "Payment Method",
    "date": "Date",
    "numberDialed": "Number dialed",
    "forwardedTo": "Forwarded to",
    "forwardedCaller": "Caller",
    "forwardedNumber": "Forwarded to",
    "fromNumber": "From",
    "toNumber": "To",
    "length": "Length",
    "fileName": "File name",
    "imported": "Imported",
    "allowedEmails": "Allowed emails",
    "dateAdded": "Date added",
    "lastSms": "Last SMS",
    "surveyName": "Survey name",
    "recipients": "Recipients",
    "questions": "Questions",
    "replies": "Replies",
    "list": "List",
    "listName": "List name",
    "itemName": "Item name",
    "nextSentDate": "Next sent date",
    "lastSentDate": "Last sent date",
    "type": "Type",
    "isHidden": "Visibility",
    "nextSend": "Next send date",
    "contactName": "To",
    "lastSent": "Last sent date",
    "sendTime": "Send time",
    "lists": "Lists",
    "failedAt": "Attempt date",
    "fileSize": "File size",
    "uploadTime": "Upload time",
    "loginsHistory": {
      "ip": "IP",
      "loginDate": "Login date"
    },
    "action": "Action",
    "debit": "Debit",
    "credit": "Credit",
    "balance": "Balance",
    "description": "Description",
    "account": "Account",
    "user": "User",
    "sender": "Sender",
    "receiver": "Received by",
    "ruleName": "Rule name",
    "executedAt": "Run time",
    "year": "Year",
    "month": "Month",
    "day": "Day",
    "totalCalls": "Total calls",
    "totalTalkTime": "Total talk time",
    "costs": "Costs",
    "clicks": "Clicks",
    "submits": "Submits",
    "embedCode": "Embed code",
    "carrier": "Carrier",
    "textmagicNumber": "Textmagic number",
    "tollFreeNumber": "Toll-free number",
    "linkedToCampaign": "Linked to campaign",
    "campaignName": "Campaign name",
    "campaignId": "Campaign ID",
    "useCase": "Use case",
    "nextRenewal": "Next renewal",
    "responseType": "Auto-responder",
    "created": "Created",
    "brandId": "Brand ID",
    "campaigns": "Campaigns",
    "keywords": "Keywords",
    "tenDlcSelectCampaign": {
      "name": "Campaign name",
      "useCase": "Use case",
      "status": "Status"
    },
    "recipientsCountries": {
      "destination": "Destination",
      "sendFrom": "Send from"
    },
    "label": "Label",
    "provider": "Provider",
    "voice": "Calls",
    "sms": "SMS",
    "mms": "MMS",
    "device": "Device",
    "location": "Location",
    "id": "ID",
    "priority": "Priority",
    "priorityShort": "P",
    "title": "Title",
    "stage": "Stage",
    "assignee": "Assignee",
    "dueDate": "Due date",
    "lastUpdated": "Last updated",
    "whatsappPhone": "WhatsApp",
    "senderId": "Sender ID",
    "ownerId": "Contact owner",
    "tags": "Tags",
    "landingPage": "Landing page",
    "contact": "Contact name",
    "delivered": "Delivered",
    "sendDate": "Send date",
    "source": "Source",
    "openDate": "Open date",
    "unsubscribeDate": "Unsubscribe date",
    "reportDate": "Report date",
    "link": "Link",
    "uniqueClicks": "Unique clicks",
    "clickDate": "Click date",
    "usedAt": "Last used"
  },
  "tmColumnEditor": {
    "columnsLabel": "Columns",
    "cantBeHidden": "Can’t be hidden",
    "hideAll": "Hide all",
    "showAll": "Show all"
  },
  "commonValidationRegistrator": {
    "defaultMessage": "Please enter a valid {field}.",
    "required": "Please enter a valid {field}.",
    "min": "{field} should be at least {params0} characters long.",
    "max": "{field} can consist of maximum {params0} characters.",
    "fullName": {
      "firstName": "Please enter a valid first name.",
      "lastName": "Please enter a valid last name."
    },
    "phoneNumber": "Please enter a valid phone number.",
    "phoneNumberForRegion": "Please enter a valid phone number for selected region.",
    "confirmation": "Password confirmation does not match.",
    "equal": "{Field} should be equal.",
    "noEqual": "{Field} should not match.",
    "hasSomeValid": "{Field} should have at least one valid field.",
    "hasEveryValid": "Every {Field} item should be valid.",
    "hasAtLeastOne": "{Field} should have at least one field.",
    "hasLetters": "At least {count} letter.",
    "hasNumbers": "At least {count} number.",
    "hasSpecialChars": "At least {count} special char.",
    "hasLowercaseAndUppercase": "Must contain lowercase and uppercase.",
    "hasUppercase": "Must contain lowercase and uppercase.",
    "mustBeGreaterOrEqual": "Must be greater than or equal to {count}.",
    "leastCharacters": "Please enter at least {count} characters.",
    "domain": "Please enter a valid domain.",
    "domainOrEmail": "Please enter a valid domain or email.",
    "countryCodeNotEmpty": "Country code could not be empty.",
    "phoneNotValid": "Please enter a valid phone number.",
    "emailNotValid": "Please enter a valid email address.",
    "noMoreThanCharactersLong": "{field} cannot be longer than {count} characters.",
    "cannotBeLonger": "Cannot be longer than {length} characters.",
    "emojiTextRequired": "Please enter a valid text.",
    "hasNoText": "Please enter a valid text.",
    "lessThan": "Must be less than {max}."
  },
  "fileValidationRegistrator": {
    "maxFileSize": "File size should be less than {fileSize}",
    "isImage": "{Field} should be an image",
    "fileAllowed": "File type is not allowed",
    "isTableDocument": "We couldn’t process file of this format. Please use only supported file types.",
    "isMessagesAttachment": "We are unable to process the uploaded file format. Please use a valid file format ({formats})."
  },
  "specialValidationRegistrator": {
    "overlaps": "These values of fields are overlapped with each other: {overlaps}",
    "unique": "Please enter unique values",
    "minCharacters": "At least {number} characters long",
    "fromToCharacters": "{min} to {max} characters",
    "lowerAndUppercase": "Lower and uppercase",
    "oneNumber": "One number",
    "oneSpecialChar": "One special character"
  },
  "composeValidationRegistrator": {
    "hasComposeContent": "Please enter a message.",
    "composeAvailableTags": "One of the tags you have entered is invalid. Please check your message text."
  },
  "dateTimeValidationRegistrator": {
    "isEarlierThan": "\"{dateFrom}\" date must be earlier than \"{dateTo}\" date",
    "rangeFromMustBeEarlierThanTo": "Range end bound must be greater than range start",
    "rangeFromMustBeInPast": "Range start bound must be in the past",
    "rangeBoundsRequired": "Range bounds must be defined"
  },
  "numericValidationRegistrator": {
    "fromValueMaxLength": "'From' field cannot be greater than 'To' field"
  },
  "textValidationRegistrator": {
    "minLength": "Please enter at least {minLength} characters for each word"
  },
  "fieldNames": {
    "fullName": "Full name",
    "companyName": "Company name",
    "ownerId": "Contact owner",
    "password": "Password",
    "passwordConfirmation": "Password confirmation",
    "primaryPhone": "Phone",
    "primaryEmail": "Email",
    "attachNewFile": "Attach new file",
    "addNote": "Add note",
    "username": "Username",
    "oldPassword": "Old password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "selectDate": "Select date",
    "firstName": "First name",
    "lastName": "Last name",
    "timezone": "Timezone",
    "timeFormat": "Time format",
    "phone": "Phone",
    "email": "Email",
    "emailAddress": "Email address",
    "name": "Name",
    "addressLine1": "Address line 1",
    "countryId": "Country",
    "statusId": "Status",
    "unsubscribeLink": "Unsubscribe link",
    "defaultFooter": "Footer text (Company address)"
  },
  "fieldMultipleCountries": {
    "noCountries": "No countries found"
  },
  "fieldTimezone": {
    "label": "(UTC {offset}): {timezoneName}",
    "offset": "(UTC {offset})"
  },
  "fileForm": {
    "replacePhoto": "Replace photo",
    "deletePhoto": "Delete current photo",
    "cropImage": "Crop image",
    "savePhoto": "Save changes"
  },
  "tooltips": {
    "smsRejected": "Message had not been sent because it was rejected by Textmagic.",
    "smsFailed": "Message was not delivered. Possible reasons: phone switched off, out of coverage, incorrect number.",
    "smsDelivered": "Message has been successfully delivered to the recipient.",
    "smsBulkDelivered": "{percent} of SMS in this session were delivered",
    "smsSent": "Message has been sent. Waiting for final delivery confirmation from mobile operator.",
    "errorCode": {
      "facebook_invalid_access_token": "The access token has expired. Please reconnect your page or <a href=\"{supportLink}\" target=\"_blank\">contact support</a> for assistance.",
      "facebook_allowed_time_window_expired": "The Facebook 24-hour session has ended. You can send more messages when the contact sends a new message in the chat.",
      "facebook_user_blocked_messaging": "The contact has blocked this Facebook page and does not wish to receive messages.",
      "facebook_bad_request": "An unexpected error occurred. Please wait for our system to retry or try sending your message again later.",
      "instagram_invalid_access_token": "The access token has expired. Please reconnect your Instagram account or <a href=\"{supportLink}\" target=\"_blank\">contact support</a> for assistance.",
      "instagram_allowed_time_window_expired": "The Instagram 24-hour session has ended. You can send more messages when the contact sends a new message in the chat.",
      "instagram_user_blocked_messaging": "The contact has blocked this Instagram account and does not wish to receive messages.",
      "instagram_bad_request": "An unexpected error occurred. Please wait for our system to retry or try sending your message again later.",
      "instagram_unsupported_attachment": "The attachment type or format is not supported by Instagram. Please try with a different file format or contact <a href=\"{supportLink}\" target=\"_blank\">support</a> for assistance."
    },
    "insertEmoji": "Insert emoji",
    "contact": {
      "list": {
        "menu": "View all your Textmagic lists including the ones that have been shared to you by your sub-accounts.",
        "menuUsersWorkflow": "View workspace contact lists.",
        "newList": "Create new list",
        "newContact": "Add new contact",
        "import": "Import contact",
        "sendSms": "Send message to selected lists",
        "sendEmail": "Send email to selected lists",
        "delete": "Delete item(s) permanently",
        "share": "Share lists with sub-accounts",
        "private": "This list is not visible to your sub-accounts.",
        "sharedByMe": "This list is owned by you and is visible to your sub-accounts.",
        "sharedToMe": "This list is shared to you by one of your sub-accounts."
      },
      "listDetails": {
        "sendSMS": "Send SMS to selected contacts",
        "sendEmail": "Send email to selected contacts",
        "addContacts": "Add new contact(s) to this list",
        "import": "Import contacts",
        "download": "Download contacts",
        "makeListPrivate": "Make this list private",
        "shareThisList": "Share this list with sub-accounts",
        "editListDetails": "Edit list details",
        "deleteList": "Delete list",
        "moveCopy": "Move/Copy selected contacts to other list",
        "removeFromList": "Remove selected contacts from list",
        "delete": "Delete selected contacts"
      },
      "myContacts": {
        "menu": "View all contacts that you have imported to Textmagic online. Contacts from the lists shared by sub-accounts are not shown here.",
        "menuUsersWorkflow": "View workspace contacts.",
        "newContact": "Add new contact",
        "import": "Import contacts",
        "download": "Download contacts",
        "sendSMS": "Send SMS to selected contacts",
        "sendEmail": "Send email to selected contacts",
        "addToList": "Add selected contacts to another list",
        "delete": "Delete selected contacts",
        "settings": "Configure how to display the content"
      },
      "myContactDetails": {
        "newSms": "Send a new message",
        "newSmsBlocked": "This contact is blocked.",
        "viewChat": "View message history",
        "edit": "Edit contact",
        "download": "Download contact",
        "unsubscribe": "Unsubscribe contact",
        "block": "Block contact",
        "unblock": "Unblock contact",
        "delete": "Delete contact"
      },
      "customFields": {
        "menu": "View all your custom fields that can be used as tags for sending personalized SMS.",
        "newCustomField": "Create a new custom field for your contacts",
        "delete": "Delete item(s) permanently"
      },
      "imports": {
        "menu": "View all import sessions that you have created and check the results of the sessions.",
        "newImport": "Import contacts in bulk",
        "delete": "Delete the selected imported files"
      },
      "unsubscribed": {
        "menu": "The list of contacts and numbers that have unsubscribed from your communication.",
        "settings": "Edit unsubscribe settings",
        "import": "Import unsubscribers",
        "download": "Download unsubscribers",
        "manual": "This number has been manually unsubscribed by the workspace user.",
        "blocked": "Number manually unsubscribed (with inbound blocked) by a user.",
        "rule": "Number automatically unsubscribed by a rule.",
        "stop": "STOP request received from this number.",
        "spam": "Too many messages sent during short period.",
        "auto": "Number has been unsubscribed automatically because the message delivery failed.",
        "complaint": "Unsubscribed by Textmagic support due to the complaint received from the subscriber.",
        "automation": "This phone number was unsubscribed by an automation."
      },
      "blockedContacts": {
        "menu": "View all blocked contacts that cannot send you inbound messages.",
        "addNewBlock": "Add blocked number",
        "import": "Import blocked contact",
        "download": "Download blocked contacts",
        "unblock": "Unblock selected contacts",
        "delete": "Delete selected blocked contacts"
      }
    }
  },
  "passwordConfirmationModal": {
    "text": "To delete {which}, please enter {accountPassword}.",
    "accountPassword": "your account password",
    "fieldLabel": "Password",
    "fieldPlaceholder": "Enter password",
    "wrongPassword": "The provided password in not valid."
  },
  "reopenSubAccountConfirmationModal": {
    "title": "Reopen sub-account",
    "text": "Are you sure, you want to reopen this sub-account?",
    "submit": "Reopen sub-account"
  },
  "reopenUserConfirmationModal": {
    "title": "Reopen user account",
    "youAreAboutToReopen": "You are about to reopen {name} user account. Before you proceed, here’s a summary of what will happen next:",
    "options": [
      "The user will regain access to the workspace immediately and receive an email notification about this change.",
      "Your upcoming subscription payment (on {date}) will be increased on a prorated basis to reflect an extra user seat.",
      "Each user seat costs {cost} per month."
    ],
    "pleaseConfirmReopen": "Please confirm that you would like to reopen this account.",
    "submit": "Reopen account",
    "successMessage": "User account has been opened."
  },
  "auth": {
    "authLoader": {
      "title": "Logging you in securely…",
      "longLoadPlaceholder1": "We appreciate your patience.\nStill working on it…",
      "longLoadPlaceholder2": "If this page appears for more than {number} seconds, {click} to reload.",
      "clickHereLink": "click here"
    }
  },
  "TmRowSelected": {
    "selectAll": "Select all",
    "selectAllVisible": "Select all visible items",
    "clearSelection": "clear selection",
    "selectedText": "{selectedCount} out of {total} {entityName} is selected | {selectedCount} out of {total} {entityName} are selected",
    "selectedTextWithoutTotal": "{selectedCount} {entityName} is selected | {selectedCount} {entityName} are selected"
  },
  "partialForm": {
    "fields": {
      "country": "Country",
      "phone": "Phone",
      "email": "Email",
      "lastName": "Last name",
      "firstName": "First name",
      "status": "Status",
      "assignee": "Assigned to",
      "tags": "Tags",
      "timezoneId": "Timezone",
      "primaryContactId": "Primary contact",
      "countryId": "Country",
      "emails": "Emails",
      "phones": "Phones",
      "time": "Time",
      "lists": "Lists",
      "followers": "Followers",
      "subject": "Subject",
      "priority": "Priority",
      "dueDate": "Due date",
      "owner": "Contact owner",
      "companyName": "Company"
    }
  },
  "formatRelative": {
    "lastWeek": "'Last' eeee 'at', h:mm aaa",
    "yesterday": "'Yesterday', h:mm aaa",
    "today": "'Today', h:mm aaa",
    "tomorrow": "'Tomorrow', h:mm aaa",
    "nextWeek": "eeee 'at' h:mm aaa"
  },
  "formatDateRelative": {
    "lastWeek": "'Last' eeee",
    "yesterday": "'Yesterday'",
    "today": "'Today'",
    "tomorrow": "'Tomorrow'",
    "ago": "ago"
  },
  "blockedContactForm": {
    "title": "Add blocked number",
    "phone": "Phone number"
  },
  "blockContactConfirmation": {
    "submitText": "Block",
    "submitLoadingText": "Blocking...",
    "title": "Block contact",
    "successText": "The number has been successfully blocked.",
    "successTextForContact": "The contact has been successfully blocked.",
    "text": "You will no longer be able to exchange messages or calls with {who} once it is blocked."
  },
  "unblockContactConfirmation": {
    "submitText": "Unblock",
    "submitLoadingText": "Unblocking...",
    "title": "Unblock confirmation",
    "successText": "The contact has been successfully unblocked. | The selected contacts have been successfully unblocked.",
    "text": "You will be able to exchange messages with this contact once unblocked."
  },
  "UnsubscribeTableDropdown": {
    "popupMessage": "Your contact can send you an inbound message with these keywords to resubscribe: JOIN, SUBSCRIBE, RESUBSCRIBE, OPT IN, OPT-IN, OPTIN or UNSTOP.",
    "resubscribe": "Resubscribe",
    "blockIncomingMessages": "Block inbound messages",
    "allowIncomingMessages": "Allow inbound messages",
    "toggleBlockToastMessage": "The contact has been successfully updated"
  },
  "unsubscribeEmailTableDropdown": {
    "resubscribe": "Resubscribe",
    "popupMessageForLinkClick": "You cannot manually resubscribe this contact as they unsubscribed via an email link. Contact {support} if this was a mistake.",
    "popupMessageForHardBounce": "You cannot manually resubscribe this contact because the email delivery has failed. Contact {support} if this was a mistake.",
    "popupMessageForSpam": "You cannot manually resubscribe this contact as they have reported spam. Contact {support} if this was a mistake.",
    "popupMessageForUndeliverable": "You cannot manually resubscribe this contact as they have an invalid or undeliverable email address. Contact {support} if this was a mistake.",
    "popupMessageForRoleBased": "You cannot manually resubscribe this contact as they have a role-based email address, not a personal inbox. Contact {support} if this was a mistake.",
    "popupMessageForDisposable": "You cannot manually resubscribe this contact as they have a disposable or temporary email address. Contact {support} if this was a mistake.",
    "popupMessageForUnknownReason": "You cannot manually resubscribe this contact. Contact {support}.",
    "support": "Textmagic support"
  },
  "ResubscribeAction": {
    "text": "Are you sure you want to resubscribe this contact?",
    "successText": "The contact has been successfully resubscribed",
    "title": "Resubscribe contact",
    "submitText": "Resubscribe",
    "submitLoadingText": "Resubscribing..."
  },
  "UnsubscribeAction": {
    "title": "Unsubscribe contact"
  },
  "BlockedContactsTableDropdown": {
    "unblockContact": "Unblock contact"
  },
  "ReceivedSmsTableDropdown": {
    "deleteMessage": "Delete message",
    "viewContact": "View contact"
  },
  "dateTimePickerDropdown": {
    "date": {
      "label": "Due date",
      "placeholder": "Select date"
    },
    "time": {
      "label": "Due time",
      "placeholder": "Select time"
    },
    "remove": "Remove"
  },
  "resubscribeEmailContactModal": {
    "title": "Resubscribe email",
    "text": "Are you sure you want to resubscribe this email {email}? Once resubscribed, you will be able to send emails again.",
    "submitText": "Resubscribe",
    "submitLoadingText": "Resubscribing...",
    "successText": "The email has been successfully resubscribed."
  },
  "unsubscribeEmailContactModal": {
    "title": "Unsubscribe email",
    "text": "Are you sure you want to unsubscribe this email {email}? Once unsubscribed, you will not be able to send emails to this contact.",
    "submitText": "Unsubscribe",
    "submitLoadingText": "Unsubscribing...",
    "successText": "The email has been successfully unsubscribed."
  },
  "listDeleteModal": {
    "title": "Delete list",
    "text": "{listName} will be deleted permanently. Are you sure you would like to delete it?",
    "checkboxText": "Also permanently delete all contacts contained in this list | Also permanently delete all contacts contained in these lists"
  },
  "receivedSmsDeleteModal": {
    "title": "Delete inbound message",
    "text": "Are you sure you would like to delete selected inbound message? This action cannot be undone.",
    "successText": "The inbound message has been successfully deleted."
  },
  "sentSmsDeleteModal": {
    "title": "Delete outbound message",
    "text": "Are you sure you would like to delete the selected outbound message? This action cannot be undone.",
    "successText": "The outbound message has been successfully deleted."
  },
  "bulkSentSmsDeleteModal": {
    "title": "Delete outbound message session",
    "text": "Are you sure you would like to delete the selected outbound messages session? This action cannot be undone.",
    "successText": "The sent SMS session and messages have been successfully deleted."
  },
  "sentSmsEmptyState": {
    "title": "You don’t have any outbound text messages yet",
    "description": "Use Compose or Chat to send your first SMS."
  },
  "SentSmsTableDropdown": {
    "viewContact": "View contact",
    "deleteMessage": "Delete message"
  },
  "sentSmsBulkTableDropdown": {
    "deleteSession": "Delete session"
  },
  "sentSmsFilterBar": {
    "fields": {
      "withReply": {
        "label": "Messages"
      },
      "messageTime": {
        "label": "Send date"
      },
      "labels": {
        "label": "Label"
      },
      "recipients": {
        "label": "Recipients",
        "options": {
          "general": "{count} recipient | {count} recipients",
          "gt": "More than",
          "lt": "Less than",
          "between": "Between"
        }
      },
      "sentBy": {
        "label": "Sent by"
      },
      "sendFrom": {
        "label": "Sent from",
        "searchPlaceholder": "Search sender numbers",
        "notInActiveNumbers": "No active numbers could be found. You can still filter by exact match:",
        "exactMatch": "Exact match",
        "fromLabel": "From: “**{query}**”"
      },
      "source": {
        "label": "Source",
        "placeholder": "Search source",
        "options": {
          "webApp": "Web app",
          "api": "API",
          "smsChat": "SMS chat",
          "iosApp": "iOS app",
          "androidApp": "Android app",
          "desktop": "Textmagic desktop",
          "emailToSms": "Email to SMS",
          "distributionList": "Distribution list",
          "widget": "Widget",
          "automationRules": "Automation rules",
          "automationFlow": "Automation flow",
          "smsSurvey": "SMS survey",
          "mcp": "MCP"
        }
      },
      "status": {
        "label": "Status"
      }
    }
  },
  "sentSmsTableWithReplyFilter": {
    "all": "All",
    "withReply": "With reply",
    "withoutReply": "Without reply"
  },
  "receivedSmsEmptyState": {
    "title": "You have not received any messages yet",
    "description": "To receive some inbound messages, first send some messages to your contacts."
  },
  "contactImportEmptyState": {
    "title": "Import your contacts to Textmagic",
    "description": "Supported file types for import are Excel (.xls or .xlsx) and CSV (.csv).",
    "button": "Import contacts"
  },
  "contactImportDeleteModal": {
    "title": "Delete imported file",
    "text": "Are you sure you would like to delete this imported file? This action cannot be undone.",
    "successText": "The imported file has been successfully deleted."
  },
  "userCustomFieldDeleteModal": {
    "title": "Delete custom field",
    "text": "{warning} Any data that was contained in this ({customField}) field will be permanently deleted. Are you sure you would like to delete selected field?",
    "warning": "Please note!",
    "successText": "The custom field has been successfully deleted."
  },
  "userCustomFieldEmptyState": {
    "title": "Add custom fields and use them as mail merge tags",
    "description": "Custom fields allow you to save more data for your contacts and use them as mail merge tags when sending text messages.",
    "button": "Add new field"
  },
  "subAccountsImportService": {
    "status": {
      "inProgress": "In progress",
      "completed": "Completed"
    }
  },
  "subAccountImportDeleteModal": {
    "title": "Delete imported file",
    "text": "Are you sure you would like to delete this imported file? This action cannot be undone.",
    "successNotification": "The import file has been successfully deleted"
  },
  "subAccountsImportDetails": {
    "tabs": {
      "invited": "Invited",
      "duplicated": "Duplicates excluded",
      "failed": "Failed to invite"
    },
    "tableStatuses": {
      "invited": "invited",
      "duplicated": "excluded",
      "failed": "failed to invite"
    },
    "cellActions": {
      "editAndInvite": "Edit and invite"
    }
  },
  "subAccountsImportDetailsEmptyState": {
    "invited": {
      "title": "No sub-accounts have been invited in this session",
      "description": "Please check the \"Failed to import\" tab to fix possible validation errors."
    },
    "duplicated": {
      "title": "This session had no excluded duplicates",
      "description": "There is nothing to fix, everything is alright here."
    },
    "failed": {
      "title": "This session had no failed rows",
      "description": "There is nothing to fix, everything is alright here."
    }
  },
  "subAccountsImportDetailsTopbar": {
    "buttons": {
      "newImport": "New import"
    }
  },
  "cancelReasons": {
    "selectReason": "Select a reason",
    "notNeedService": "I don't need the service anymore",
    "hasIssuesWithPlatform": "I had issues with the platform",
    "pricingTooHigh": "The pricing is too high",
    "foundBetterAlternative": "I found a better alternative",
    "other": "Other"
  },
  "closeAccountModal": {
    "title": "Closing your Textmagic account?",
    "description": "We're very sorry to see you leave. Please let us know why you're closing your account. Your feedback helps us improve.",
    "customerSupport": "Customer support",
    "permanentDeletionMessage": "I understand that {which} owned by this account will be permanently deleted and cannot be restored.",
    "deletion": {
      "contacts": "contacts",
      "messages": "outbound and inbound messages"
    },
    "reasonField": {
      "label": "Please tell us why you're leaving"
    },
    "descriptionField": {
      "hasIssuesWithPlatform": {
        "label": "Shortly describe the issues you had",
        "placeholder": "It will help us get better in the future"
      },
      "foundBetterAlternative": {
        "label": "What alternative did you switch to?",
        "placeholder": "List the competitor name"
      },
      "other": {
        "label": "Shortly describe your reason",
        "placeholder": "Please explain why you decided to leave"
      }
    },
    "loadingText": "Closing...",
    "submitButton": "Close account"
  },
  "closeSubAccountModal": {
    "title": "Close sub-account",
    "description": "Are you sure you want to close this sub-account?",
    "permanentDeletionMessage": "I understand that the {which} data will be deleted permanently.",
    "deletion": {
      "contacts": "contacts and messaging",
      "numbers": "all virtual numbers"
    },
    "successMessage": "Sub-account has been closed.",
    "loadingText": "Closing...",
    "submitButton": "Close sub-account"
  },
  "usersCloseAccountModal": {
    "title": "Close user account",
    "successMessage": "Account has been closed.",
    "aboutToDeactivate": "You are about to deactivate {name} user account? Before you proceed, here’s a summary of what will happen next:",
    "options": [
      "The user will lose access to the workspace immediately.",
      "Your upcoming subscription payment (on {date}) will be reduced to reflect the removal of this user seat.",
      "Any remaining days from this seat's current subscription period will be calculated on a prorated basis and credited back to you."
    ],
    "confirm": "Please confirm that you would like to close this account.",
    "loadingText": "Closing...",
    "submitButton": "Close account"
  },
  "templatesIndexTopBar": {
    "share": "Share"
  },
  "templateFormName": {
    "label": "Template name",
    "placeholder": "Enter template name",
    "formErrors": {
      "required": "Please enter a valid template name.",
      "maxLength": "Template name cannot be longer than 50 plain text characters."
    }
  },
  "templateFormGenerateBtn": {
    "text": "Copy to {content} text",
    "plain": "plain",
    "rich": "rich"
  },
  "templateFormContent": {
    "label": "Message",
    "placeholder": "Enter template text",
    "hint": {
      "characters": "Characters",
      "parts": "Parts"
    },
    "tabs": {
      "content": {
        "tabText": "SMS",
        "tabSubtext": "(Plain text)"
      },
      "emailContent": {
        "tabText": "Ticket",
        "tabSubtext": "(Rich text)"
      }
    },
    "formErrors": {
      "required": "Please enter a message for your template.",
      "maxLength": "Your message contains too many characters. Please make your message text shorter.",
      "categoryId": "Please enter a category for your template",
      "textHaveBeenTrimmed": "Please note that the plain text version has been cut to { number } characters."
    }
  },
  "templateFormCategory": {
    "label": "Category",
    "placeholder": "Select category",
    "newCategory": "New category"
  },
  "ContactListForm": {
    "nameLabel": "List name",
    "namePlaceholder": "Enter the list name",
    "isPrivateLabel": "Make this list private. Contacts will not be shared with sub-accounts.",
    "isDefaultLabel": "Make this list default for new contacts.",
    "editTitle": "Edit list",
    "addTitle": "Create new list",
    "fields": {
      "listNameRequired": "Please enter a valid List name."
    },
    "createList": "Create list"
  },
  "fieldTableColumns": {
    "addColumnLabel": "Add column",
    "lastColumnDeleteTooltip": "At least one column must be selected"
  },
  "buyNumber": {
    "number": "Number",
    "callForwarding": "Call forwarding"
  },
  "senderSettings": {
    "buyNumber": {
      "callForwarding": "Call forwarding"
    }
  },
  "buyNumberStep1": {
    "chooseMobileNumber": "Choose your Textmagic mobile number",
    "getNumberForTextMessaging": "Get your SMS number for text messaging with your customers, staff and partners.",
    "numberFeatures": {
      "sms": "Two-way SMS",
      "mms": "MMS",
      "voice": "Calls",
      "smsMms": "Two-way SMS, MMS"
    },
    "gettingStarted": "Getting started",
    "confirmationButtonTitle": "Activate number"
  },
  "buyNumberBaseFormService": {
    "errors": {
      "useCase": {
        "required": "Please enter your use case description.",
        "minLength": "Use case description has to be at least {minCharacters} characters long.",
        "maxLength": "This value is too long. It should have {maxCharacters} characters or less."
      }
    }
  },
  "buyNumberUsSenderTenDlcList": {
    "tollFree": {
      "options": [
        "(8XX) numbers for messaging in the U.S. and Canada",
        "Business details, EIN / Tax ID required (except for sole proprietors)",
        "Privacy Policy, SMS Terms, and opt-in details required",
        {
          "start": "Toll-free verification:",
          "end": "Free"
        },
        {
          "start": "Number cost:",
          "end": "per month",
          "includedInPlan": "Free (included in your plan)"
        },
        "Traffic verified with the SMS aggregator",
        {
          "start": "Typical review time:",
          "end": "3-5 business days"
        },
        "2-way SMS, MMS and voice supported",
        "Minimum initial credit required: {price}",
        {
          "start": "1 month free,",
          "end": " {price} per month"
        }
      ]
    },
    "tenDlc": {
      "options": [
        "Local area code U.S. numbers for sending texts",
        "Business details, EIN / Tax ID required",
        "Privacy Policy, SMS Terms, and opt-in details required",
        {
          "start": "Brand registration + vetting:",
          "end": "Free"
        },
        {
          "start": "Campaign registration:",
          "end": " per month",
          "prefix": "1 month free",
          "suffix": ", then "
        },
        {
          "start": "Number cost:",
          "end": "per month",
          "includedInPlan": "Free (included in your plan)"
        },
        "Traffic whitelisted with the mobile operators via TCR",
        {
          "start": "Typical review time:",
          "end": "{from}-{end} business days"
        },
        "2-way SMS, MMS and voice supported",
        "Minimum initial credit required: {price}",
        {
          "start": "1 month free,",
          "end": " {price} per month"
        }
      ]
    }
  },
  "buyNumberAllowedForBuy": {
    "numberType": "Number type",
    "chooseNumber": "Choose number",
    "yourBusinessUseCase": "Your business use case",
    "assignToAccount": "Assign to account",
    "theNumberOnlyAvailableToThisAccount": "Important! The number will only be available to this account.",
    "perMonth": "{price} per month",
    "perMonthDescription": "We will deduct this amount from your account balance each month. If your account balance becomes too low to renew the dedicated number, we leave right to cancel it permanently. You can cancel this number at any time.",
    "perMonthDescriptionForPlan": "One virtual number is included in your Professional plan. If you buy more numbers you will be billed extra for each virtual number according to the Textmagic services pricing.",
    "requiredRegisterFor10DLC": "Please note: You will be required to register for 10DLC if you plan to use local U.S. numbers for sending text messages",
    "readAbout10DLC": "Read more about 10DLC and related costs",
    "tollFreeNumber": "Toll-free number",
    "localNumber": "Local number",
    "local10DLCNumber": "Local 10DLC number",
    "localDescriptions": {
      "areaCodesAvailable": "All area codes available",
      "suitableTwoWayCommunication": "Suitable for two-way communication",
      "maxLengthMessage": "Max length 918 characters / message",
      "maxSendingSpeed": "Max sending speed 1 SMS / sec",
      "maxMessagesDay": "Max 500 messages a day"
    },
    "monthFree": "1 month free,",
    "payAfter": " then {price} per month",
    "includedInPlan": "Free (included in your plan)",
    "useCase": {
      "label": "Your business use case",
      "placeholder": "Describe your use case",
      "hint": "Explain how you intend to use this number. Max {maxCharacters} characters."
    }
  },
  "buyNumberCountryOnlyByRequestAlert": {
    "dueToLocalCarrierRequirementsPleaseContact": "Due to local carrier requirements, please contact {link} to apply for a number in this location.",
    "textMagicSupport": "Textmagic support"
  },
  "buyNumberLocalNumberFields": {
    "areaCode": "Area code",
    "availableNumber": "Available number"
  },
  "buyNumberNotAvailableAlert": {
    "weDonHaveAnyMoreNumbersAvailableForThisArea": "Sorry, but we don't have any more numbers available for this area. We will add more shortly but in the meantime why not try choosing a different area."
  },
  "buyNumberConnectByocAlert": {
    "text": "Connect your {twilio} or {vonage} numbers and send/receive messages within Textmagic."
  },
  "buyNumberCallForwarding": {
    "skipThisStep": "Skip this step"
  },
  "callForwarding": {
    "title": "Set up call forwarding and greeting",
    "subTitle": "Choose how to handle incoming calls to your number.",
    "form": {
      "number": "{provider} number",
      "your": "Your",
      "forwardCallsTo": "Forward calls to",
      "enterYourNumber": "Enter your mobile or landline number",
      "costPerMinute": "{cost} / minute{example}",
      "costPerMinuteExample": "(for example {minutes} minutes = {cost})",
      "inboundCallsPrices": "Inbound calls prices may vary based on the caller origin country.",
      "forwardCallsOptions": {
        "off": "Calls won’t be forwarded. A greeting can be played and the call will hang up.",
        "chat": "Incoming calls will ring in your Textmagic web app (Messenger).",
        "phone": "Forward incoming calls to a your phone number."
      }
    }
  },
  "callForwardingFormBuilderService": {
    "forwardCallsToValues": {
      "off": "Disabled",
      "chat": "Textmagic Messenger",
      "phone": "Your number"
    },
    "messenger": "Messenger",
    "pleaseEnterValidNumber": "Please enter a valid number."
  },
  "callForwardingFormLineGreeting": {
    "greeting": "Greeting",
    "addGreeting": "Add greeting",
    "hint": "Your customer will hear this recording while calling your {provider} number.",
    "hintFileTypes": "Supported file types: .wav or .mp3.",
    "chooseAudioModal": {
      "title": "Your audio recordings",
      "uploadBtnLabel": "Upload a new sound",
      "confirmButton": "Use recording"
    },
    "editGreeting": "Edit greeting",
    "disableGreeting": "Disable greeting"
  },
  "audioTableEmpty": {
    "title": "No custom sounds uploaded yet",
    "description": "Your uploaded audio files will appear here. Add your custom sounds to personalize your notifications or messages.",
    "button": "Upload a new sound"
  },
  "buyNumberWorkConstraintsAlert": {
    "numbersNotWorkForSmsVerificationOrLoginPurposes": "Textmagic numbers will NOT work for SMS verification or login purposes (bank accounts, social media accounts etc.). You can only receive text messages from your customers and staff using their mobile phones.",
    "learnMore": "Learn more."
  },
  "buyNumberSuccess": {
    "title": "Your dedicated number is now ready for use",
    "subTitle": "This is your number for text messaging with your customers, staff and partners.",
    "table": {
      "account": "Account",
      "dedicatedNumber": "Dedicated number",
      "inboundCallsWillBeForwardedTo": "Inbound calls will be forwarded to",
      "forwardAudio": "Greeting file",
      "forwardingPrice": "Forwarding price",
      "numberPrice": "Number price",
      "renewalDate": "Renewal date",
      "yourNumber": "Your number({number})",
      "SmsChat": "SMS Chat",
      "forwardingPriceInfo": "{currency}{price} / minute ({country})",
      "numberPriceInfo": "{price} / month (will be deducted from account balance)"
    }
  },
  "tmPreviewPhone": {
    "form": {
      "inputPlaceholder": "Type your reply",
      "sendButton": "@:common.send"
    }
  },
  "customFieldForm": {
    "label": "Custom field name",
    "placeholder": "Enter name",
    "charactersHint": "Maximum 50 plain text characters",
    "maxLengthError": "Your custom field contains too many characters. Please make your custom field text shorter.",
    "requiredError": "Please enter a valid custom field name."
  },
  "customFieldModalCreate": {
    "title": "New custom field",
    "success": "The custom field has been successfully created."
  },
  "customFieldModalUpdate": {
    "title": "Edit custom field",
    "success": "The custom field has been successfully updated."
  },
  "tmNumberLabelModal": {
    "editTitle": "Edit number label",
    "createTitle": "New number label",
    "field": {
      "number": {
        "label": "Number"
      },
      "label": {
        "label": "Label",
        "placeholder": "Enter number label"
      }
    }
  },
  "numberLabelFormService": {
    "errors": {
      "label": {
        "max": "Max label length is 30 symbols."
      }
    }
  },
  "myContactsEmptyState": {
    "title": "Import your contacts to Textmagic",
    "description": "Supported file types for import are Excel (.xls or .xlsx) and CSV (.csv).",
    "button": "Add contact",
    "importButton": "Import contacts"
  },
  "inboundCallsEmptyState": {
    "title": "You have no inbound calls",
    "description": "Receive calls to your virtual numbers using SMS chat and respond to your contacts faster.",
    "button": "View SMS chat"
  },
  "inboundCallsModalsDelete": {
    "title": "Delete inbound call",
    "text": "Are you sure you would like to delete selected inbound call? This action cannot be undone."
  },
  "outboundCallsEmptyState": {
    "title": "You have no outbound calls",
    "description": "Receive calls to your virtual numbers using SMS chat and respond to your contacts faster.",
    "button": "View SMS chat"
  },
  "outboundCallsModalsDelete": {
    "title": "Delete outbound call",
    "text": "Are you sure you would like to delete selected outbound call? This action cannot be undone."
  },
  "forwardedCallsEmptyState": {
    "title": "You have no forwarded calls",
    "description": "Set up call forwarding and forward incoming calls from your virtual numbers to any phone number.",
    "button": "View my numbers"
  },
  "forwardedCallsModalsDelete": {
    "title": "Delete forwarded call",
    "text": "Are you sure you would like to delete selected forwarded call? This action cannot be undone."
  },
  "exportModal": {
    "title": "Send the download link to an email",
    "description": "Export of data can take some time. Please enter email address, and we will send a download link as soon as possible.",
    "emailLabel": "Email address",
    "emailPlaceholder": "Enter email address",
    "emailErrorRequired": "Please enter a valid email address.",
    "success": "Your data is now being prepared for download. We will send a download link to your email address as soon as possible.",
    "selectFileFormat": "Select file format"
  },
  "ContactListDetailsTopbar": {
    "search": "Search contacts",
    "sendSMS": "Send SMS",
    "addContacts": "Add contacts",
    "moveCopy": "Move/Copy",
    "removeFromList": "Remove from list",
    "editListDetails": "Edit list details",
    "pinList": "Pin list",
    "unpinList": "Unpin list"
  },
  "myContactsTableDropdown": {
    "editContact": "Edit contact",
    "blockContact": "Block contact",
    "unsubsribe": "Unsubscribe contact",
    "pinContact": "Pin contact",
    "unpinContact": "Unpin contact"
  },
  "ContactListDetailsDropdown": {
    "editContact": "Edit contact",
    "blockContact": "Block",
    "unsubsribe": "Unsubscribe",
    "removeFromTheList": "Remove from list",
    "pin": "Pin contact",
    "unpin": "Unpin contact"
  },
  "subAccountsEmptyState": {
    "title": "Add sub-accounts for your team members",
    "description": "Equip your entire company with Textmagic by giving employees sub-accounts and sharing your existing credit balance with them.",
    "button": "Invite sub-accounts"
  },
  "usersWorkflowActiveEmptyState": {
    "title": "Invite users for a better teamwork ",
    "description": "Invite team members to collaborate in one shared workspace. Enjoy access to shared messaging channels, messaging data, and contacts, all under a unified billing account for seamless communication.",
    "button": "Invite users"
  },
  "subAccountsTableTopBar": {
    "invite": "Invite sub-accounts",
    "import": "Import"
  },
  "subAccountsLoginCell": {
    "logInAsUser": "Log in as user"
  },
  "bulkSentSmsTabs": {
    "overview": "Overview",
    "delivered": "Delivered",
    "sent": "Sent",
    "failed": "Failed",
    "rejected": "Rejected"
  },
  "sentSmsBulkDetailsInfoLoading": {
    "title": "Loading campaign information...",
    "description": "Please wait while we are loading your information."
  },
  "receivedSmsDetailsInfoLoading": {
    "title": "Loading message information...",
    "description": "Please wait while we are loading your information."
  },
  "sentSmsDetailsInfoLoading": {
    "title": "Loading message information...",
    "description": "Please wait while we are loading your information."
  },
  "scheduledDetailsInfoLoading": {
    "title": "Loading message information...",
    "description": "Please wait while we are loading your information."
  },
  "scheduledEmailDetailsInfoLoading": {
    "title": "Loading campaign information...",
    "description": "Please wait while we are loading your information."
  },
  "callDetailsInfoLoading": {
    "title": "Loading call information...",
    "description": "Please wait while we are loading your information."
  },
  "sentSmsBulkDetailsOverviewContent": {
    "deliverySection": {
      "title": "Delivery",
      "successfullyDeliveredDescription": "{delivered} SMS were successfully delivered, with {rejected} rejected and {failed} failed.",
      "yourEmailHasntReachedDescription": "Your SMS hasn't reached any recipients yet. Please allow some additional time for delivery."
    },
    "bulkSentSmsStatusTooltip": {
      "delivered": "Total number of text messages delivered.",
      "sent": "Total number of text messages awaiting final delivery confirmation from the mobile operator.",
      "failed": "Total number of text messages that could not be delivered due to issues such as the phone being switched off, out of coverage, or the number being incorrect.",
      "rejected": "Total number of text messages not sent due to unsubscribes or compliance issues."
    },
    "details": {
      "title": "Details",
      "subtitle": "An overview of the SMS broadcast details, message and costs."
    }
  },
  "sentSmsBulkDetailsInfo": {
    "from": "From",
    "to": "Sent to",
    "destinationCountry": "Destination country | Destination countries",
    "recipients": "Recipient|Recipients",
    "country": "{quantity} country | {quantity} countries",
    "countries": "Country | Countries",
    "sendDate": "Send date",
    "totalCost": "Total cost",
    "author": "Created by",
    "charactersCount": "Characters count",
    "characters": "Characters",
    "messagePartsCount": "Message parts count",
    "messageParts": "Message parts",
    "source": "Source",
    "id": "ID",
    "emailSource": {
      "title": "Email source",
      "senderIp": "Sender IP",
      "fromAddress": "From address",
      "sourceEmail": "Source email",
      "originalEmailNotAvailable": "Original email is not available for this message"
    }
  },
  "sentSmsBulkDetailsPreview": {
    "title": "Message preview",
    "sentMessage": "Sent message"
  },
  "subAccountsTableDropdown": {
    "logIn": "Log in as this account",
    "passwordReset": "Reset password",
    "passwordResetSuccessMessage": "A password reset link has been successfully sent.",
    "edit": "Edit sub-account",
    "close": "Close sub-account",
    "reopen": "Reopen sub-account",
    "resend": "Resend invitation"
  },
  "usersWorkflowTableDropdown": {
    "passwordReset": "Reset password",
    "passwordResetSuccessMessage": "A password reset link has been successfully sent.",
    "edit": "Edit user",
    "close": "Close user account",
    "reopen": "Reopen user",
    "setOffline": "Set offline",
    "setOfflineSuccessMessage": "The user's status has been successfully updated."
  },
  "usersWorkflowTableInvitedDropdown": {
    "resend": "Resend invitation",
    "deleteInvite": "Delete invite"
  },
  "removeContactFromTheListAction": {
    "title": "Remove contact from list",
    "text": "{fullName} {phone} will be removed from this list.\n\n Are you sure you would like to remove it?",
    "submitText": "Remove contact",
    "successText": "The selected contact has been successfully removed from this list."
  },
  "bulkRemoveContactFromTheListAction": {
    "submitText": "Remove contacts",
    "title": "Remove contacts from list"
  },
  "bulkRemoveFromListText": {
    "text": "Are you sure you would like to remove the selected contacts from this list?"
  },
  "UnsubsribeContactModal": {
    "blockIncomingText": "Also block inbound messages from this number.",
    "unsubscribe": "Unsubscribe",
    "unsubscribing": "Unsubscribing",
    "modalTitle": "Unsubscribe contact",
    "successText": "The contact has been successfully unsubscribed",
    "text": " will be permanently removed from your lists. All future messages to this number will be rejected by Textmagic. This applies to all your sub-accounts too."
  },
  "unsubscribeContactWithEmailModal": {
    "title": "Unsubscribe contact",
    "text": "You are about to unsubscribe {contact} from receiving messages. Select the communication channels you want to unsubscribe.",
    "blockIncomingText": "Block incoming SMS from this number",
    "emailAlreadyUnsubscribed": "This email has already been unsubscribed.",
    "unsubscribe": "Unsubscribe",
    "unsubscribing": "Unsubscribing",
    "successText": "The contact has been successfully unsubscribed"
  },
  "unsubscribeContactWithEmailModalCheckbox": {
    "willBeUnsubscribed": "Will be unsubscribed"
  },
  "invoicesEmptyState": {
    "title": "You have no invoices yet",
    "description": "After you buy credit, your invoices will be displayed here.",
    "button": "Buy credits"
  },
  "invoicesTableDropdown": {
    "forwardViaEmail": "Forward via email"
  },
  "contactDeleteModal": {
    "title": "Delete contact",
    "text": [
      "{who} will be deleted permanently.",
      "Currently, this contact is the requester in {tickets}. All tickets associated with this contact will be marked as {closed}. This action cannot be undone.",
      "Are you sure you would like to delete it?"
    ],
    "tickets": "ticket | tickets",
    "closed": "Closed"
  },
  "contactsChangeEmailConfirmation": {
    "title": "Change contact email",
    "text": [
      "You are about to change {name} email.",
      "Currently, this contact is the requester in {tickets}. All tickets associated with this contact will be marked as {closed}. This action cannot be undone.",
      "Are you sure you would like to change the email?"
    ],
    "tickets": "ticket | tickets",
    "closed": "Closed"
  },
  "BulkShareContactListConfirmation": {
    "submitText": "Share list",
    "submitLoadingText": "Sharing...",
    "successTextPlural": "The lists have been successfully updated.",
    "successTextSingular": "The list has been successfully updated.",
    "text": "After sharing the selected lists, your sub-accounts will be able to view, edit and delete the contacts in these lists. Are you sure you want to continue?"
  },
  "MakeListPrivateConfirmation": {
    "submitText": "Make private",
    "title": "Make list private",
    "successText": "Selected list has been successfully made private",
    "text": "After making the selected list private, your sub-accounts will not be able to view, edit and delete the contacts in this list. Are you sure you want to continue?"
  },
  "senderSettingsCancelPhoneNumberConfirm": {
    "title": "Cancel number renewal",
    "text": "Are you sure you want to cancel the subscription for the dedicated number {phone}? You will still be able to use this number until {date}. After that, the number will expire.",
    "cancel": "Keep number",
    "submit": "Cancel number",
    "cancelSuccess": "The selected number has been successfully canceled.",
    "successMessage": "The selected number subscription has been successfully scheduled to expire."
  },
  "CancelPhoneTollFreeNumberConfirmation": {
    "title": "Cancel toll-free number",
    "text": "Are you sure you want to cancel the toll-free number {phone}?",
    "cancelButtonText": "Keep number",
    "submitButtonText": "Cancel number"
  },
  "contactDetails": {
    "blocked": "blocked",
    "unsubscribe": "Unsubscribe",
    "sharedBy": "Shared by {fullName}"
  },
  "composeHeader": {
    "sms": "SMS",
    "email": "Email"
  },
  "compose": {
    "subtitles": {
      "draft": "Draft saved {time} ago",
      "justNowDraft": "Draft saved just now",
      "emptyDraft": "Any changes will be saved as draft"
    },
    "clearDraftModal": {
      "title": "Clear draft changes",
      "content": "You are about to clear all text message draft changes. This action cannot be undone. Are you sure you would like to continue?",
      "confirmationButton": "Clear all changes"
    }
  },
  "composeToggleTooltip": {
    "title": "Switch channels",
    "text": "Send your message by SMS or Email. Use the toggle to switch anytime."
  },
  "composeMessage": {
    "title": "Compose a text message",
    "to": "To",
    "scheduleMessage": "Schedule message",
    "previewMessage": "Preview message",
    "previewAndSendMessage": "Preview & send",
    "previewAndScheduleMessage": "Preview & schedule",
    "sendNow": "Send now",
    "previewInCalendar": "Preview in calendar",
    "cancel": "Cancel schedule",
    "from": "From",
    "fromPlaceholder": "Start typing a number or contact name",
    "message": "Message",
    "messagePartsTooltip": "Your message includes {parts} parts now.",
    "schedule": "Schedule",
    "successSend": "Your message has been successfully sent to {count} recipient. | Your message has been successfully sent to {count} recipients",
    "attachFileInfo": "You can upload files that are up to 10 MB in size.___A clickable hyperlink will be included in your SMS where recipients can view / download your file.___Attachments will be stored on Textmagic's servers.",
    "attachMmsFileInfo": "You can send images via MMS that are up to 3.5 MB and other files up to 525 KB in size.___A multimedia message (MMS) will be sent to your recipient's phone including the attached file.___Attachments will be stored on Textmagic's servers.",
    "buyCredit": "Buy credit",
    "notFoundValidRecipients": "One or more of the recipients' numbers are invalid. Please remove invalid phone numbers and try again.",
    "senderEmpty": {
      "title": "Get started with SMS broadcasts",
      "text": "Send text messages to your customers. Share promos, alerts, or reminders and handle replies with your team.",
      "thousands": "Send SMS to thousands in seconds",
      "schedule": "Schedule one-time or recurring messages",
      "replies": "Manage replies with your team",
      "getNumber": "Get a Textmagic number",
      "bringNumber": "Bring your own number",
      "subtext": "To start sending SMS, get a Textmagic number or connect your own from Twilio, Vonage, Sinch, or Bandwidth.",
      "subtextGBorAU": "To start sending SMS, get a Textmagic number, a Sender ID or {connectYourOwnNumber} from Twilio, Vonage, Sinch, or Bandwidth.",
      "connectYourOwn": "connect your own number",
      "applyForSenderId": "Apply for a Sender ID"
    },
    "senderIsNotRegistered": "The selected 'From' number is not registered. You cannot send messages until your brand and campaign registration is approved by the network operators.",
    "automationPromotion": {
      "convertSms": "Convert this message",
      "convertEmail": "Convert this email",
      "promotionCta": "{convert} into an automation flow to add more actions, rules, and conditions.",
      "createAutomation": "Create automation"
    }
  },
  "composeScheduleSection": {
    "firstSendDate": "First send date",
    "hourFormat": "24-hour format",
    "timezone": "Timezone",
    "timezoneDescription": "Please note that Textmagic automatically considers daylight saving time (DST) changes."
  },
  "composeScheduleRepeatTypes": {
    "none": "Doesn’t repeat",
    "hourly": "Hourly",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "yearly": "Yearly"
  },
  "composeEndTypes": {
    "never": "Never",
    "after": "After",
    "date": "On date"
  },
  "composeOrdinalDays": {
    "first": "First",
    "second": "Second",
    "third": "Third",
    "fourth": "Fourth",
    "last": "Last"
  },
  "composeEmailStepSubjectForm": {
    "character": "{count} character | {count} characters"
  },
  "messagesSendForm": {
    "recipientsPlaceholder": "Start typing a number, contact, list, or segment name",
    "recipientsPlaceholderShort": "Type a number, contact, list, or segment",
    "recipientsErrorRequired": "Please enter at least one recipient.",
    "recipientsErrorInvalidNumber": "Please enter a valid mobile phone number.",
    "recipientsErrorInvalidEmail": "Please enter a valid email.",
    "messagePlaceholder": "Type your message"
  },
  "composeCharactersHint": {
    "unicode": "Unicode characters:",
    "common": "Characters:"
  },
  "composePartsHint": {
    "label": "Parts:"
  },
  "messagesSendFormWarnings": {
    "pleaseNote": "Please note:",
    "balanceLow": "You need to buy credit to send this message. Suitable credit amount: {amount}.",
    "canadianNumber": "We cannot guarantee successful delivery of marketing messages, alerts, and notifications to Canadian numbers because this content should originate from a short code, that we do not offer at the moment.",
    "maxLength": "Your message contains too many characters. Please make your message text shorter.",
    "bulkSession": "You are about to send a large bulk session. Please preview your message before sending.",
    "shortLink": "The carriers may reject messages with short links. To ensure the SMS delivery, please replace {domain} with a regular long link.",
    "byocPlanExceedLimit": "The following SMS session cannot be sent because it exceeds your BYOC plan’s message limit. To proceed, please {upgrade} or reduce the number of recipients or SMS parts.",
    "byocPlanUpgrade": "upgrade your BYOC plan",
    "unicode": "Your message contains Unicode characters ({unicodeChars}{others}), which reduce the max length of each message part and may increase the total cost of sending. {learnMore}",
    "unicodeOthers": "and {othersLength} other|and {othersLength} others",
    "multipleParts": "Your message contains {parts}, increasing the total cost. To reduce the number of message parts, shorten your text. {learnMore}",
    "parts": "{count} parts",
    "senderId": "Your message will be sent from an alphanumeric Sender ID. This means that users {canNotReply} to you or {optOut}.",
    "canNotReply": "will not be able to reply",
    "optOut": "opt out",
    "numberNotRegistered": "This number is **not registered**. You must register your brand and campaign before you can send SMS from this number.",
    "registerBrandAndCampaign": "Register brand and campaign",
    "numberRegistrationInReview": "This number registration is **in review**. You can send SMS once the brand and campaign registration is approved by the network operators.",
    "checkStatus": "Check status",
    "updateBrandAndCampaign": "Please **review and update** the brand and campaign registration details to start sending SMS from this number.",
    "fixIssues": "Fix issues",
    "anUnexpectedError": "An unexpected error occurred while registering this number. Please",
    "defaultSenderIsNotRegistered": "You must register your brand and campaign before you can send SMS to {country} from the **{number}** number.",
    "defaultSenderIsNotRegisteredWithoutNumber": "You must register your brand and campaign before you can send SMS to {country} from this number.",
    "noSender": "To send SMS to {country}, you need to get a number first.",
    "buyNumber": "Buy a number"
  },
  "composeSideButton": {
    "contacts": "Contacts",
    "lists": "Lists",
    "segments": "Segments",
    "frequentlySent": "Frequently sent",
    "manageSenders": "Manage senders",
    "insertTemplate": "Insert template",
    "insertTag": "Add dynamic field",
    "attachFile": "Attach file",
    "noContacts": "You have no contacts here yet."
  },
  "composePreviewModal": {
    "modalTitle": "Message preview for 1 recipient (out of {count} total)",
    "modalTitleSingleMessage": "Message preview",
    "backToEditing": "Back to editing",
    "submit": "Send {number} message | Send {number} messages",
    "submitSchedule": "Schedule message",
    "submitScheduleCount": "Schedule {number} message | Schedule {number} messages",
    "approximatePrice": "Approximate cost is displayed because you have tags in your message.",
    "bulkSession": "You are about to send a bulk session. Please review your message carefully and confirm.",
    "table": {
      "from": "From",
      "to": "To",
      "messageContent": "Message content",
      "totalCharacters": "Total characters",
      "totalCharactersNumber": "{number} character | {number} characters",
      "messageParts": "Message parts",
      "messagePartsNumber": "{number} part | {number} parts",
      "costOfThisMessage": "Cost of this message",
      "totalSessionCost": "Total session cost"
    }
  },
  "composePreviewModalToCellContentContactWithoutPhone": {
    "contactDoesNotHaveValidPhoneNumber": "This contact does not have a valid phone number. Please add a number to this contact to send SMS.",
    "addPhoneNumber": "Add phone number"
  },
  "composeSuccessSendMessages": {
    "scheduledMessageDetails": "Scheduled message details",
    "sentTextMessageDetails": "Outbound text message details",
    "successAlertTitle": "Your message has been successfully sent to {quantity} recipient. | Your message has been successfully sent to {quantity} recipients.",
    "editSmsAndResend": "Edit SMS and resend",
    "viewSentMessages": "View outbound messages"
  },
  "composeSuccessSendScheduled": {
    "scheduleNewMessage": "Schedule a new message",
    "viewScheduledMessages": "View scheduled messages",
    "viewInCalendar": "View in calendar",
    "yourMessageHasBeenScheduledSuccessfully": "Your message has been scheduled successfully. Next send time is on {dateTime}."
  },
  "accountDetails": {
    "editAccountDetails": "Edit account details",
    "username": "Username",
    "accountOwner": "Account owner",
    "role": "Role",
    "contactEmail": "Contact email",
    "mobileNumber": "Mobile number",
    "timeZone": "Time zone",
    "timeDisplayFormat": "Time display format",
    "registrationCountry": "Registration country",
    "successSendVerificationOnEmail": "We have sent you a verification email. Please check your inbox.",
    "resendLinkIn": {
      "text": "Resend link in {minutes}{seconds}",
      "minutes": "{minutes}m",
      "seconds": "{seconds}s"
    },
    "close": {
      "label": "Closing your account",
      "text": "If you’re having issues or have questions about Textmagic, please {contactSupport}, and if you want to close your account, please use this link to {closeAccount}.",
      "contactSupport": "contact Textmagic support",
      "closeAccount": "close your account"
    }
  },
  "accountDetailsEditModal": {
    "title": "Edit account details",
    "formFields": {
      "userName": {
        "label": "Username",
        "placeholder": "Enter username",
        "formErrors": {
          "required": "Please enter username."
        }
      },
      "firstName": {
        "label": "First Name",
        "placeholder": "Enter first name",
        "formErrors": {
          "required": "Please enter first name."
        }
      },
      "lastName": {
        "label": "Last Name",
        "placeholder": "Enter last name",
        "formErrors": {
          "required": "Please enter last name."
        }
      },
      "email": {
        "label": "Contact email",
        "placeholder": "Enter contact email",
        "formErrors": {
          "required": "Please enter contact email."
        }
      },
      "phone": {
        "label": "Mobile number",
        "placeholder": "Enter mobile number"
      },
      "timezone": {
        "label": "Time zone"
      },
      "displayTimeFormat": {
        "label": "Time display format"
      }
    }
  },
  "phoneVerificationModal": {
    "title": "Verify mobile number",
    "didntReceiveAnSms": "Didn’t receive an SMS?",
    "sendSmsAgain": "Send again",
    "cancelVerification": "Cancel verification",
    "confirmYourPhoneNumberBySms": "Enter the 6-digit code we sent by SMS to",
    "pleaseEnterCodeHere": "Please enter the code here",
    "verifyNumber": "Verify",
    "verifyingNumber": "Verifying...",
    "errors": {
      "codeIsIncorrect": "That code is incorrect. Check it and try again."
    },
    "resendSuccess": "We have sent you a verification SMS. Please check your phone.",
    "verificationSuccess": "Mobile number verified."
  },
  "inviteSubAccountModal": {
    "title": "Invite new sub-account",
    "submitButton": "Send invitation",
    "success": "The invitation email has been sent successfully.",
    "eachUserSeatMonthly": "Each user seat costs {cost} per month.",
    "eachUserSeatYearly": "Each user seat costs {cost} per month (billed yearly).",
    "inviteTeamMembers": "Invite team members to collaborate in a shared workspace with access to shared messaging channels, data, and contacts.",
    "formFields": {
      "email": {
        "label": "Email address",
        "placeholder": "Enter email address",
        "info": "Activation link will be sent to your team member’s email."
      },
      "role": "Role"
    },
    "addAnother": "Add another"
  },
  "inviteUsersModal": {
    "title": "Invite users"
  },
  "inviteSubAccountsModal": {
    "title": "Invite sub-accounts"
  },
  "switchSubAccountModal": {
    "title": "Switch sub-account",
    "manage": "Manage sub-accounts"
  },
  "resendInvitationSubAccountModal": {
    "title": "Resend invitation",
    "description": "Are you sure you want to send invitation to this sub-account? You can change email address for this sub-account if needed.",
    "descriptionForUsers": "Are you sure you want to send invitation to this user? You can change email address for this user if needed.",
    "submitButton": "Resend invitation",
    "success": "An activation link has been sent to {email}",
    "formFields": {
      "email": {
        "label": "Email",
        "placeholder": "email{'@'}example.com"
      }
    }
  },
  "fieldTagsList": {
    "addList": "Add list",
    "addLists": "Add lists",
    "selectAnother": "Select a different list",
    "createNewList": "Create new list",
    "searchLists": "Search lists"
  },
  "fieldSelectSearchSenderSettings": {
    "byoc": "{provider} (BYOC)",
    "byocNumbers": "BYOC numbers",
    "byocSendingNotAllowed": "Your account permissions do not allow sending messages via connected CPaaS providers.",
    "dedicated": "Textmagic numbers",
    "whatsApp": "WhatsApp",
    "widgets": "Widgets",
    "facebook": "Facebook pages",
    "instagram": "Instagram accounts",
    "senderIds": "Sender IDs",
    "userNumbers": "Your mobile phone",
    "shared": "Shared reply numbers",
    "defaultCallerSelectValue": "Default sender settings (recommended)",
    "voiceEnabled": "Voice-enabled numbers",
    "defaultCallerSelectValueShort": "Default sender settings",
    "buyTextmagicDedicatedNumber": "- Buy a Textmagic dedicated number -",
    "connectCPaaSProvider": "- Connect a CPaaS provider -",
    "applyForSenderID": "- Apply for a Sender ID -",
    "addYourMobileNumberUnderAccount": "- Add your mobile number under account -",
    "verifyYourMobileNumber": "- Verify your mobile number -",
    "senderIDisNotSupported": "- Sender ID is not supported in this country -",
    "noAvailableSenderIds": "- No available Sender IDs -",
    "ownMobileSettingIsNotSupported": "- Own mobile setting is not supported in this country -",
    "sharedMobileSettingIsNotSupported": "- Shared mobile setting is not supported in this country -",
    "connectWhatsappNumber": "- Connect WhatsApp number to Textmagic -",
    "registrationStatuses": {
      "registered": "Registered",
      "inReview": "In review",
      "actionRequired": "Action required",
      "notRegistered": "Not registered",
      "failed": "Failed registration"
    }
  },
  "fieldSelectSenderPhone": {
    "displayCustomNumber": "Display custom number",
    "selectNumber": "- Select number -",
    "errors": {
      "phoneRequired": "Please select a phone number."
    }
  },
  "fieldSelectSearchInbox": {
    "selectInbox": "- Select an inbox -",
    "useCustomEmail": "Use custom email address",
    "connected": "Connected inboxes",
    "connectNew": "- Connect new inbox -",
    "customEmailPlaceholder": "Type email here",
    "errors": {
      "inbox": "Please select a inbox."
    }
  },
  "fieldSelectSearchFacebookPage": {
    "selectFacebookPage": "- Select a Facebook page -",
    "useCustomFacebookPage": "Use custom page",
    "facebookPages": "Facebook pages",
    "connectNew": "- Connect Facebook page to Textmagic -",
    "customFacebookPagePlaceholder": "Add link to Facebook page",
    "searchFacebookPages": "Search Facebook pages",
    "errors": {
      "facebookPage": "Please select a Facebook page.",
      "customFacebookPage": "Please enter a valid Facebook page link."
    }
  },
  "fieldSelectSearchInstagramAccount": {
    "selectAccount": "- Select an Instagram account -",
    "useCustomAccount": "Use custom account",
    "accounts": "Instagram accounts",
    "connectNew": "- Connect Instagram account to Textmagic -",
    "customAccountPlaceholder": "Add link to Instagram account",
    "searchAccounts": "Search Instagram accounts",
    "errors": {
      "account": "Please select an Instagram account.",
      "customAccount": "Please enter a valid link to Instagram account."
    }
  },
  "fieldWeekDaysTimeRangeLists": {
    "errors": {
      "endTimeBeforeStartTime": "The end time must be later than the start time.",
      "intervalsOverlap": "Time intervals should not overlap within a day.",
      "required": "Please select at least one day and time frame."
    }
  },
  "contactsImportedEmptyState": {
    "title": "This import session had no successfully imported contacts",
    "description": "Please check the “Failed to import” tab to fix possible validation errors."
  },
  "contactsDuplicatesEmptyState": {
    "title": "This import session had no excluded duplicate numbers",
    "description": "There is nothing to fix, everything is alright here."
  },
  "contactsFailedEmptyState": {
    "title": "This import session had no failed rows",
    "description": "There is nothing to fix, everything is alright here."
  },
  "contactsExcludedEmptyState": {
    "title": "This import session had no excluded rows",
    "description": "There is nothing to fix, everything is alright here."
  },
  "contactsUnsubscribedEmptyState": {
    "title": "No email addresses were unsubscribed",
    "description": "You have a good quality email list."
  },
  "noteFormService": {
    "note": {
      "placeholder": "Type your note",
      "button": "Add note",
      "buttonSave": "Save note"
    },
    "formErrors": {
      "required": "Field is required.",
      "enterTextOrAttachFile": "Enter text or attach a file."
    },
    "maxAttachments": "The maximum number of attachments in one note is {count}."
  },
  "deleteNoteConfirmation": {
    "title": "Delete note",
    "text": "Are you sure you would like to delete this note? This action cannot be undone later."
  },
  "contactDetailsNoteAdd": {
    "text": "Click to add an internal note"
  },
  "contactDetailsNotesList": {
    "title": "Notes",
    "showMore": "Show {count} more",
    "noNotesYet": "No notes yet"
  },
  "contactDetailsScheduleCard": {
    "smsTitle": "Scheduled text message",
    "emailTitle": "Scheduled email",
    "scheduled": "Scheduled",
    "paused": "Paused"
  },
  "contactDetailsSchedulesList": {
    "title": "No scheduled messages yet"
  },
  "contactDetailsNotesAction": {
    "create": "The note has been successfully added.",
    "update": "The note has been successfully updated.",
    "updateSome": "Edited notes has been successfully updated.",
    "delete": "The selected note has been successfully deleted."
  },
  "contactDetailsSidebar": {
    "title": "Details",
    "addCustomField": "Add new custom field",
    "manageCustomField": "Manage custom fields",
    "placeholder": "Add {field}",
    "fields": {
      "fullName": "Full name",
      "phone": "Phone",
      "whatsappPhone": "WhatsApp",
      "email": "Email",
      "companyName": "Company",
      "lists": "Lists",
      "ownerId": "Contact owner",
      "tags": "Tags"
    },
    "systemFields": {
      "source": {
        "label": "Source",
        "manual": "Manual",
        "import": "Import",
        "api": "API",
        "form": "Form",
        "liveChat": "Live chat",
        "whatsapp": "WhatsApp",
        "facebook": "Facebook",
        "ticket": "Ticket",
        "instagram": "Instagram",
        "sms": "SMS",
        "shopify": "Shopify",
        "woocommerce": "WooCommerce",
        "hubspot": "HubSpot",
        "zohocrm": "Zoho CRM",
        "mcp": "MCP"
      },
      "sourceForm": {
        "label": "Form name",
        "deleted": "Deleted form",
        "open": "Open form"
      },
      "consent": {
        "label": "Consent",
        "none": "None",
        "marketing": "Marketing",
        "transactional": "Transactional",
        "marketingAndTransactional": "Marketing and Transactional",
        "terms": "Terms of Service / Privacy Policy",
        "marketingAndTerms": "Marketing and Terms of Service / Privacy Policy",
        "transactionalAndTerms": "Transactional and Terms of Service / Privacy Policy",
        "marketingTransactionalAndTerms": "Marketing, Transactional and Terms of Service / Privacy Policy"
      }
    },
    "leavePage": "You have unsaved changes. If you continue, your changes will be discarded. Are you sure you want to continue?",
    "contactInfo": "Contact info",
    "customFields": "Custom fields",
    "newCustomField": "New custom field",
    "emptyState": {
      "title": "No search results found",
      "description": "Please try a different keyword"
    }
  },
  "unsavedFormRouteLeave": "You have unsaved changes. If you continue, your changes will be discarded. Are you sure you want to continue?",
  "contactDetailsHeader": {
    "addNote": "Internal note",
    "details": "Details",
    "contactDetails": "Contact details",
    "endCall": "End call",
    "call": "Call",
    "newEmailDisabledTooltip": "You cannot send emails to this contact as their email address is unsubscribed.",
    "task": "Task",
    "pin": "Pin",
    "unpin": "Unpin"
  },
  "contactDetailsModalUnsavedNote": {
    "title": "Unsaved changes",
    "description": "You have unsaved changes in the internal note, that you have been editing. Would you like to save these changes?",
    "submitButton": "Save changes",
    "cancelButton": "Keep editing"
  },
  "contactDetailsCustomFieldsEmpty": {
    "title": "No custom data fields",
    "description": "Create a new custom field to store more data",
    "buttonTitle": "New custom field"
  },
  "contactDetailsContentLoader": {
    "title": "Loading contact information..."
  },
  "whiteBlockContentLoader": {
    "title": "Loading your information...",
    "description": "Please wait while we are loading your information."
  },
  "audioDeleteModal": {
    "title": "Delete recording",
    "text": "Are you sure you would like to delete this recording? This action cannot be undone.",
    "deleteSuccess": "The audio file has been successfully deleted."
  },
  "selectingContactsModal": {
    "title": "Contacts"
  },
  "selectingContactsProgressModal": {
    "modalTitle": "Please wait...",
    "title": "We are currently working on grouping your contacts. Please wait.."
  },
  "selectingContactsListsModal": {
    "title": "Lists"
  },
  "selectingSegmentsModal": {
    "title": "Segments"
  },
  "addContactsChooseSourceModal": {
    "title": "Add contacts",
    "manuallyLabel": "Create a new contact",
    "manuallyDescription": "Add contacts one by one",
    "listLabel": "Add from existing contacts",
    "listDescription": "Copy contacts from other Lists"
  },
  "contactListMoveCopyModal": {
    "titleMove": "Move contacts",
    "titleCopy": "Copy contacts",
    "description": "Please choose from the following options:",
    "moveTitle": "Move selected contacts to a new list",
    "moveDescription": "Contacts are removed from the current list and added to a new one.",
    "copyTitle": "Copy selected contacts to a new list",
    "copyDescription": "Contacts remain in the current list and will be added to a new one.",
    "success": {
      "move": "The selected contacts have been successfully moved to the new list.",
      "copy": "The selected contacts have been successfully copied to the new list."
    }
  },
  "myContactsTopbar": {
    "newContact": "New contact",
    "import": "Import",
    "addToList": "Add to list"
  },
  "myContactsFilters": {
    "isEmpty": "Is empty",
    "fields": {
      "tags": {
        "label": "Tags"
      },
      "country": {
        "label": "Country"
      },
      "ownerId": {
        "label": "Contact owner"
      },
      "createdDate": {
        "label": "Date created"
      },
      "lastUpdated": {
        "label": "Last updated"
      },
      "firstName": {
        "label": "First name"
      },
      "lastName": {
        "label": "Last name"
      },
      "phone": {
        "label": "Phone"
      },
      "whatsappPhone": {
        "label": "WhatsApp"
      },
      "email": {
        "label": "Email"
      },
      "company": {
        "label": "Company"
      },
      "createdBy": {
        "label": "Created by"
      },
      "lists": {
        "label": "Lists"
      },
      "source": {
        "label": "Source"
      },
      "sourceForm": {
        "label": "Source form"
      },
      "smsConsent": {
        "label": "SMS consent",
        "options": {
          "none": "None",
          "marketing": "Marketing",
          "transactional": "Transactional",
          "terms": "Terms of Service / Privacy Policy"
        }
      },
      "lastInboundSms": {
        "label": "Last inbound SMS"
      },
      "lastOutboundSms": {
        "label": "Last outbound SMS"
      },
      "lastInboundEmail": {
        "label": "Last inbound email"
      },
      "lastOutboundEmail": {
        "label": "Last outbound email"
      },
      "noteAddedDate": {
        "label": "Note added date"
      },
      "noteText": {
        "label": "Note text"
      }
    }
  },
  "myContactsFilterBar": {
    "searchContactOwner": "Search contact owner",
    "startTypingEmail": "Start typing email",
    "startTypingCompany": "Start typing company",
    "startTypingPhone": "Start typing phone",
    "searchUsers": "Search users",
    "startTypingWords": "Type words or phrases"
  },
  "addContactsToList": {
    "title": "Add contacts to list",
    "button": "Add to list",
    "confirmModal": "The selected {count} {contact} will be added to the following list:\n{list}. Are you sure you would like to continue?",
    "contact": "contact | contacts",
    "success": "Selected contacts have been successfully copied to the new list."
  },
  "senderIdApplyModal": {
    "title": "Apply for Sender ID",
    "submit": "Apply now",
    "loading": "Applying...",
    "oneWayNote": "Sender IDs only support {oneWayMessaging}. Incoming replies and inbound SMS are not supported.",
    "oneWayMessaging": "one-way messaging",
    "senderId": {
      "label": "Enter your sender ID:",
      "placeholder": "Enter sender ID name",
      "hint": [
        "Maximum 11 characters and at least 1 text character. A-Z and 0-9. No special symbols or spaces.",
        "Generic Sender IDs, e.g. Verify, SMS, INFO are not allowed."
      ]
    },
    "explanation": {
      "label": "Please explain your use case:",
      "placeholder": "Enter your message",
      "hint": [
        "To increase the speed of your request, please provide a brief description of your business intends to use this Sender ID.",
        "Max 300 characters."
      ]
    },
    "price": {
      "label": "Price:",
      "price": "{price} per month",
      "includedInYourPlan": "Free (included in your plan)",
      "hint": "You can cancel the subscription at any time."
    },
    "alert": {
      "text": "Sorry, but you do not have enough credit to buy this Sender ID. Please {link} now to continue."
    },
    "createdForAustralia": "Thank you for requesting the Sender ID. We will process your order and assign the requested Sender ID within 5-7 business days.",
    "weHaveReceivedYourSenderIdRequest": "We have received your Sender ID request. You will be notified via email once your new Sender ID has been approved."
  },
  "auSenderIdApplyModal": {
    "title": "Register your sender ID for Australia",
    "description": "Australia's communications regulator (ACMA) now requires all alphanumeric sender IDs to be registered before sending SMS to Australian numbers. Select the option that applies to your business.",
    "registerNow": "Register now",
    "withAbn": {
      "title": "Australian business with ABN",
      "description": "Your business is registered in Australia and has an Australian Business Number (ABN). After submitting, you'll receive an authorisation form to sign and later ACMA will contact your authorised representative directly to verify the registration.",
      "hint": "You'll need: ABN, legal company name, sender ID name(s), traffic type, estimated monthly volume, and your authorised representative's details (must appear in the Australian Business Registry)."
    },
    "withoutAbn": {
      "title": "International business (no ABN)",
      "description": "Your business is registered outside Australia and does not have an ABN. After submitting, you'll receive an authorisation form to sign and a link to complete identity verification for your business.",
      "hint": "You'll need: legal company name, country of registration, company registration number, company website, traffic type, estimated monthly volume, your company representative's details."
    }
  },
  "senderIdApplyFormService": {
    "errors": {
      "senderId": {
        "required": "Please enter a valid sender ID.",
        "min": "This value is too short. It should have 3 characters or more.",
        "letters": "In order to avoid number spoofing we require at least one text character in all Sender IDs."
      },
      "explanation": "Please explain why you need this Sender ID.",
      "maxLength": "This value is too long. It should have 300 characters or less."
    }
  },
  "dateFilter": {
    "All": "All time",
    "Today": "Today",
    "Yesterday": "Yesterday",
    "This week": "This week",
    "Last week": "Last week",
    "This month": "This month",
    "Last month": "Last month",
    "Previous month": "Last month",
    "Last 30 days": "Last 30 days",
    "Last 60 days": "Last 60 days",
    "Pick date range": "Custom"
  },
  "dateFilterCustom": {
    "from": "From",
    "to": "To",
    "show": "Show",
    "close": "Close"
  },
  "historyStatusAlert": {
    "warningMessage": "This contact is {status}. You cannot send messages to this contact anymore."
  },
  "historyTableSharedTopButtons": {
    "blockContact": "Block contact",
    "unblockContact": "Unblock contact"
  },
  "contactDetailsActivityNoResult": {
    "title": "There are no results with the applied filters",
    "description": "Please try to change your search request or filters"
  },
  "contactDetailsActivityBase": {
    "noEventsYet": "No events yet"
  },
  "contactsDetailsActivities": {
    "title": "Activity log",
    "scheduled": "Scheduled",
    "sent": "Outbound SMS",
    "received": "Inbound SMS",
    "call": "Calls",
    "whatsapp": "WhatsApp",
    "livechat": "Live chat",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "searchActivities": "Search activities",
    "tickets": "Tickets",
    "emailCampaigns": "Email campaigns"
  },
  "activityCardCall": {
    "to": "To {phone}",
    "from": "From {phone}",
    "titleOutbound": "Outbound call",
    "titleForwarded": "Forwarded call",
    "titleInbound": "Inbound call",
    "titleMissed": "Missed call"
  },
  "activityCardReceivedSms": {
    "title": "Inbound text message",
    "titleForMms": "Inbound MMS"
  },
  "activityCardSentSms": {
    "title": "Outbound text message",
    "titleForMms": "Outbound MMS",
    "status": "sent"
  },
  "activityCardLiveChat": {
    "title": "Live chat"
  },
  "activityFacebookChat": {
    "title": "Chat with {title} page"
  },
  "activityInstagramChat": {
    "title": "Chat with {title}"
  },
  "contactDetailsContent": {
    "notes": {
      "title": "Notes",
      "addNote": "Add note"
    },
    "tasks": {
      "title": "Tasks",
      "noTasks": "No tasks yet",
      "setDueDate": "Set due date",
      "newTask": "New task"
    },
    "scheduled": {
      "title": "Scheduled",
      "scheduleSms": "Schedule SMS",
      "scheduleEmail": "Schedule email",
      "scheduleUnavailableForBlockedTooltip": "Scheduling is unavailable for blocked contacts.",
      "newSms": "New SMS",
      "newEmail": "New email"
    }
  },
  "noteCardNew": {
    "createTask": "Create task"
  },
  "activityCardTickets": {
    "emptyText": "There are no messages yet"
  },
  "activityCardEmail": {
    "title": "Email campaign"
  },
  "messagesAttachmentFileModal": {
    "attachFile": "Attach a file",
    "attachFileInsertDownloadLink": "Attach a file - Insert download link",
    "attachFileMMS": "Attach a file - MMS",
    "orDragAndDrop": "or drag and drop",
    "fileErrorRequired": "Please choose a file that you would like to attach to your message.",
    "supportsFormats": "Supports {startOfLine} & {commaWithLastElement} file formats",
    "attachWhatsAppMediaFileInfo": "You can upload image files up to 5 MB, video and audio files up to 16 MB.",
    "attachFacebookMediaFileInfo": "You can upload image files up to 8 MB, video and audio files up to 25 MB.",
    "attachWhatsAppDocFileInfo": "You can upload files up to 100 MB.",
    "attachFacebookDocFileInfo": "You can upload files up to 25 MB."
  },
  "messagesAttachmentSelectModal": {
    "insertDownloadLink": "Insert download link",
    "aClickableLinkToTheFileWillBeAddedToYourMessage": "A clickable link to the file will be added to your message.",
    "aMultimediaMessageWillBeSentToYourRecipientPhone": "A multimedia message will be sent to your recipient’s phone."
  },
  "messagesAttachmentFilePreviewModal": {
    "fileUploaded": "File uploaded",
    "directLink": "Direct link",
    "uploadStatus": "Upload status",
    "addLinkToMessage": "Add link to message",
    "attachFile": "Attach file",
    "previewNotAvailable": "Preview is not available for this type of file."
  },
  "fieldImportFile": {
    "dragAndDropFile": "Drag & drop your file here",
    "fileTypes": "Supported file types: Excel (.xls or .xlsx) and CSV (.csv)."
  },
  "tmRepeatForm": {
    "repeat": "Repeat"
  },
  "tmRepeatFormMonthly": {
    "onDay": "on day",
    "onThe": "on the"
  },
  "tmRepeatFormYearly": {
    "on": "on",
    "of": "of",
    "onThe": "on the"
  },
  "tmRepeatFormRepeatAndCount": {
    "every": "every"
  },
  "tmRepeatFormEnd": {
    "end": "End",
    "sentSessions": "sent {type} sessions"
  },
  "weekDaysFull": {
    "day": "Day",
    "weekday": "Weekday",
    "weekendday": "Weekend day"
  },
  "flowStepNumber": {
    "value": "step {number}"
  },
  "importUpload": {
    "file": "Upload a file",
    "list": "Copy & paste",
    "edit": "Start over",
    "upload": "Upload file"
  },
  "importUploadSubtitle": {
    "file": "You have uploaded the file {name} ({size}).",
    "text": "You have manually added {entities} to be imported."
  },
  "importUploadFile": {
    "title": "Upload a file",
    "generatingPreview": "Generating preview..."
  },
  "importUploadFileInfo": {
    "gettingStarted": {
      "title": "Getting started",
      "text": "See how the data should be organized for a successful import.",
      "link": "Download example file"
    },
    "learnMore": {
      "title": "Learn more about import"
    },
    "options": {
      "xls": "Microsoft Excel workbook (.xls)",
      "xlsx": "Microsoft Excel workbook (.xlsx)",
      "csv": "Comma-separated values (.csv)"
    }
  },
  "contactImportUpload": {
    "title": "Upload contact data",
    "subtitle": "Select a way how you would like to upload contacts.",
    "file": {
      "description": "Upload a file with contacts phone numbers, names, organization etc."
    },
    "phones": {
      "title": "Copy and paste phone numbers",
      "description": "Simply copy and paste multiple numbers to add many contacts at ones (no field matching).",
      "placeholder": "Paste your phone numbers here",
      "hint": "Paste one phone number per line or separated with commas.",
      "error": {
        "required": "Please enter at least 1 valid phone number"
      }
    },
    "learnMoreText": "Read about the methods of how you can import contacts."
  },
  "flowUploadPhonesFormService": {
    "phonesErrorMessage": "Please enter valid phone numbers."
  },
  "importMatching": {
    "title": "Match fields",
    "subtitle": "This is a preview of the imported data. Please match the columns below to the data fields in Textmagic.",
    "subtitleFinished": "You have selected {count} spreadsheet data columns to be imported."
  },
  "importMatchingTopic": {
    "topic": "Data fields preview",
    "subtopic": "Please select the relevant user fields to match the spreadsheet data columns.",
    "fullScreen": "View in full screen"
  },
  "importMatchingFullscreenModal": {
    "title": "Match data fields",
    "subtitle": "Please select the relevant user fields to match the spreadsheet data columns."
  },
  "importMatchingCountryModal": {
    "title": "Number validation",
    "alert": "We were unable to automatically validate your numbers in the file. Please select manually one of the options below to help us import your phone numbers correctly:",
    "subtitle": "Numbers format",
    "country": "All of my numbers are from the same country",
    "international": "My numbers are from multiple countries",
    "internationalText": "Numbers must be in the international format with the country code and no leading zeroes, e.g. 183782315212 for the USA."
  },
  "fieldConfigMatching": {
    "confirm": {
      "title": "Contact field is already in use",
      "text": "This field is already in use by another column. Do you want the selected column to use this field instead?"
    }
  },
  "fieldEmailFooterEditor": {
    "fieldNames": {
      "companyName": "Company name",
      "companyAddress": "Mailing address"
    }
  },
  "importMatchSelect": {
    "new": "Add new field",
    "skip": "Do not import"
  },
  "lookupMatchSelect": {
    "skip": "Do not check"
  },
  "subAccountDetails": {
    "tabs": {
      "overview": "Overview",
      "permissions": "Permissions",
      "sent": "Outbound SMS",
      "received": "Inbound SMS"
    }
  },
  "usersDetails": {
    "tabs": {
      "overview": "Overview",
      "permissions": "Permissions"
    }
  },
  "subAccountDetailsButtons": {
    "logInAccount": "Log in as this account",
    "resetPassword": "Reset password",
    "resend": "Resend invitation",
    "openSubAccount": {
      "button": "Reopen sub-account",
      "successMessage": "Sub-account has been opened."
    }
  },
  "userDetailsButtons": {
    "resetPassword": "Reset password",
    "resend": "Resend invitation",
    "openSubAccount": "Reopen user",
    "setOffline": "Set offline",
    "setOfflineSuccessMessage": "The user's status has been successfully updated."
  },
  "contactImportSettings": {
    "title": "Additional options",
    "subtitle": "Choose lists where to import contacts and additional actions.",
    "subtitleFinished": "All contacts will be added to the following lists: {lists}",
    "unsubscribe": "Unsubscribers",
    "block": "Blocked",
    "startImport": "Start import",
    "maxQuantityTagsError": "Tags list should contain {quantity} elements or less."
  },
  "contactImportSettingsForm": {
    "lists": "Add imported contacts to the following lists",
    "moreActions": "More actions",
    "unsubscribe": "Unsubscribe imported contacts",
    "tags": {
      "label": "Add tags",
      "placeholder": "Start typing tag name"
    },
    "block": "Block imported contacts",
    "landline": "Exclude landline numbers",
    "landlineHint": "If your list contains landline numbers, they will be ignored and will not be imported."
  },
  "contactImportSettingsLandlineAlert": {
    "text": "Your uploaded file contains {rows}. It will cost you {cost} to check them for landlines using {link} service.",
    "carrierLookup": "Carrier lookup"
  },
  "contactImportSettingsCreditAlert": {
    "text": "Sorry, but you do not have enough credit to check these numbers. Please {buyCredit} now to continue.",
    "buyCredit": "buy credit"
  },
  "contactImportSettingsAlert": {
    "text": "{note} You are about to import contacts into the {list} list. These contacts will be moved from your account to {contacts} contacts. {warning} to these contacts after this import.",
    "note": "Please note:",
    "warning": "It will no longer be possible to send messages"
  },
  "contactImportsService": {
    "listName": "Import {date}"
  },
  "myData": {
    "totalUsers": "Total users",
    "users": "user | users"
  },
  "contactImportCleanup": {
    "title": "Data cleanup",
    "subtitle": "Clean your contact list to improve delivery rates and engagement.",
    "label": "Clean up your email list",
    "recommended": "Recommended for email campaigns",
    "description": "Validate email addresses to improve deliverability and sender reputation.",
    "reduceBounceRate": "Reduce bounce rate",
    "reduceBounceRateDescription": "Remove invalid, risky, or non-existent emails before sending.",
    "protectSenderReputation": "Protect sender reputation",
    "protectSenderReputationDescription": "Prevent hard bounces that can hurt your domain reputation.",
    "improveEngagement": "Improve engagement",
    "improveEngagementDescription": "Send to real users, reaching more active recipients.",
    "skippingAlert": "**Skipping email list cleanup may lead to higher bounce rates**, lower engagement, and sender reputation issues. Only import contacts who have opted in. Purchased lists may cause delivery problems and harm your sender reputation.",
    "emailLookupAndValidation": "Email lookup & validation",
    "onlyCost": "Only {cost} per lookup",
    "onlyCostWithBonus": "{bonus} free email lookups left · Only {cost} per lookup after",
    "estimatedCost": "Estimated cost: {cost}",
    "forContacts": "for {count} contacts",
    "deductedFromBalance": "{cost} will be deducted from your account balance for the email lookup service.",
    "startCleanup": "Clean up list and start import",
    "skipCleanup": "Skip cleanup and start import",
    "hideStepForever": "Hide this step forever",
    "costTooltip": "This is the estimated cost. If some contacts can’t be checked (e.g. missing or invalid email), the cost for those will be returned to your balance.",
    "costTooltipWithBonus": "This is the estimated cost. Free bonus lookups are deducted first, then paid credits are used. If some contacts can’t be checked (e.g. missing or invalid email), the cost for those will be returned to your balance.",
    "notEnoughCredit": "You don’t have enough credit for email cleanup. To continue, please {buyCredit} or {uncheck} option.",
    "buyCredit": "buy credit",
    "uncheck": "uncheck the cleanup"
  },
  "contactImportProgress": {
    "title": "Import results",
    "subtitle": "Just leave it with us and we will import your data in the background.",
    "importProgressLabel": "Import in progress ({progress}%)...",
    "cleanupProgressLabel": "Data cleanup in progress ({progress}%)...",
    "completeLabel": "Import completed",
    "subtextProgress": "Big files processing can take time. You can close this tab and we will send you an email once the import has completed",
    "subtextComplete": "Your import has been completed. To see details please click the button below",
    "continue": "View results",
    "restart": "Start new import"
  },
  "importProgressResult": {
    "name": "File name",
    "size": "File size",
    "rows": "Total rows"
  },
  "sentSmsBulkDetailsModal": {
    "title": "Outbound SMS details"
  },
  "sentSmsBulkDetailsEmptyState": {
    "title": "There are no messages in {status} status",
    "description": "Please check other tabs for more details"
  },
  "headerVerifyEmail": {
    "title": "Please verify your email - {email} - by clicking the verification link found in the message we just sent to you.",
    "resendButtonTitle": "Resend verification email"
  },
  "headerVerifyIdentity": {
    "needVerifyIdentity": "We need to verify your identity before we can complete your order. Please {verify}",
    "verifyYourIdentity": "verify your identity",
    "yourIdentityBeingReviewed": "Your identity is being reviewed. You will be notified via email once your identity has been verified (normally it takes {minMinutes} - {maxMinutes} minutes)."
  },
  "subAccountSidebar": {
    "title": "Profile",
    "username": "Username",
    "subaccountType": "Role",
    "status": "Status",
    "lastActive": "Last active",
    "createdAt": "Date created"
  },
  "subAccountDetailsPermissions": {
    "sections": {
      "actionsPermissions": {
        "title": "Actions",
        "description": "Manage the global actions applicable to the whole workspace.",
        "options": {
          "exportData": {
            "title": "Export data"
          },
          "deleteData": {
            "title": "Delete data"
          },
          "importContacts": {
            "title": "Import contacts"
          },
          "mobileApp": {
            "title": "Mobile app"
          }
        }
      },
      "messagingPermissions": {
        "title": "Messaging",
        "description": "Manage the permissions related to messaging.",
        "options": {
          "smsChat": {
            "title": "SMS chat"
          },
          "scheduled": {
            "title": "Scheduled"
          },
          "history": {
            "title": "History"
          },
          "composePage": {
            "title": "Send SMS"
          },
          "composeEmailPage": {
            "title": "Send Email"
          },
          "sendMms": {
            "title": "Send MMS"
          },
          "byoc": {
            "title": "Send SMS via BYOC"
          }
        }
      },
      "channelsPermissions": {
        "title": "Channels management",
        "description": "Which communication channels this sub-account can manage (Connect/disconnect).",
        "userFlowDescription": "Which communication channels this user can manage (Connect/disconnect).",
        "options": {
          "buyNumbersSenderIds": {
            "title": "Buy numbers / Sender IDs"
          },
          "manageCpaasProviders": {
            "title": "Bring your own CPaaS",
            "caption": "(BYOC)"
          },
          "connectEmailDomains": {
            "title": "Connect email domains",
            "caption": "(Email campaigns)"
          },
          "connectInboxes": {
            "title": "Connect inboxes",
            "caption": "(Tickets)"
          },
          "connectWhatsapp": {
            "title": "WhatsApp"
          },
          "connectFacebook": {
            "title": "Facebook"
          },
          "connectInstagram": {
            "title": "Instagram"
          },
          "connectChatWidget": {
            "title": "Chat widget"
          }
        }
      },
      "contactsPermissions": {
        "title": "Contacts",
        "description": "Manage the permissions related to contacts, lists and importing.",
        "options": {
          "contacts": {
            "title": "Contacts"
          },
          "resubscribe": {
            "title": "Resubscribe"
          },
          "createNewLists": {
            "title": "Create new lists"
          }
        }
      },
      "servicesPermissions": {
        "title": "Services",
        "description": "Manage the permissions related to additional services.",
        "options": {
          "emailToSms": {
            "title": "Email to sms"
          },
          "distributionLists": {
            "title": "Distribution lists"
          },
          "textToSpeechSettings": {
            "title": "Text-to-speech settings"
          },
          "api": {
            "title": "API & integrations"
          },
          "automationRules": {
            "title": "Automations"
          },
          "carrierLookup": {
            "title": "Carrier lookup"
          },
          "subscribeForms": {
            "title": "Subscribe forms"
          },
          "senderSettings": {
            "title": "Sender settings"
          },
          "makeCalls": {
            "title": "Calls"
          },
          "emailLookup": {
            "title": "Email lookup"
          },
          "verifyApi": {
            "title": "Verify API"
          },
          "pointAi": {
            "title": "Point AI"
          }
        }
      },
      "accountPermissions": {
        "title": "Account",
        "description": "Manage the permissions related to the account.",
        "options": {
          "accountSettings": {
            "title": "Account settings"
          },
          "billing": {
            "title": "Billing"
          },
          "autorechargeSettings": {
            "title": "Auto-recharge"
          },
          "invoices": {
            "title": "Invoices"
          },
          "subaccountSettings": {
            "title": "Sub-accounts"
          },
          "messagingData": {
            "title": "Messaging data"
          },
          "accountNotifications": {
            "title": "Notifications"
          }
        }
      },
      "reportingPermissions": {
        "title": "Reporting",
        "description": "Manage the permissions related to the reporting section.",
        "options": {
          "reportingOverview": {
            "title": "Reporting overview"
          },
          "reportingMessages": {
            "title": "Messages"
          },
          "reportingCalls": {
            "title": "Calls"
          },
          "reportingStatements": {
            "title": "Statements"
          },
          "reportingAuditLogs": {
            "title": "Audit logs"
          },
          "reportingSubAccounts": {
            "title": "Sub-accounts"
          },
          "reportingUsers": {
            "title": "Users"
          },
          "reportingNumbers": {
            "title": "Numbers reporting"
          },
          "reportingEmails": {
            "title": "Email"
          }
        }
      }
    },
    "sectionsTooltip": {
      "actionsPermissions": {
        "exportData": "Allow sub-account to export data from Textmagic.",
        "deleteData": "Allow sub-account to delete any data from Textmagic.",
        "importContacts": "Allow sub-account to import contacts to Textmagic.",
        "mobileApp": "Allow sub-account to log in using the mobile app for iOS and Android."
      },
      "messagingPermissions": {
        "scheduled": "Allow sub-account to access the Scheduled messages page.",
        "history": "Allow sub-account to access the History (Sent, Received, Forwarded calls) section.",
        "composeEmailPage": "Allow sub-account to send email using the Compose page in the Web app.",
        "composePage": "Allow sub-account to send messages using the Compose page in the Web app.",
        "sendMms": "Allow sub-account to send MMS.",
        "byoc": "Allow sub-account to send SMS through their own connected CPaaS provider (BYOC)."
      },
      "channelsPermissions": {
        "buyNumbersSenderIds": "Allow sub-account to buy phone numbers and request Sender IDs.",
        "manageCpaasProviders": "Allow sub-account to manage CPaaS providers and their numbers.",
        "connectEmailDomains": "Allow sub-account to connect and verify sending domains for email campaigns.",
        "connectInboxes": "Allow sub-account to connect email inboxes used in the Tickets section.",
        "connectWhatsapp": "Allow sub-account to connect or disconnect the WhatsApp channel.",
        "connectFacebook": "Allow sub-account to connect or disconnect the Facebook Messenger channel.",
        "connectInstagram": "Allow sub-account to connect or disconnect the Instagram channel.",
        "connectChatWidget": "Allow sub-account to set up and manage the Chat widget."
      },
      "contactsPermissions": {
        "contacts": "Allow sub-account to access the Contacts (Lists, My contacts, Custom fields, Import, Blocked) section.",
        "resubscribe": "Allow sub-account to resubscribe contacts, who have been manually unsubscribed.",
        "createNewLists": "Allow sub-account to create new lists."
      },
      "servicesPermissions": {
        "emailToSms": "Allow sub-account to access and use the email to SMS feature.",
        "distributionLists": "Allow sub-account to access the Distribution lists feature.",
        "textToSpeechSettings": "Allow sub-account to access the Text-to-speech settings page.",
        "api": "Allow sub-account to access and use the SMS API Gateway feature.",
        "automationRules": "Allow sub-account to access the Automations feature.",
        "carrierLookup": "Allow sub-account to access and use the carrier lookup tool.",
        "subscribeForms": "Allow sub-account to access the Subscribe forms page.",
        "senderSettings": "Allow sub-account to edit Sender settings.",
        "makeCalls": "Allow sub-account to make a calls.",
        "emailLookup": "Allow sub-account to access and use the email lookup tool.",
        "verifyApi": "Allow sub-account to access and use the VerifyAPI.",
        "pointAi": "Allow sub-account to access and use the Point AI assistant."
      },
      "accountPermissions": {
        "accountSettings": "Allow sub-account to access the Account settings page.",
        "billing": "Allow sub-account to access the Billing settings.",
        "autorechargeSettings": "Allow sub-account to access the Auto-recharge page.",
        "invoices": "Allow sub-account to access the Invoices page.",
        "subaccountSettings": "Allow sub-account to access the Sub-accounts page.",
        "messagingData": "Allow sub-account to access the Messaging data page.",
        "accountNotifications": "Allow sub-account to change notification settings."
      },
      "reportingPermissions": {
        "reportingOverview": "Allow sub-account to access the Reporting overview page.",
        "reportingMessages": "Allow sub-account to access the Messages reporting page.",
        "reportingCalls": "Allow sub-account to access the Calls reporting page.",
        "reportingStatements": "Allow sub-account to access the Statements page.",
        "reportingAuditLogs": "Allow sub-account to access the Audit logs page.",
        "reportingSubAccounts": "Allow sub-account to access the Sub-accounts reporting page.",
        "reportingNumbers": "Allow sub-account to access the Numbers reporting page.",
        "reportingEmails": "Allow sub-account to access the Email reporting pages."
      }
    },
    "sectionsTooltipForUsers": {
      "actionsPermissions": {
        "exportData": "Allow user account to export data from Textmagic.",
        "deleteData": "Allow user account to delete any data from Textmagic.",
        "importContacts": "Allow user account to import contacts to Textmagic.",
        "mobileApp": "Allow user account to log in using the mobile app for iOS and Android."
      },
      "messagingPermissions": {
        "scheduled": "Allow user account to access the Scheduled messages page.",
        "history": "Allow user account to access the History (Sent, Received, Forwarded calls) section.",
        "composeEmailPage": "Allow user account to send emails using the Compose Email page in the Web app.",
        "composePage": "Allow user account to send messages using the Compose page in the Web app.",
        "sendMms": "Allow user account to send MMS.",
        "byoc": "Allow user account to send SMS through their own connected CPaaS provider (BYOC)."
      },
      "channelsPermissions": {
        "buyNumbersSenderIds": "Allow user account to buy phone numbers and request Sender IDs.",
        "manageCpaasProviders": "Allow user account to manage CPaaS providers and their numbers.",
        "connectEmailDomains": "Allow user account to connect and verify sending domains for email campaigns.",
        "connectInboxes": "Allow user account to connect email inboxes used in the Tickets section.",
        "connectWhatsapp": "Allow user account to connect or disconnect the WhatsApp channel.",
        "connectFacebook": "Allow user account to connect or disconnect the Facebook Messenger channel.",
        "connectInstagram": "Allow user account to connect or disconnect the Instagram channel.",
        "connectChatWidget": "Allow user account to set up and manage the Chat widget."
      },
      "contactsPermissions": {
        "contacts": "Allow user account to access the Contacts (Lists, My contacts, Custom fields, Import, Blocked) section.",
        "resubscribe": "Allow user account to resubscribe contacts, who have been manually unsubscribed.",
        "createNewLists": "Allow user account to create new lists."
      },
      "servicesPermissions": {
        "emailToSms": "Allow user account to access and use the email to SMS feature.",
        "distributionLists": "Allow user account to access the Distribution lists feature.",
        "textToSpeechSettings": "Allow user account to access the Text-to-speech settings page.",
        "api": "Allow user account to access and use the SMS API Gateway feature.",
        "automationRules": "Allow user account to access the Automations feature.",
        "carrierLookup": "Allow user account to access and use the carrier lookup tool.",
        "subscribeForms": "Allow user account to access the Subscribe forms page.",
        "senderSettings": "Allow user account to edit Sender settings.",
        "makeCalls": "Allow user account to make a calls.",
        "emailLookup": "Allow user account to access and use the email lookup tool.",
        "verifyApi": "Allow user account to access and use the VerifyAPI.",
        "pointAi": "Allow user account to access and use the Point AI assistant."
      },
      "accountPermissions": {
        "accountSettings": "Allow user account to access the Account settings page.",
        "billing": "Allow user account to access the Billing settings.",
        "autorechargeSettings": "Allow user account to access the Auto-recharge page.",
        "invoices": "Allow user account to access the Invoices page.",
        "subaccountSettings": "Allow user account to access the Users page.",
        "messagingData": "Allow user account to access the Messaging data page.",
        "accountNotifications": "Allow user account to change notification settings."
      },
      "reportingPermissions": {
        "reportingOverview": "Allow user account to access the Reporting overview page.",
        "reportingMessages": "Allow user account to access the Messages reporting page.",
        "reportingCalls": "Allow user account to access the Calls reporting page.",
        "reportingStatements": "Allow user account to access the Statements page.",
        "reportingAuditLogs": "Allow user account to access the Audit logs page.",
        "reportingNumbers": "Allow user account to access the Numbers reporting page.",
        "reportingUsers": "Allow user account to access the Users reporting page.",
        "reportingEmails": "Allow user account to access the Email reporting pages."
      }
    },
    "users": "Users",
    "unavailableForUserRole": "This permission is unavailable for the User role"
  },
  "subAccountEditModal": {
    "title": "Edit sub-account",
    "titleForUsers": "Edit user",
    "fields": {
      "username": {
        "title": "Username",
        "placeholder": "Enter username"
      },
      "firstName": {
        "title": "First name",
        "placeholder": "Enter first name"
      },
      "lastName": {
        "title": "Last name",
        "placeholder": "Enter last name"
      },
      "phone": {
        "title": "Mobile number",
        "placeholder": "Enter mobile number"
      },
      "email": {
        "placeholder": "email{'@'}example.com"
      },
      "role": {
        "title": "Role"
      }
    }
  },
  "subAccountImportFlow": {
    "discard": "Cancel import"
  },
  "subAccountImportUpload": {
    "title": "Upload data",
    "subtitle": "Select a file with the users’ data that you want to invite to Textmagic.",
    "file": {
      "description": "Upload a file with users’ emails, names and other data."
    },
    "emails": {
      "title": "Copy and paste emails",
      "description": "Simply copy and paste multiple emails to invite multiple users at once (no field matching).",
      "placeholder": "Paste your emails here",
      "hint": "Paste one email per line or separated with commas."
    },
    "learnMoreText": "Read about the methods how you can invite team members."
  },
  "subAccountImportMatching": {
    "headersHidden": "Exclude the first row of the spreadsheet (column names) from the import"
  },
  "subAccountImportSettings": {
    "title": "Choose role",
    "subtitle": "Select a role for your new sub-accounts.",
    "subtitleFinished": "You have selected the {role} role for your new sub-accounts.",
    "roles": {
      "A": "Administrator",
      "U": "Regular user"
    }
  },
  "subAccountsImportDetailsRoleField": {
    "admin": {
      "label": "Administrator",
      "badge": "recommended"
    },
    "user": {
      "label": "Regular user"
    },
    "description": "{verb} manage sub-accounts and top up account.",
    "descriptionForUsersWorkflow": "{verb} manage other users and billing."
  },
  "subAccountImportProgress": {
    "title": "Invite sub-accounts",
    "subtitle": "Just leave it with us and we will invite your sub-accounts in the background. They will receive an invitation email soon.",
    "progressLabel": "Inviting in progress ({progress}%)...",
    "completeLabel": "{count} sub-account have been invited|{count} sub-accounts have been invited",
    "subtextProgress": "Big files processing can take time. You can close this tab and we will send you an email once the import has completed",
    "subtextComplete": "Your import has been completed. To see details please click the button below",
    "continue": "View results",
    "restart": "Start new import"
  },
  "tmBuyNumberCell": {
    "buyNumber": "Buy number"
  },
  "senderSettingsCountriesTypes": {
    "byoc": "{provider} number",
    "byocSenderId": "{provider} sender ID",
    "tmNumber": "Textmagic number",
    "sharedNumber": "Shared number",
    "ownMobile": "Own mobile"
  },
  "senderSettingsSearchResultsTable": {
    "title": "Search results"
  },
  "senderSettingsCountriesTableRowMobile": {
    "buyNumber": "Buy number"
  },
  "senderSettingsCountriesEditDefaultSenderModal": {
    "title": "Edit default sender"
  },
  "senderSettingsCountriesRestoreSettingsModal": {
    "title": "Restore default sender settings",
    "description": "Some of your changes might be overwritten when restoring default sender settings.",
    "successMessage": "The default sender settings have been successfully restored."
  },
  "voiceCallService": {
    "couldNotConnectYourCallTheNumberIsBusy": "Could not connect your call. The number is busy.",
    "couldNotConnectYourCall": "Could not connect your call.",
    "couldNotConnectYourCallPleaseTryAgainLater": "Could not connect your call. Please try again later or contact support.",
    "noPhoneNumberInIncomingCall": "No phone number in incoming call",
    "collapseCurrentCallInformation": "Collapse current call information",
    "expandCurrentCallInformation": "Expand current call information",
    "areYouSureYouWantToCloseThisPageYourActiveCallWillBeDisconnected": "Are you sure you want to close this page? Your active call will be disconnected",
    "outboundCall": "Outbound call",
    "inboundCall": "Inbound call",
    "chat": "Chat",
    "mute": "Mute"
  },
  "audioSettings": {
    "defaultDevice": "System Default Device",
    "inputDeviceLabel": "Microphone (input)",
    "outputDeviceLabel": "Speakers (output)",
    "title": "Audio settings",
    "testMic": "Test mic",
    "stopTestMic": "Stop test mic",
    "testSpeakers": "Test speakers",
    "accessDeniedWarning": "You can't change audio settings unless you give the webpage access to media devices"
  },
  "subAccountsDetailsOverview": {
    "title": "Audit logs"
  },
  "auditLogTableEmpty": {
    "title": "This user has no audit logs yet",
    "description": "Once this user has performed any actions, they will be displayed here."
  },
  "subAccountsImportDetailsFailedModal": {
    "title": "Edit import",
    "form": {
      "firstName": {
        "label": "First name",
        "placeholder": "Enter first name"
      },
      "lastName": {
        "label": "Last name",
        "placeholder": "Enter last name"
      },
      "phone": {
        "label": "Mobile number",
        "placeholder": "Enter mobile number"
      },
      "email": {
        "placeholder": "email{'@'}example.com"
      },
      "role": {
        "label": "Role"
      }
    },
    "success": "Sub-account has been invited successfully."
  },
  "tmUsersSelectDropdown": {
    "allAccounts": "All accounts ({count})"
  },
  "confirmEmailResolver": {
    "error": "The confirmation link is expired or invalid. Please try resending a new link from the account settings page."
  },
  "resetPassword": {
    "title": "Reset your password",
    "description": "Please create a new password for Textmagic",
    "email": {
      "label": "Textmagic account email"
    },
    "password": {
      "label": "New password",
      "placeholder": "Create a new password"
    },
    "confirm": {
      "label": "Confirm new password",
      "placeholder": "Confirm your new password"
    },
    "submit": "Reset password",
    "toLogin": {
      "text": "Remembered password?",
      "link": "Log in"
    }
  },
  "resetPasswordResolver": {
    "error": "The link is expired or invalid. Please try resending a new link."
  },
  "accountSsoDetails": {
    "title": "SAML details",
    "edit": "Edit SAML details",
    "entityId": "Identity provider Entity ID",
    "ssoService": "Identity provider SSO URL",
    "sloService": "Identity provider SLO URL",
    "x509Cert": {
      "label": "Public x509 certificate",
      "value": "Standard Strength Certificate (2048-bit)"
    },
    "forceSsoLogin": {
      "label": "Force SSO only",
      "sso": "SSO",
      "ssoAndPassword": "SSO and Textmagic password"
    }
  },
  "accountSsoDisable": {
    "alert": "If you would like to disable your Single Sign-On feature, please click on the link below. In that case no accounts will be able to log in using SSO anymore. If you are completely sure about disabling the SSO feature, please click here: {link}.",
    "disable": "Disable SSO feature"
  },
  "accountSsoTutorials": {
    "title": "Single Sign-On tutorials"
  },
  "accountSsoTutorial": {
    "view": "View guide"
  },
  "accountSsoEnable": {
    "title": "Enable Single Sign-On",
    "description": "Connect to a secure SSO portal to give access to all of your employees with one click, \nusing SAML authentication standard.",
    "submit": "Add SAML details"
  },
  "accountSsoDetailsModal": {
    "title": "SAML details",
    "entityId": {
      "label": "Identity provider Entity ID",
      "placeholder": "https://www.example.com/saml/metadata"
    },
    "ssoService": {
      "label": "Identity provider SSO URL",
      "placeholder": "https://www.example.com/saml/sso"
    },
    "sloService": {
      "label": "Identity provider SLO URL",
      "placeholder": "https://www.example.com/saml/slo"
    },
    "x509Cert": {
      "label": "Public x509 certificate",
      "placeholder": "Standard Strength Certificate (2048-bit)"
    },
    "forceSsoLogin": {
      "label": "Log in options",
      "sso": {
        "label": "SSO only",
        "description": "Allow users to login to Textmagic only via SSO"
      },
      "ssoAndPassword": {
        "label": "SSO, and Textmagic password",
        "description": "Allow, users to login to Textmagic via SSO and the account password"
      }
    },
    "successNotification": "SAML details has been successfully updated."
  },
  "accountSsoDetailsFormService": {
    "errors": {
      "entityId": "Please specify an Entity ID.",
      "ssoService": "Please specify an SSO URL.",
      "sloService": "Please enter a valid SLO URL.",
      "x509Cert": "Please specify a public x509 certificate."
    }
  },
  "forms": {
    "tabs": {
      "clickToText": "Click-to-text forms",
      "subscribes": "Subscribe forms"
    }
  },
  "formsToolbar": {
    "add": "Add new form",
    "searchPlaceholder": "Search forms"
  },
  "formsEmptyState": {
    "contact": {
      "title": "Embed a form on your website and start chatting with your customers",
      "description": "With click-to-text form, you can show your availability and improve customer communication.",
      "button": "Add new form"
    },
    "subscribe": {
      "title": "Embed a form on your website and start collecting mobile numbers",
      "description": "Boost your marketing by creating a customized web form that can be embedded on your website to collect mobile numbers from your visitors",
      "button": "Add new form"
    }
  },
  "unsubscribeReason": {
    "manual": "Manual",
    "blocked": "Blocked",
    "rule": "Rule",
    "stop": "Stop",
    "spam": "Spam",
    "auto": "Auto",
    "complaint": "Complaint",
    "automation": "Automation"
  },
  "fieldCountriesList": {
    "add": "Add new country",
    "all": "All countries"
  },
  "fieldPageUrlRules": {
    "constraints": {
      "contains": "URL contains",
      "doesNotContain": "URL doesn’t contain",
      "startsWith": "URL starts with",
      "endsWith": "URL ends with",
      "equalsTo": "URL equals to",
      "doesNotEqualTo": "URL doesn’t equal to"
    },
    "add": "Add rule"
  },
  "mockAlert": "This page use mocked data to present content.",
  "fieldSelectColumn": {
    "defaultButtonText": "number(s)",
    "addOne": "Add {text}",
    "addAll": "Add all",
    "removeOne": "Remove {text}",
    "removeAll": "Remove all"
  },
  "fieldLabelAutocomplete": {
    "session": "{number} session | {number} sessions",
    "createNewLabel": "Create new label"
  },
  "headerSubAccount": {
    "loggedIn": "Logged in as {name} ({login})."
  },
  "contactListsEmpty": {
    "title": "Organize your contacts into lists",
    "description": "Improve your SMS communication by sorting all your contacts in your database into different groups and lists.",
    "button": "Create new list"
  },
  "unsubscribedEmpty": {
    "title": "You have no unsubscribed contacts yet",
    "description": "When someone opts out from your messages, these numbers will be displayed here."
  },
  "unsubscribedEmailEmpty": {
    "title": "No email contacts have been unsubscribed yet",
    "description": "Your unsubscribed contacts will appear here. Stay connected and track opt-outs to maintain a clean and engaged contact list."
  },
  "unsubscribedEmailReason": {
    "manual": "This email has been manually unsubscribed by the workspace user.",
    "linkClick": "This email has been unsubscribed by clicking the unsubscribe link.",
    "hardBounce": "Delivery failed permanently. Sending is blocked to protect your sender reputation.",
    "softBounce": "Delivery failed after several attempts. Sending is blocked to prevent further bounces and reputation damage.",
    "spam": "This email was marked as spam by the recipient. Future messages won’t be delivered.",
    "roleBased": "This email was identified as role-based, and not a personal inbox during an email lookup (cleanup) session.",
    "disposable": "This email was identified as disposable or temporary inbox during an email lookup (cleanup) session.",
    "undeliverable": "This email was identified as invalid or undeliverable during an email lookup (cleanup) session.",
    "automation": "This email was unsubscribed by an automation."
  },
  "tmUnsubscribedEmailReasonCell": {
    "reason": {
      "manual": {
        "title": "Manual"
      },
      "linkClick": {
        "title": "Link click"
      },
      "hardBounce": {
        "title": "Hard bounce"
      },
      "softBounce": {
        "title": "Soft bounce"
      },
      "spam": {
        "title": "Spam"
      },
      "roleBased": {
        "title": "Role-based"
      },
      "disposable": {
        "title": "Disposable"
      },
      "undeliverable": {
        "title": "Undeliverable"
      },
      "automation": {
        "title": "Automation"
      },
      "unknownReason": {
        "title": "Unknown reason"
      }
    }
  },
  "contactImportUnsubscribedEmailReason": {
    "roleBased": "Role-based email address, not a personal inbox.",
    "disposable": "Disposable or temporary email address.",
    "undeliverable": "Invalid or undeliverable email address.",
    "unknownReason": "Unknown reason."
  },
  "blockedContactsEmpty": {
    "title": "You have no blocked contacts yet",
    "description": "You can add blocked numbers or contacts with the button below.",
    "button": "Add blocked number"
  },
  "contactListDetailsEmpty": {
    "title": "Import your contacts to Textmagic.",
    "description": "Supported file types for import are Excel (.xls or .xlsx) and CSV (.csv).",
    "addContact": "Add contact",
    "or": "or",
    "import": "Import contacts"
  },
  "faq": {
    "title": "Frequently asked questions",
    "description": "Haven’t found what you were looking for? {contact}"
  },
  "tollFreeCaFaq": [
    {
      "question": "When and why choose a toll-free number for texting?",
      "answer": [
        "We recommend choosing the toll-free number because it covers the broadest range of messaging {useCases} in the USA and Canada. These numbers also support high throughput compared to local numbers, which makes them perfect for all sorts of business communications, whether it's one-on-one conversations, marketing campaigns, multimedia messages, or phone calls.",
        "You should consider choosing a toll-free number if any of the following apply:"
      ],
      "useCases": "use cases",
      "categories": "categories",
      "options": [
        "Your business does NOT have a Tax ID (EIN number), or you are a sole proprietor.",
        "One of the {categories} of the toll-free campaigns matches your use case.",
        "You plan to send marketing messages and need a high throughput.",
        "You want to send messages to the USA and Canada."
      ]
    },
    {
      "question": "Why do I need to complete a toll-free number verification?",
      "answer": [
        "Verifying your toll-free number isn't just a Textmagic rule; it's an {requirement} and a trust-building measure created to protect consumers from unwanted spam and fraud.",
        "U.S. carriers, the messaging aggregator, and Textmagic will block messages that are sent from unverified toll-free numbers and do not comply with regulations.",
        "In other words, without completing this mandatory traffic verification for your toll-free number, your text messages will not be delivered. "
      ],
      "requirement": "industry-wide requirement"
    },
    {
      "question": "What campaign types can I send using Textmagic toll-free numbers?",
      "answer": [
        "Currently, the toll-free messaging aggregator allows the registration of 43 use cases. The complete list is {link}.",
        "As best practice, please send texts only to people who have explicitly “opted in” to receive texts from your company."
      ],
      "here": "here"
    }
  ],
  "gettingStarted": {
    "title": "Getting started",
    "description": "To send text messages, you need to buy a virtual number, verify your brand and use case, and get approved by the mobile network operators. Once your messaging traffic has been approved, you can send and receive SMS, MMS, and voice calls.",
    "tenDlcNumber": "10DLC number",
    "tollFreeNumber": "Toll-free number",
    "tenDlcNumbersApproved": "10-digit local U.S. numbers approved by the mobile network operators for sending texts.",
    "tollFreeNumbersApproved": "8XX prefix numbers for U.S. and Canada verified for sending texts by the messaging aggregator.",
    "taxIdRequired": "Tax ID (EIN number) required",
    "taxIdNotRequired": "Tax ID (EIN number) {not} required",
    "not": "not",
    "paidRegistration": "Paid registration + {fees}",
    "fees": "quarterly fees",
    "freeRegistration": "Free registration",
    "trafficWhitelisted": "Traffic whitelisted {operators}",
    "operators": "with the mobile operators",
    "trafficVerified": "Traffic verified with the {aggregator}",
    "aggregator": "messaging aggregator",
    "approvalPeriod": "Approval period {varies}",
    "varies": "varies",
    "twoWaySms": "2-way SMS, MMS and voice supported",
    "minimumCredit": "Minimum initial credit required: {price}",
    "minimumTollFreeCredit": "Minimum initial credit required: {currency}20",
    "enoughCredit": "You have enough credit to get started",
    "notEnoughCredit": "You don't have enough credit to get started",
    "applicationSubmitted": "Your application has been submitted",
    "getTenDlcNumber": "Get 10DLC number",
    "getTollFreeNumber": "Get toll-free number",
    "chooseTenDlcNumber": "You can choose your number with the local area code prefix. The 10DLC registration fees apply.",
    "chooseTollFreeNumber": "You can choose your toll-free number with the 8XX prefix. The verification is free.",
    "registrationRequired": "Registration Required",
    "messagingRegistration": "10DLC and toll-free messaging registration is {requirement}",
    "industryRequirement": "an industry-wide requirement. ",
    "industryMoving": "The industry is moving to {traffic} to fight spam and fraud. Registration cannot be skipped.",
    "traffic": "100% registered messaging traffic",
    "tenDlcAfterPayment": "After payment, you can choose your 10DLC number with the local area code.",
    "tollFreeAfterPayment": "After payment, you can choose your toll-free number with the 8XX prefix.",
    "tenDlcCanBuy": "You can choose your number with the local area code prefix. The 10DLC registration fees apply.",
    "tollFreeCanBuy": "You can choose your toll-free number with the 8XX prefix. The verification is free.",
    "tenDlcComplete": "Please complete your 10DLC brand and campaign registration to start sending messages.",
    "tollFreeComplete": "Please complete your toll-free registration to start sending messages.",
    "upToFiveWeeks": "Please allow up to 5 weeks for your form to be reviewed. Then, you can start sending text messages.",
    "buyCredit": "Buy credit now",
    "completeRegistration": "Complete registration",
    "viewStatus": "View application status",
    "fixIssues": "Fix issues",
    "localCanadianNumber": "Local Canadian number",
    "chooseCanadianNumber": "You can choose your number with the local area code prefix.",
    "tenDlcCanadian": "10-digit local Canadian numbers for sending and receiving text messages and voice calls.",
    "noBulkText": "No bulk and promotional texts allowed",
    "noRegistrationRequired": "No registration required",
    "p2p": "Peer-to-peer single messages only",
    "mmsNotSupported": "MMS not supported",
    "brandAndVetting": "Brand registration + vetting: {price}",
    "brandRegistration": "Brand registration: {price}",
    "oneTimeFee": "(one time fee)",
    "campaignRegistration": "Campaign registration: {price}",
    "perQuarter": "per quarter",
    "numberCost": "Number cost: {price}",
    "perMonth": "per month",
    "upToWeeks": "up to 5 weeks",
    "free": "Free",
    "actionRequired": "Action required"
  },
  "contactList": {
    "noMatchingResults": "There are no visible lists.",
    "refineRequest": "Please unhide some of the lists or create a new one to see the results."
  },
  "headerAlertOldVersion": {
    "text": "A new version of Textmagic is available.",
    "refresh": "Update now"
  },
  "headerAlertOffline": {
    "text": "Connection lost. Please check your internet connection."
  },
  "headerAlertAsyncLoadFailed": {
    "text": "Part of this page didn't load correctly due to connection issues."
  },
  "importMatchingAlert": {
    "text": "Please match \"{fieldName}\" field with your import file.",
    "textOr": "Please match at least one of these fields {fields} with your import file."
  },
  "fieldSelectSearchUser": {
    "allAccounts": "All accounts ({count})"
  },
  "fieldSelectSearchCountry": {
    "placeholder": "- Select country -"
  },
  "fieldAutomationRulesAction": {
    "add": "Add a new action"
  },
  "fieldFullName": {
    "placeholderFirstName": "Enter first name",
    "placeholderLastName": "Enter last name"
  },
  "systemExitResolver": {
    "successNotification": "You were logged out. Please log in again."
  },
  "attachmentPreview": {
    "title": "Attachment preview",
    "pleaseDownloadTheFileToViewIt": "Please download the file to view it",
    "currentlyThePreviewOfFilesIsNotSupported": "Currently, the preview of { extension } files is not supported.",
    "pleaseDownloadTheOriginalFileToOpenIt": "Please download the original file to open it."
  },
  "composeMessagesBulksProgressModal": {
    "title": "Campaign in progress...",
    "titleError": "Campaign was not sent",
    "description": "Your SMS campaign will be completed in the background. Feel free to close this window.",
    "alertTitle": "Your message has been successfully sent to {recipients} recipients.",
    "connectionIsUnstable": "Connection is unstable. All messages will be processed and sent in the background. You can later check the details from the history page.",
    "errorMessage": "Sorry, but you do not have enough credit to send this message. Please buy credit now and send a message once again.“ message should be displayed",
    "notEnoughMoneyMessage": "Sorry, we could not send the session because you do not have enough credit on your account. Please {buyCredit} and try sending the message again.",
    "buyCredit": "buy credit",
    "rejectReason": {
      "sessionRejected": "Session fully rejected, mixed/unknown reject reason.",
      "lowBalance": "Not enough credit to send the session.",
      "noRecipients": "No valid recipients in the session.",
      "invalidRecipients": "Invalid phone number / recipient.",
      "emptyText": "Message text empty or became empty after tag replacement.",
      "unexpectedError": "Unexpected processing error.",
      "forbiddenCountry": "Your account does not have permission to send messages to this country. Please contact support for more details.",
      "blocked": "This contact has been blocked.",
      "unsubscribed": "This contact has unsubscribed from your lists.",
      "invalidNumber": "The recipient number is invalid or missing.",
      "invalidFrom": "The sender number is invalid or missing. Please check your sender settings and try again.",
      "notUsFromNumber": "To activate sending to this country please buy a number.",
      "badFrFromNumber": "To activate sending to this country please buy a number.",
      "badAeFromNumber": "To activate sending to this country, please connect a CPaaS provider using the BYOC feature.",
      "regulationTm": "To activate sending to this country, please connect a CPaaS provider using the BYOC feature.",
      "regulationAu": "Messages to Australia can only be sent from an Australian dedicated virtual number or an alphanumeric Sender ID…",
      "regulationGb": "Messages to the United Kingdom can only be sent from a UK dedicated virtual number or an alphanumeric Sender ID…",
      "shortLinkInText": "Messages that contain publicly available URL shorteners are rejected. Please avoid using short links.",
      "surveyNondedicated": "The SMS Survey feature is not supported in this country.",
      "ttsNotLvnFromNumber": "Voice message must be sent from a voice enabled number.",
      "rejectedMms": "MMS message must be sent from a USA toll-free number.",
      "userVonageCarrierMmsFileExtensionRejected": "The file format in the message is not supported.",
      "userCarrierMmsNotSupported": "Textmagic doesn't support MMS for this CPaaS provider.",
      "tollFreeUnverified": "Please complete the toll-free verification to send messages from this number.",
      "tenDlcUnverified": "Please complete the 10DLC registration to send messages from this number.",
      "tenDlcRejected": "Your 10DLC registration was rejected. Please review your registration details and submit it again.",
      "sendingDisabledOnAccount": "Message rejected by Textmagic. Please contact support for more details.",
      "paidServicesDisabled": "Paid services are disabled on your account. Please contact support for more details.",
      "byocTwilio": "The Twilio CPaaS provider has rejected your message. Please check the log details on their end.",
      "byocVonage": "The Vonage CPaaS provider has rejected your message. Please check the log details on their end.",
      "byocSinch": "The Sinch CPaaS provider has rejected your message. Please check the log details on their end.",
      "notActiveUserCarrierProvider": "There is an authorization issue with your connected CPaaS provider. Please update the provider's credentials.",
      "notActiveUserCarrierPhone": "The linked number is unavailable for use in Textmagic. Please check with your provider.",
      "notActiveUserCarrierSenderId": "The linked Sender ID is unavailable for use in Textmagic. Please check with your provider.",
      "userHasNotByocAccess": "Your BYOC free trial has expired. Please choose a plan to continue using this service.",
      "userCarrierPhoneHasNotCapability": "The BYOC number you selected doesn't support SMS. Please connect a different number with SMS capabilities.",
      "notExistUserCarrierSender": "The sender's number was deactivated before the message was sent.",
      "unsupported": "Please contact support."
    }
  },
  "composeMessagesBulksProgress": {
    "sendingTextMessages": "Sending text messages... ({progress}%)",
    "messagesSent": "Messages sent",
    "totalMessages": "Total messages",
    "notEnoughMoneyMessage": "Your campaign was not sent because you do not have enough credit on your account.",
    "notEnoughMoneyMessageTitle": "Too low balance to send campaign"
  },
  "composeMessagesBulksProgressPopup": {
    "sendingCampaign": "Sending campaign... ({progress}%)"
  },
  "tmParticipantSenderId": {
    "senderId": "(Sender ID)"
  },
  "formDetailsSidebar": {
    "errorNotification": "We could not update the {fullName} contact. <a href=\".\">Please reload the contact detail page</a> to see the latest data."
  },
  "attachment": {
    "title": "Please download the file to view it",
    "subtitle": "The preview of <b>.{fileFormat}</b> files is not supported.",
    "info": "This file was sent using {textmagic}.\nIn case of any issues, please {support}.",
    "textmagic": "Textmagic",
    "size": "Size: {weight}"
  },
  "editVerifyingEmailModal": {
    "title": "Edit email address ",
    "description": "If you’d like to change your email address from {email} to a new one, please enter the new email in the field below. We will resend a verification code to the new address.",
    "form": {
      "label": "New email address",
      "placeholder": "Enter new email address",
      "validationMessage": "Please enter a valid email address.",
      "button": "Save and resend",
      "buttonLoading": "@:common.saving",
      "errors": {
        "forbidden": "This email cannot be used. Please use a different email address.",
        "needVerifyEmail": "This email address is already registered in our system.",
        "invalidEmail": "Please enter your corporate/work email address."
      }
    },
    "notifySuccess": "Your email has been successfully updated, and the 6-character code has been resent. Please check your inbox."
  },
  "verificationCodeModal": {
    "title": "Confirm email change",
    "email": "For your security, we have sent a 6-digit code to",
    "enterCode": "Enter the verification code below:",
    "noResponse": "Didn’t get the verification code?",
    "resendCode": "Resend code"
  },
  "emailVerificationModal": {
    "title": "Confirm email change",
    "alert": "You will be {loggedOut} of your account after confirming your email change with the verification code.",
    "loggedOut": "logged out",
    "success": "The email has been successfully changed.",
    "resendSuccess": "We have sent you a verification email. Please check your inbox."
  },
  "passwordVerificationModal": {
    "title": "Confirm password change",
    "success": "The password has been successfully changed.",
    "tooManyRequests": "You've entered the wrong code too many times. Please wait a moment and try again from start.",
    "resendSuccess": "We have sent you a verification SMS. Please check your phone."
  },
  "yourAccountPermissionsHaveChangedNotification": "Your account permissions have changed. For more information, please contact your Textmagic account administrator.",
  "accountBalanceCriticallyLowModal": {
    "title": "Account balance is critically low",
    "description": "Please be aware that your Textmagic numbers and other subscriptions may be canceled if your balance is insufficient to renew them on their renewal date(s).",
    "balanceRemaining": "Balance remaining: {balance}"
  },
  "payment": {
    "thankYouForRequestingTheSenderId": "Thank you for requesting the Sender ID. We will process your order and assign the requested Sender ID within 5-7 business days."
  },
  "contactImportMatching": {
    "previousMatched": "Match columns according to previous import.",
    "headersHidden": "Exclude the first row of the spreadsheet (column names) from the import"
  },
  "numberIsAlreadyTakenError": "Sorry, but this number is already taken. Please choose a different one.",
  "gettingStartedByocFeature": {
    "title": "Connect your SMS provider",
    "description": "Connect your number from Twilio, Sinch, Vonage, or Bandwidth.",
    "buttonTitle": "Connect provider"
  },
  "gettingStartedUsWhatsFeature": {
    "title": "WhatsApp",
    "description": "Reply to customer messages on WhatsApp and keep all chats in one place."
  },
  "gettingStartedLiveChatFeature": {
    "title": "Live chat",
    "description": "Add a chat widget to your website and let customers contact you instantly."
  },
  "gettingStartedSharedEmailFeature": {
    "title": "Shared email inbox",
    "description": "Connect your inbox and handle customer emails together with your team."
  },
  "gettingStartedFacebookFeature": {
    "title": "Facebook",
    "description": "Connect your Facebook page to answer customer messages faster."
  },
  "gettingStartedInstagramFeature": {
    "title": "Instagram",
    "description": "Manage and reply to messages from your Instagram followers in one view."
  },
  "gettingStartedFullClickableFeature": {
    "getStarted": "Get started"
  },
  "gettingStartedOtherOptionsForSms": {
    "title": "Other options for SMS"
  },
  "tollFreeUsFaq": [
    {
      "question": "When and why choose a toll-free number for texting?",
      "answer": [
        "We recommend choosing the toll-free number because it covers the broadest range of messaging {useCases} in the USA and Canada. These numbers also support high throughput, compared to 10DLC, which makes them perfect for all sorts of business communications, whether it's one-on-one conversations, marketing campaigns, multimedia messages, or phone calls.",
        "You should consider choosing a toll-free number if any of the following apply:"
      ],
      "useCases": "use cases",
      "categories": "categories",
      "options": [
        "Your business does NOT have a Tax ID (EIN number), or you are a sole proprietor.",
        "One of the {categories} of the toll-free campaigns matches your use case.",
        "You plan to send marketing messages and need a high throughput.",
        "You want to send messages to the USA and Canada."
      ]
    },
    {
      "question": "Why do I need to complete a toll-free number verification?",
      "answer": [
        "Verifying your toll-free number isn't just a Textmagic rule; it's an {requirement} and a trust-building measure created to protect consumers from unwanted spam and fraud.",
        "U.S. carriers, the messaging aggregator, and Textmagic will block messages that are sent from unverified toll-free numbers and do not comply with regulations.",
        "In other words, without completing this mandatory traffic verification for your toll-free number, your text messages will not be delivered. "
      ],
      "requirement": "industry-wide requirement"
    },
    {
      "question": "What campaign types can I send using Textmagic toll-free numbers?",
      "answer": [
        "Currently, the toll-free messaging aggregator allows the registration of 43 use cases. The complete list is {link}.",
        "As best practice, please send texts only to people who have explicitly “opted in” to receive texts from your company."
      ],
      "here": "here"
    }
  ],
  "gettingStartedLayout": {
    "title": "Welcome to Textmagic! {icon}",
    "description": ["Let's get you set up with all your communication channels in just a few steps."],
    "gettingStartedFaq": "getting started FAQ",
    "faq": {
      "title": "Getting started FAQ"
    }
  },
  "gettingStartedLayoutAll": {
    "byocFeatureDescription": "Connect your existing numbers from your CPaaS provider to Textmagic using our BYOC service. The setup is quick, enabling you to begin texting in minutes.",
    "byocFeatureRequiredDescription": "CPaaS provider API key is required."
  },
  "gettingStartedNumberFeature": {
    "buttons": {
      "setCallForwarding": "Set up call forwarding"
    },
    "qr": {
      "title": "SMS QR Code",
      "tooltip": "Scan this QR code to text your virtual number."
    },
    "available": "available",
    "comingSoon": "coming soon"
  },
  "gettingStartedUsCaNumberFeature": {
    "title": "Your TOLL-FREE NUMBER",
    "description": [
      "We've assigned a toll-free number to your account for 1 month for free, so you can start engaging with your audience sooner. Please {complete} to start texting.",
      "complete a free verification"
    ],
    "WeAddedTollFreeNumberToYourAccount": "We’ve added a toll-free number to your account. Please complete verification to activate texting and start engaging with your audience.",
    "buttonCompleteVerification": "Complete verification",
    "buttonCompleteRegistration": "Complete registration",
    "buttonViewStatus": "View status"
  },
  "gettingStartedCaLocalWithoutNumber": {
    "title": "Get a local number",
    "description": [
      "Local numbers support one-on-one (P2P) texting only and {messaging} in Canada.",
      "Please {support} to request a number."
    ],
    "chooseNumber": "Choose your local number",
    "massMessaging": "can’t be used for mass messaging"
  },
  "gettingStartedAuUkNumberFeature": {
    "title": "Your Textmagic number",
    "description": "We've assigned a virtual number to your account for {free}, so you can start engaging with your audience sooner. You can start texting right away.",
    "useYourVirtualNumberToSendMessages": "Use your virtual number to send messages and engage with your audience right away.",
    "monthForFree": "1 month for free",
    "buttonNewMessage": "New text message"
  },
  "gettingStartedAuUkSenderFeature": {
    "title": "Get a Sender ID",
    "description": ["Elevate your brand by sending texts from your company name for {cost}/month."],
    "chooseYourSenderId": "Choose Sender ID"
  },
  "gettingStartedUsCaSmsFaq": [
    {
      "question": "Which Textmagic number should I choose?",
      "answer": [
        "We recommend a **toll-free number** for most businesses messaging customers in the US and Canada. It supports higher sending volumes and is a great choice for different campaign types and bulk messaging.",
        "If your business is in the US and you prefer a local presence, you can also choose a **10DLC number** with a recognizable US area code. Local Textmagic numbers are not available for Canadian businesses.",
        "Both toll-free and 10DLC numbers must be verified or registered before you can start messaging."
      ],
      "links": ["Learn more about texting in the US and Canada"]
    },
    {
      "question": "Can I bring my existing number?",
      "answer": [
        "Yes. If you already have numbers with a supported CPaaS provider, you can connect them to Textmagic instead of getting new Textmagic numbers.",
        "Textmagic supports **Twilio, Sinch, Vonage, and Bandwidth**. You can keep your existing numbers, provider, messaging rates, and routes while using Textmagic’s messaging features.",
        "Your numbers must already meet the applicable registration or verification requirements with your provider."
      ],
      "links": ["Learn more about bringing your own CPaaS numbers"]
    },
    {
      "question": "Do I need to register or verify my number before sending messages?",
      "answer": [
        "Yes. Registration and verification are industry-wide requirements for business messaging in the US and Canada. They help messaging providers verify legitimate businesses, protect consumers, and reduce spam and fraud.",
        "**Toll-free numbers** require verification, while **US 10DLC numbers** require brand and campaign registration."
      ],
      "links": ["Learn more about 10DLC registration", "Learn more about toll-free verification"]
    },
    {
      "question": "What information do I need to register or verify my number?",
      "answer": ["You’ll need to provide information about your business and how you plan to use SMS, including:"],
      "options": [
        "Your business details and website.",
        "Your messaging use case.",
        "Sample messages.",
        "Your SMS opt-in method and proof of consent.",
        "A publicly accessible Privacy Policy.",
        "Publicly accessible SMS Terms and Conditions."
      ],
      "note": [
        "The exact requirements depend on whether you’re registering a US 10DLC number or verifying a toll-free number."
      ],
      "links": ["10DLC registration guide", "Toll-free verification guide"]
    },
    {
      "question": "What are the SMS opt-in and consent requirements?",
      "answer": [
        "You must get permission from recipients before sending them SMS messages.",
        "Your opt-in process should clearly explain **who is sending the messages and what types of messages recipients are agreeing to receive**. Recipients should actively provide their consent, and you should keep proof of how consent was collected.",
        "For online forms, recipients should actively opt in, for example, by selecting an **unchecked checkbox**. Your opt-in should also provide access to your Privacy Policy and SMS Terms and explain how recipients can opt out."
      ],
      "links": ["Learn more about acceptable SMS consent methods"]
    },
    {
      "question": "What should a compliant Privacy Policy and SMS Terms include?",
      "answer": [
        "For US messaging registration and verification, you need a publicly accessible **Privacy Policy** and **SMS Terms and Conditions**.",
        "Your **Privacy Policy** should:"
      ],
      "privacyPolicyOptions": [
        "Explain what personal information you collect and how you use it.",
        "State that mobile opt-in information will not be shared with third parties or affiliates for marketing or promotional purposes.",
        "Be publicly accessible through a valid URL on your business domain."
      ],
      "smsTermsTitle": ["Your **SMS Terms** should include:"],
      "smsTermsOptions": [
        "Your brand and a description of your messaging program.",
        "Message frequency.",
        "A “Message and data rates may apply” disclosure.",
        "Customer support information.",
        "Clear **HELP** and **STOP** instructions.",
        "A link to your Privacy Policy.",
        "Be publicly accessible through a valid URL on the **same business domain**."
      ],
      "note": [
        "Your website, Privacy Policy, and SMS Terms should use the **same business domain** provided during registration or verification.",
        "You can use our samples as a starting point and customize them with your business information before publishing."
      ],
      "links": ["Sample SMS Privacy Policy", "Sample SMS Terms and Conditions"]
    }
  ],
  "gettingStartedOtherChannelsFaq": [
    {
      "question": "What other channels can I connect?",
      "answer": [
        "You can connect multiple customer communication channels, including **Live Chat, a shared email inbox, WhatsApp, Facebook, and Instagram**.",
        "Once connected, your team can manage customer conversations in one place without switching between different platforms.",
        "For **Meta channels — WhatsApp, Facebook, and Instagram — Textmagic supports receiving incoming messages and replying to them**. You can’t initiate new conversations through these channels."
      ],
      "links": ["Explore Textmagic features"]
    },
    {
      "question": "How do I set up Live Chat on my website?",
      "answer": [
        "Create a **chat widget**, customize it, and add the provided code to your website.",
        "The widget lets visitors start a Live Chat with your team and can also offer other contact options, including **SMS, WhatsApp, email, and calls**. You can choose which channels to display and customize where and when the widget appears.",
        "Live Chat conversations appear in **Messenger**, where your team can respond from one place."
      ],
      "links": ["Learn more about setting up the chat widget"]
    },
    {
      "question": "How do I connect a shared email inbox?",
      "answer": [
        "You can connect your business email and manage incoming customer emails together with your team.",
        "Incoming emails are automatically converted into **Tickets**, where your team can assign, prioritize, track, and reply to customer requests from a shared workspace."
      ],
      "links": ["Learn more about setting up your shared email inbox"]
    },
    {
      "question": "How do I connect WhatsApp?",
      "answer": [
        "Connect your **WhatsApp Business account** using your Meta account. You can connect an existing WhatsApp Business number or set up a new one during the connection process.",
        "Once connected, you can **receive and reply to WhatsApp messages directly in Messenger**."
      ],
      "links": ["Learn more about connecting WhatsApp"]
    },
    {
      "question": "How do I connect Facebook?",
      "answer": [
        "Connect a **Facebook Page** using a Facebook account that has admin access to the Page and grant the required permissions.",
        "Once connected, you can **receive and reply to Facebook messages directly in Messenger**, where your team can manage conversations together."
      ],
      "links": ["Learn more about connecting Facebook"]
    },
    {
      "question": "How do I connect Instagram?",
      "answer": [
        "Connect your **Instagram Business or Creator account**. You’ll need admin access to the Instagram account you want to connect.",
        "Once connected, you can **receive and reply to Instagram messages directly in Messenger**, where your team can manage conversations together."
      ],
      "links": ["Learn more about connecting Instagram"]
    }
  ],
  "gettingStartedTabs": {
    "sms": "SMS",
    "email": "Email",
    "otherChannels": "Other channels",
    "tollFree": "Toll-free numbers",
    "byoc": "CPaaS integrations",
    "virtualNumbers": "Virtual numbers",
    "senderId": "Sender IDs",
    "whatsApp": "WhatsApp",
    "liveChat": "Live chat",
    "facebook": "Facebook"
  },
  "gettingStartedUs": {
    "tabs": {
      "tollFree": "Toll-free numbers",
      "10dlc": "10DLC numbers"
    },
    "freeForMonth": "FREE FOR 1 MONTH",
    "free": "FREE",
    "freeForMonthTollFreeTooltip": [
      "The first toll-free number is free for 1 month, later {cost} per month / number. ",
      "The toll-free verification is totally free forever."
    ],
    "freeTollFreeTooltip": [
      "The first toll-free number is included in your current plan, each extra number costs {cost} per month / number.",
      "The toll-free verification is totally free forever."
    ],
    "freeForMonthTenDlcTooltip": [
      "The first 10DLC number is free for 1 month, later {cost} per month / number.",
      "The 10DLC brand and campaign initial vetting + registration is free.",
      "The first 10DLC campaign is free for 1 month, later {cost} per month / campaign."
    ],
    "freeTenDlcTooltip": [
      "The first 10DLC number is included in your current plan, each extra number costs {cost} per month / number.",
      "The 10DLC brand and campaign initial vetting + registration is free.",
      "The first 10DLC campaign is free for 1 month, later {cost} per month / campaign."
    ]
  },
  "gettingStartedAuUk": {
    "freeForMonthTooltipText": ["The first texting number is free for 1 month, later {cost} per month / number."],
    "freeTooltipText": [
      "The first texting number is included in your current plan, each extra number costs {cost} per month / number. "
    ]
  },
  "gettingStartedCaLocalFeature": {
    "freeForMonthTooltip": "The first local number is free for 1 month, later {cost} per month / number.",
    "freeTooltip": "The first local number is included in your current plan, each extra number costs {cost} per month / number."
  },
  "gettingStartedDefaultFeature": {
    "comingSoon": "COMING SOON"
  },
  "gettingStartedPreloader": {
    "description": "Please wait while we are loading your information."
  },
  "gettingStartedUsTenDlcNumberFeature": {
    "title": "Your 10DLC NUMBER",
    "description": [
      "Before you can start sending texts, you must",
      "register your brand and campaign.",
      "This is an industry-wide requirement applicable to all businesses sending text messages to the U.S."
    ],
    "buttonViewStatus": "View status",
    "buttonCompleteRegistration": "Complete registration"
  },
  "gettingStartedCaLocalNumberFeature": {
    "title": "Your local number",
    "description": [
      "Before you can start sending texts, you must",
      "register your brand and campaign.",
      "This is an industry-wide requirement applicable to all businesses sending text messages to the U.S."
    ]
  },
  "gettingStartedUsCaRejectedReason": {
    "description": [
      "We were unable to verify your application. Please fix the errors below and resubmit the form again."
    ],
    "buttonFixIssues": "Fix issues and resubmit"
  },
  "gettingStartedCa": {
    "tabs": {
      "tollFree": "Toll-free numbers",
      "localNumbers": "Local numbers"
    }
  },
  "gettingStartedWithoutNumber": {
    "title": "Get a Textmagic number",
    "description": ["Choose your number from our available pool of numbers."],
    "chooseYourTextingNumber": "Choose number"
  },
  "gettingStartedUsWithoutNumber": {
    "chooseNumber": "Choose number",
    "tollFree": {
      "title": "Get a toll-free number",
      "description": "Send and receive business texts across the U.S. and Canada."
    },
    "tenDlc": {
      "title": "Get a local number (10DLC)",
      "description": "Text customers using a local U.S. number with your area code."
    }
  },
  "gettingStartedSetUpSmsSendingExpansionItem": {
    "title": "Send SMS"
  },
  "gettingStartedEmailSending": {
    "title": "Send email campaigns"
  },
  "gettingStartedMoreChannels": {
    "title": "Other channels"
  },
  "gettingStartedConnectYourEmail": {
    "title": "Connect your email domain ",
    "description": ["Get started with email campaigns in a few clicks."],
    "connectYourDomain": "Connect domain"
  },
  "gettingStartedGetDomain": {
    "title": "Don't have a domain?",
    "description": "Get a domain now and start sending emails in minutes.",
    "buttonText": "Get a new domain"
  },
  "gettingStartedGetNewDomain": {
    "title": "Don't have a domain?",
    "description": "{link} and start sending emails in minutes.",
    "link": "Get a domain now"
  },
  "gettingStartedQrCode": {
    "title": "SMS QR Code",
    "message": "Hello, this is a message to Textmagic number"
  },
  "gettingStartedAuVirtualNumbersFaq": [
    {
      "question": "What is a virtual number, and how does it work?",
      "answer": [
        "A Textmagic virtual number is a phone number that allows users to call, send, and receive text messages through the Textmagic platform.",
        "When you sign up, you'll get an Australian virtual number for the first month for free. This number is designed to work only with Australian mobile subscribers. It cannot receive 2FA/verification texts sent by other services.",
        "We recommend using the virtual number because it is perfect for all sorts of business communications, whether it's one-on-one conversations, marketing campaigns, or making phone calls."
      ]
    },
    {
      "question": "What is the difference between a virtual number and a Sender ID?",
      "answer": [
        "The virtual number and Sender ID serve different purposes and have distinct functions:",
        [
          "The {number} supports calls and two-way texting for various purposes like marketing, two-way SMS chats, customer alerts, and staff communication.",
          "The {sender} is designed for one-way outbound texting without reply capabilities. It is suitable for use cases like marketing campaigns and sending important announcements where responses are unnecessary."
        ]
      ],
      "virtualNumber": "virtual number",
      "senderId": "Sender ID"
    },
    {
      "question": "How can I get started with sending texts from a virtual number?",
      "answer": [
        "When you sign up, you'll get an Australian virtual number for the first month for free. You can start texting instantly via the {compose} and {chats} pages."
      ],
      "compose": "Compose",
      "chats": "Chats"
    },
    {
      "question": "Can I port in my existing virtual number to Textmagic?",
      "answer": [
        "Textmagic does not offer number porting in Australia. Please use our local dedicated virtual number or a Sender ID."
      ]
    },
    {
      "question": "Can I send text messages from my own mobile number instead?",
      "answer": [
        "Textmagic doesn't support sending texts from personal mobile numbers due to carrier restrictions. To send texts, you can use our local dedicated virtual number or a Sender ID."
      ]
    },
    {
      "question": "Can I have multiple virtual numbers on one account?",
      "answer": [
        "Yes, it is possible to have multiple virtual numbers on the account and use them to send different campaigns."
      ]
    },
    {
      "question": "Can I receive inbound messages using the Textmagic virtual number?",
      "answer": [
        "Yes, you can. With the Textmagic virtual number, you can send and receive messages, as well as make phone calls. Australian virtual number is designed to work only with local Australian mobile subscribers and cannot receive 2FA/verification texts."
      ]
    },
    {
      "question": "How am I charged for the virtual number subscription?",
      "answer": [
        "When you sign up, you'll get an Australian virtual number for the first month for free. After the first free month, the credit for the virtual number renewal will be automatically deducted from your prepaid account balance.",
        "Learn more about {pricing}"
      ],
      "pricing": "Textmagic pricing."
    },
    {
      "question": "How much does it cost for someone to send a message to my virtual number?",
      "answer": [
        "The cost for sending the SMS is just the standard charge made by your client’s mobile operator for sending a message. Textmagic never charges your client for sending a message."
      ]
    }
  ],
  "gettingStartedAuUkSenderIdsFaq": [
    {
      "question": "What is a Sender ID, and how does it work?",
      "answer": [
        "A Sender ID is a unique name that appears in the \"from\" field of your text messages on the recipient's phone. It is important to note that:",
        [
          "The Sender ID can be a maximum of 11 characters long.",
          "The Sender ID must relate to your business name and cannot be a general word.",
          "The Sender ID subscription can be shared with your team members.",
          "Your recipients cannot reply to text messages sent using a Sender ID.",
          "The Sender ID subscription costs {cost} per month."
        ]
      ]
    },
    {
      "question": "What is the difference between a virtual number and a Sender ID?",
      "answer": [
        "The virtual number and Sender ID serve different purposes and have distinct functions:",
        [
          "The {number} supports calls and two-way texting for various purposes like marketing, two-way SMS chats, customer alerts, and staff communication.",
          "The {sender} is designed for one-way outbound texting without reply capabilities. It is suitable for use cases like marketing campaigns and sending important announcements where responses are unnecessary."
        ]
      ],
      "virtualNumber": "virtual number",
      "senderId": "Sender ID"
    },
    {
      "question": "How can I get started with sending texts from my business name?",
      "answer": [
        "To send text messages from your business name (Sender ID):",
        [
          "Register for a Textmagic account or {logIn} to your existing account.",
          "{verify} by purchasing SMS credit.",
          "Go to the {sender} and click {apply}",
          "Fill out the Sender ID application with your company data and use case description."
        ],
        "A Textmagic specialist will review your Sender ID application. Once it is approved, you will receive an email confirmation."
      ],
      "logIn": "log in",
      "verify": "Verify your account value",
      "sender": "Sender IDs page",
      "apply": "Apply for Sender ID."
    },
    {
      "question": "Why was my Sender ID rejected?",
      "answer": [
        "Textmagic may reject your Sender ID application if one of the following applies:",
        [
          "Sender ID looks like a number, not a business name.",
          "Sender ID is a general word, not specific to your business name.",
          "Sender ID relates or looks similar to a well-known protected brand like Apple, UPS,  Lloyds etc."
        ]
      ]
    },
    {
      "question": "Can I set up my own number as a Sender ID?",
      "answer": [
        "You can't use your personal number as a Sender ID on Textmagic due to carrier restrictions. The Sender ID needs to reflect your company name for compliance."
      ]
    },
    {
      "question": "Can I register multiple Sender IDs on my account?",
      "answer": [
        "Yes, it is possible to have multiple Sender IDs on the account and use them to send different campaigns."
      ]
    },
    {
      "question": "Can I share one Sender ID with my team members?",
      "answer": ["Yes, the Sender ID is automatically shared with all your users from the same account branch."]
    },
    {
      "question": "Are there any restrictions when it comes to choosing a Sender ID?",
      "answer": [
        "The Sender ID can be a maximum of 11 characters long, consisting only of letters and numbers without any special characters. The use of generic sender IDs like INFO, SMS, NOTICE, etc. is prohibited."
      ]
    },
    {
      "question": "Can I receive inbound messages or replies to texts sent from a Sender ID?",
      "answer": [
        "No, you can not. The Sender ID is designed for one-way outbound texting without reply capabilities. It is suitable for use cases like marketing campaigns and sending important announcements where responses are unnecessary.\n"
      ]
    },
    {
      "question": "How am I charged for the Sender ID subscription?",
      "answer": [
        "The Sender ID subscription costs {cost} per month. The credit for the subscription renewal is automatically deducted from your prepaid account balance.",
        "Learn more about Textmagic pricing."
      ]
    }
  ],
  "gettingStartedUkVirtualNumbersFaq": [
    {
      "question": "What is a virtual number, and how does it work?",
      "answer": [
        "A Textmagic virtual number is a phone number that allows users to call, send, and receive text messages through the Textmagic platform.",
        "When you sign up, you'll get a UK virtual number for the first month for free. This number is designed to work only with UK mobile subscribers. It cannot receive 2FA/verification texts sent by other services.",
        "We recommend using the virtual number because it is perfect for all sorts of business communications, whether it's one-on-one conversations, marketing campaigns, or making phone calls."
      ]
    },
    {
      "question": "What is the difference between a virtual number and a Sender ID?",
      "answer": [
        "The virtual number and Sender ID serve different purposes and have distinct functions:",
        [
          "The {number} supports calls and two-way texting for various purposes like marketing, two-way SMS chats, customer alerts, and staff communication.",
          "The {sender} is designed for one-way outbound texting without reply capabilities. It is suitable for use cases like marketing campaigns and sending important announcements where responses are unnecessary."
        ]
      ],
      "virtualNumber": "virtual number",
      "senderId": "Sender ID"
    },
    {
      "question": "How can I get started with sending texts from a virtual number?",
      "answer": [
        "When you sign up, you'll get a UK virtual number for the first month for free. You can start texting instantly via the {compose} and {chats} pages."
      ],
      "compose": "Compose",
      "chats": "Chats"
    },
    {
      "question": "Can I port in my existing virtual number to Textmagic?",
      "answer": [
        "Textmagic does not offer number porting in the UK. Please use our dedicated virtual UK number or a Sender ID."
      ]
    },
    {
      "question": "Can I send text messages from my own mobile number instead?",
      "answer": [
        "Textmagic doesn't support sending texts from personal mobile numbers due to carrier restrictions. To send texts, you can use our dedicated virtual UK number or a Sender ID. "
      ]
    },
    {
      "question": "Can I have multiple virtual numbers on one account?",
      "answer": [
        "Yes, it is possible to have multiple virtual numbers on the account and use them to send different campaigns."
      ]
    },
    {
      "question": "Can I receive inbound messages using the Textmagic virtual number?",
      "answer": [
        "Yes, you can. With the Textmagic virtual number, you can send and receive messages, as well as make phone calls. The UK virtual number is designed to work only with local UK mobile subscribers and cannot receive 2FA/verification texts."
      ]
    },
    {
      "question": "How am I charged for the virtual number subscription?",
      "answer": [
        "When you sign up, you'll get a UK virtual number for the first month for free. After the first free month, the credit for the virtual number renewal will be automatically deducted from your prepaid account balance. ",
        "Learn more about {pricing}"
      ],
      "pricing": "Textmagic pricing."
    },
    {
      "question": "How much does it cost for someone to send a message to my virtual number?",
      "answer": [
        "The cost for sending the SMS is just the standard charge made by your client’s mobile operator for sending a message. Textmagic never charges your client for sending a message."
      ]
    }
  ],
  "gettingStartedRequestNumberButton": {
    "requestNumber": "Request a number"
  },
  "upgradeAccountModal": {
    "title": "Upgrade your account to unlock this feature",
    "description": ["Unlock the sub-accounts feature by buying credit,", "and bring your team on board with you."],
    "buyCredit": "Buy credit"
  },
  "sentry": {
    "feedback": "Feedback",
    "feedbackAndIdeas": "Feedback and ideas",
    "sendFeedback": "Send feedback",
    "messagePlaceholder": "Describe your ideas to improve this page…",
    "emailLabel": "Your email"
  },
  "tenDlcSampleMessagesFormService": {
    "defaultMessage": "[Enter your sample message]\nReply STOP to opt out."
  },
  "importResultListCell": {
    "listsLink": "{count} lists",
    "blocked": "Blocked contacts",
    "unsubscribed": "Unsubscribed contacts"
  },
  "fieldPhoneWithCountrySelect": {
    "emptyValue": "- Select a virtual number -"
  },
  "buyCreditAlert": {
    "notEnoughCredit": "Sorry, but you do not have enough credit to buy this number. Please {link} now to continue.",
    "buyCredit": "buy credit"
  },
  "HeaderProfilePendingTooltip": {
    "title": "Your order is being processed",
    "description": {
      "orderWillBeReviewed": "Your order will be reviewed within the next { hours } hours by our accounts team. If you wish to avoid waiting and get your order processed instantly, please verify your identity.",
      "youWillReceiveConfirmation": "You will receive confirmation once your account is topped up. Thank you for your patience."
    }
  },
  "headerProfileRemainingMessagesTooltip": {
    "currentCreditAllows": "Your current credit allows to send about:",
    "worldwideCpass": "{quantity} worldwide (via CPaaS provider)* ",
    "viaTextmagic": "(via Textmagic numbers)",
    "viaEmailCampaigns": "{quantity} (via email campaigns)",
    "email": "email | emails",
    "numbersMayVaryBased": "* Numbers may vary based on SMS length, encoding & destination.",
    "viewFullPricingTable": "View full pricing table",
    "watchTutorialAboutBilling": "Watch tutorial about billing",
    "freeBonusCredits": "Free bonus credits:",
    "to": "to",
    "emailLookup": "email lookup | email lookups"
  },
  "headerProfileRemainingMessagesTooltipBonusInfoItem": {
    "left": "left"
  },
  "userPresence": {
    "online": "Online",
    "offline": "Offline",
    "tooltip": "Set your availability for live chat. If all agents are offline, an auto-reply will be shown or live chat will be hidden based on your widget settings."
  },
  "sidebarDivider": {
    "comingSoon": "Coming soon"
  },
  "tasks": {
    "increaseProductivity": "Increase your team's productivity with tasks",
    "movePlanning": "Move your project planning, organization, and teamwork forward with fully customizable task management.",
    "faqDescription": "Haven’t found what you were looking for? {contact}",
    "faq": {
      "whatIsFeature": "What is the tasks feature?",
      "features": "The tasks feature in Textmagic is a user-friendly tool designed to simplify tracking your team activities. Each task can be customized with file attachments, optional due dates, and reminders to ensure timely completion. All tasks are organized in a board-style layout, with each column representing a specific task stage for easy visualization. Plus, you have the flexibility to manage multiple projects simultaneously by setting up various boards tailored to each project's needs.",
      "howTasksDiffer": "How do tasks in Textmagic differ from other task managers?",
      "uniqueAdvantage": "Tasks in Textmagic offer a unique advantage over traditional task managers by integrating the ability to communicate directly with customers without needing to switch apps or contexts. By allowing tasks to be created and managed within the context of customer interactions, Textmagic enhances a team's ability to be responsive to customer needs. This not only improves customer satisfaction but also helps in quicker resolution of issues, as tasks can be assigned and addressed as soon as they arise from a conversation. Textmagic solution is ideal for teams looking for a more integrated and communication-centric approach.",
      "howCanImprove": "How can the Tasks feature improve my productivity?",
      "allowingToOrganize": "By allowing you to organize and prioritize your tasks, the feature helps you focus on what's important, reducing the time spent figuring out what to work on next. This organization leads to more efficient use of time and higher productivity. A board-style layout helps you quickly identify the most important tasks first, ensuring that high-priority work gets the attention it deserves. With a clear plan in place, you can dedicate more time to actual work rather than planning or juggling tasks in your mind.",
      "howCanHelp": "Can the Tasks feature help me in managing deadlines?",
      "dueDates": "Yes, it allows you to set due dates for each task. This keeps you aware of upcoming deadlines, helping you to plan ahead and avoid last-minute rushes. Plus, you can set reminders so you don't forget about these important deadlines. This way, you're less likely to miss something crucial and can stay more organized and relaxed.",
      "canCreate": "Can I create a task from the chat?",
      "createDirectly": "Yes, you can create a task directly from a chat conversation. This feature is designed to streamline workflows, allowing users to quickly turn discussions into actionable tasks without leaving the chat interface. This means that when a task or action item arises during a conversation, you can immediately create a task for it, ensuring that it gets attention and follow-up.",
      "linkAnything": "Plus, you can also link anything else from the Textmagic app to your tasks, like a contact, a list, or even a specific SMS message. This makes it easy to keep all your related stuff connected and organized right where you need it.",
      "canHelpWithDeadlines": "Can the tasks feature help me in managing deadlines?",
      "setDueDates": "Yes, it allows you to set due dates for each task. This keeps you aware of upcoming deadlines, helping you to plan ahead and avoid last-minute rushes. Plus, you can set reminders so you don't forget about these important deadlines. This way, you're less likely to miss something crucial and can stay more organized and relaxed."
    },
    "sideBar": {
      "personal": "Personal",
      "marketing": "Marketing",
      "support": "Support",
      "sales": "Sales",
      "dev": "Dev",
      "management": "Management",
      "design": "Design"
    }
  },
  "tickets": {
    "simplifySupport": "Simplify support with an intuitive ticketing system",
    "turnInteractions": "Turn customer interactions into meaningful experiences and delight customers at every turn.",
    "faqTitle": "Tickets FAQ",
    "haveNotFound": "Haven’t found what you were looking for? {contact}",
    "sideBar": {
      "assigned": "Assigned to me",
      "open": "Open",
      "pending": "Pending",
      "unassigned": "Unassigned",
      "solved": "Solved",
      "closed": "Closed ",
      "all": "All tickets"
    },
    "faq": {
      "whatIsFeature": "What is the tickets feature?",
      "features": "The tickets feature in Textmagic serves as a support and communication tool that aims to simplify the process of managing customer inquiries, service requests, and issues. This feature allows users to receive and create requests directly within the Textmagic platform, without using any third-party tools.",
      "whyUse": "Why should I use tickets in Textmagic?",
      "benefits": "Textmagic tickets offer an efficient solution for organizing all your communication in one place. Whether you're handling customer support queries, feedback, or specific issues, everything will be centralized and easily accessible. All relevant information and communications will be consolidated in one ticket, making it easier for you to contact the customer in a single click. By consolidating all the relevant information, resolving problems becomes much more efficient, and you won't have to waste time sifting through emails or messages on different platforms.",
      "canCreate": "Can I create a new ticket from chat?",
      "createEasily": "It's easy to create a ticket directly from the conversation. Additionally, you can link any item, such as a contact, chat, list, task, or single message, to the ticket. The Textmagic tickets feature is designed to increase the productivity of your support process, allowing you to focus solely on resolving issues without worrying about the interface.",
      "willCreateAutomatically": "Will you automatically create a ticket when I receive an email from someone?",
      "ticketAutomation": "Sure! Upon receiving a new email message, we will automatically determine whether it corresponds to an existing ticket or not. If it is a new message, we will create a new ticket."
    }
  },
  "monthlyPlansPayAsYouGo": {
    "title": "Pay-as-you-go plan",
    "description": "Pay-as-you-go allows you to add and spend credit whenever you want. Your prepaid balance won’t expire.",
    "downgradeButton": "Downgrade to pay-as-you-go plan"
  },
  "monthlyPlansCard": {
    "perMonth": "{currency} per month",
    "buttons": {
      "downgrade": "Downgrade",
      "currentPlan": "Current plan",
      "upgrade": "Upgrade"
    }
  },
  "monthlyPlansDefaultCard": {
    "discount": {
      "text": "{sale} discount",
      "tooltip": "Compared to Textmagic pay-as-you-go price."
    },
    "textMonth": {
      "text": "{quantity} texts / month",
      "tooltip": "Single messages are limited to {character} characters, including {br} spaces. Longer messages incur {end}",
      "end": "additional charges."
    },
    "perText": {
      "text": "{price} per text",
      "tooltip": "This is the price per text that you will be paying for every message that goes over the plan limit."
    },
    "allFeatures": "All features included",
    "chatAI": "Chat AI assistant"
  },
  "usersWorkflowFaq": {
    "title": "Users FAQ"
  },
  "usersWorkflowTopBar": {
    "searchPlaceholder": "Search users",
    "invite": "Add users",
    "import": "Import"
  },
  "badges": {
    "beta": "Beta",
    "new": "New",
    "tryNow": "Try now",
    "try": "Try",
    "recommended": "Recommended"
  },
  "inviteSubAccountEmailControl": {
    "roles": {
      "administrator": "Administrator",
      "user": "User"
    }
  },
  "inviteSubAccountFormContent": {
    "tooltipText": [
      {
        "text": "{arg0} - Can manage other users and billing.",
        "args": ["Administrator"]
      },
      {
        "text": "{arg0} - Cannot manage other users and billing.",
        "args": ["Regular user"]
      }
    ]
  },
  "inviteSubAccountAlert": {
    "text": "Users who accept invites will count as active seats in your Team plan."
  },
  "usersWorkflowLoadingOverlayContent": {
    "title": "Redirecting to Stripe...",
    "subtitle": "Please wait while we redirect you to a secure Stripe portal to complete checkout."
  },
  "usersWorkflowActive": {
    "accountOwner": "The workspace account owner is {name} - {email}.",
    "manage": "Manage"
  },
  "deleteInvitationModal": {
    "title": "Delete user invite",
    "text": [
      "Are you sure you would like to delete the invite for {email}?",
      "The user will not be able to join your workspace, and the invitation will be revoked."
    ],
    "successMessage": "The user invite has been successfully deleted."
  },
  "richEditor": {
    "formats": {
      "bold": "Bold",
      "underline": "Underline",
      "italic": "Italic",
      "strike": "Strikethrough",
      "codeBlock": "Code",
      "link": "Link",
      "bulletList": "Bulleted list",
      "orderedList": "Ordered list",
      "clear": "Clear formatting",
      "textAlignCenter": "Center",
      "textAlignLeft": "Left",
      "textAlignRight": "Right",
      "textAlignJustify": "Justify",
      "textColor": "Text color",
      "highlightColor": "Highlight color"
    },
    "pasteFormatted": "Paste formatted",
    "pastePlainText": "Paste as plain text",
    "linkText": "Link text",
    "formatting": "Formatting",
    "insertDynamicField": "Insert dynamic field"
  },
  "sentSmsDetailsSenderItem": {
    "label": "Sent by"
  },
  "saveFormFooterBar": {
    "unsavedChanges": "You have unsaved changes."
  },
  "formSubscribeLanding": {
    "copyright": "Subscribe form powered by {company}"
  },
  "fieldImageAttachArea": {
    "text": "Drag image here or {browse}",
    "browse": "browse..."
  },
  "fieldNarrowFileUploadArea": {
    "text": "Drag image here or {browse}",
    "browse": "browse..."
  },
  "fieldAssignee": {
    "assignTo": "Assign to",
    "unassigned": "Unassigned",
    "inviteNewUser": "Invite a new user",
    "you": "You",
    "owner": "Contact owner"
  },
  "tmDropdownUsersFilter": {
    "filter": "Filter",
    "deselectAll": "Deselect all",
    "selectAll": "Select all",
    "unassigned": "Unassigned",
    "searchPlaceholder": "Search users",
    "users": "{count} users",
    "allUsers": "All users"
  },
  "myContactDetails": {
    "contactShared": "This contact is shared by {name}.",
    "backToContacts": "Back to Contacts"
  },
  "commonPriority": {
    "low": "Low",
    "normal": "Normal",
    "high": "High",
    "urgent": "Urgent"
  },
  "fieldContactSelect": {
    "enterNameOrPhone": "Please enter Contact name or phone number",
    "newContact": "new contact"
  },
  "contactNotes": {
    "title": "Contact notes",
    "editNote": "Edit note",
    "addContactNote": "Add contact note",
    "showMoreNotes": "Show more notes",
    "showLessNotes": "Show less notes",
    "addNewNote": "Add a new note",
    "emptyTitle": "This contact has no notes",
    "emptyText": "Please add a new note using the button below.",
    "notesFor": "Notes for {name}"
  },
  "myContactsTable": {
    "unassigned": "Unassigned"
  },
  "myContactsViewSaver": {
    "saveAs": "Save as new segment",
    "unsavedChanges": "You can save the applied filters as a segment."
  },
  "fieldContactTags": {
    "newTag": "New tag",
    "enterTag": "Enter tag name"
  },
  "tmRestoreCell": {
    "expiresDays": "Expires in {days} day | Expires in {days} days"
  },
  "restoreNumberRenewalModal": {
    "title": "Restore number renewal",
    "buttonTitle": "Restore renewal",
    "text": "Are you sure you want to restore the subscription for the dedicated number {phone}? The next renewal date will be on {date}",
    "successMessage": "The selected number subscription has been successfully restored."
  },
  "pageSingle": {
    "important": "IMPORTANT: ",
    "back": "Back to Textmagic app",
    "copy": "Copy text",
    "poweredBy": "Powered by"
  },
  "contactListsTableDropdown": {
    "pin": "Pin list",
    "unpin": "Unpin list"
  },
  "pinnedContactListComposition": {
    "pinSuccess": "Your selected contact list have been successfully pinned.",
    "unpinSuccess": "Your selected contact list have been successfully unpinned."
  },
  "pinnedContactComposition": {
    "pinSuccess": "Your selected contact has been successfully pinned.",
    "unpinSuccess": "Your selected contact has been successfully unpinned."
  },
  "pinnedSegmentComposition": {
    "pinSuccess": "Your selected segment has been successfully pinned.",
    "unpinSuccess": "Your selected segment has been successfully unpinned."
  },
  "tmPriceWithGiftCell": {
    "included": "included in your plan"
  },
  "tmFilterTopBar": {
    "addFilterLabel": "Add filter",
    "addFiltersLabel": "More filters",
    "addGroupLabel": "Add filter group",
    "discardLabel": "Discard",
    "hidePanel": "Hide"
  },
  "tmSentSmsMessageCell": {
    "deleted": "Message deleted"
  },
  "typingSingle": {
    "userTyping": "is typing"
  },
  "typing": {
    "severalPeople": "Several people",
    "severalAgentsTyping": "{people} are typing"
  },
  "topFilterPanelButton": {
    "label": "Filters"
  },
  "messenger": {
    "scanQrCode": {
      "title": "scan QR Code"
    },
    "settings": {
      "breadcrumbs": {
        "chats": "Messaging",
        "settings": "Settings",
        "email": "Email",
        "emailsFlow": "Domains & senders"
      }
    }
  },
  "attachments": {
    "unknownName": "Unknown file",
    "attachFile": "Attach file",
    "maxFilesReached": "Maximum number of files reached",
    "errors": {
      "unknownUploadError": "Unknown upload error",
      "uploadErrorWithDash": "Upload error - ",
      "uploadError": "Upload error",
      "maxFileSizeError": "The maximum allowed file size is 10M.",
      "maxFileSizeErrorShort": "10MB maximum size",
      "offlineError": "Connection lost",
      "maxFileCustomSizeErrorShort": "{size} maximum size",
      "fileFormatErrorShort": "Format is not supported",
      "fileIsNotValid": "File is not valid"
    }
  },
  "tmFilterTagsEmpty": {
    "title": "There are no tags yet",
    "description": "Organize your {domain} by creating tags."
  },
  "tmFilterTags": {
    "searchPlaceholder": "Search tags",
    "containAny": "Contain any",
    "containAll": "Contain all",
    "containNone": "Do not contain",
    "areExactly": "Are exactly",
    "contain": "Contain"
  },
  "tmFilterContactsWithOptions": {
    "operations": {
      "all": "All",
      "is": "Is",
      "isNot": "Is not"
    },
    "placeholder": "Start typing name"
  },
  "tmFilterContactSource": {
    "searchPlaceholder": "Search source"
  },
  "tmFilterContactSourceForm": {
    "searchPlaceholder": "Search forms",
    "deletedForm": "Deleted form"
  },
  "tmFilterList": {
    "searchPlaceholder": "Search lists"
  },
  "tmFilterContactList": {
    "unlisted": "Unlisted",
    "notInAnyList": "Not in any list"
  },
  "tmFilterIsEmpty": {
    "options": {
      "all": "All",
      "isEmpty": "Is empty",
      "isNotEmpty": "Is not empty"
    }
  },
  "tmFilterWords": {
    "options": {
      "anyOf": "Contains any of these words or phrases",
      "allOf": "Contains all of these words or phrases",
      "noneOf": "Does not contain any of these words or phrases",
      "isEmpty": "Is empty",
      "isNotEmpty": "Is not empty"
    },
    "contains": "Contains",
    "containsAll": "Contains all",
    "doesNotContain": "Does not contain"
  },
  "tmFilterTermsHint": {
    "text": "Press {enter} or {comma} to separate terms.",
    "enter": "Enter"
  },
  "tmFilterEmail": {
    "options": {
      "anyOf": "Contains at least one of these words",
      "noneOf": "Contains none of these words",
      "isEmpty": "Is empty",
      "isNotEmpty": "Is not empty",
      "isUnsubscribed": "Is unsubscribed",
      "isNotUnsubscribed": "Is not unsubscribed"
    },
    "contains": "Contains",
    "doesNotContain": "Does not contain"
  },
  "tmFilterPhone": {
    "options": {
      "startsWith": "Starts with",
      "endsWith": "Ends with",
      "like": "Contains",
      "notLike": "Does not contain",
      "isEmpty": "Is empty",
      "isNotEmpty": "Is not empty"
    }
  },
  "tmFilterCountry": {
    "placeholder": "Search country"
  },
  "tmFilterContacts": {
    "emptyTitle": "There are no contacts yet"
  },
  "tmFilterOptions": {
    "empty": "Is empty",
    "placeholder": "Search options"
  },
  "tmFilterNumeric": {
    "empty": "Is empty",
    "notEmpty": "Is not empty",
    "between": "Between",
    "labels": {
      "BETWEEN": "Between",
      "GTE": "Greater than or equal to",
      "LTE": "Less than or equal to",
      "IS_EMPTY": "Is empty",
      "IS_NOT_EMPTY": "Is not empty"
    }
  },
  "tmFilterLabel": {
    "searchPlaceholder": "Search labels"
  },
  "recipientBadgeMore": "+ {count} more",
  "recipientBadgeLess": "- less {count}",
  "rRuleTextFormatterService": {
    "hourly": {
      "interval": "{hourly} every {hours} hour | {hourly} every {hours} hours",
      "hourly": "hourly"
    },
    "daily": {
      "interval": "daily | every {count} days"
    },
    "weekly": {
      "interval": "weekly | every {count} weeks",
      "weekday": "on {weekdays}"
    },
    "monthly": {
      "interval": "monthly | every {count} months",
      "monthday": "on the {day} of the month",
      "weekday": "on the {day}",
      "day": "{day} day"
    },
    "yearly": {
      "yearly": "yearly",
      "monthday": "on {day}",
      "weekday": "on the {day}",
      "value": "{pos} {day} of {month}"
    },
    "pos": {
      "1": "first",
      "2": "second",
      "3": "third",
      "4": "fourth",
      "-1": "last"
    },
    "end": {
      "never": "<b>will continue forever</b>",
      "after": "will stop <b>after {count} send</b> | will stop <b>after {count} sends</b>",
      "until": "until <b>{date}</b>"
    }
  },
  "composeScheduledTextFormatterService": {
    "once": "only once",
    "on": "on {date}",
    "timeSuffix": " at {time}",
    "timezone": " (UTC {offset}: {timezone})"
  },
  "privacyPolicy": {
    "title": "Updated Terms of Service and Privacy Policy",
    "subtitle": "We have updated our Terms of Service and Privacy Policy. Here is a summary of the main changes",
    "line1": "<strong>Optional third-party AI integrations.</strong> You can now connect your Textmagic account to third-party AI tools, such as ChatGPT or Claude, through an API. You control whether you enable this connection. Textmagic does not initiate or send this data to the AI tool. Any processing by the third-party AI tool is subject to that provider's own terms and privacy policy.",
    "line2": "<strong>Data processing updates.</strong> We have clarified our data retention periods, sub-processors, and the safeguards we use for international data transfers. We have also added information on how to submit data protection complaints, including a reference to the UK Information Commissioner’s Office (ICO), and confirmed that our existing support channel can be used to report security concerns. Our AI-powered features now also cover content creation and improvement in addition to customer support.",
    "termsOfService": "Terms of Service",
    "privacyPolicy": "Privacy Policy",
    "button1": "Read the full Terms of Service",
    "button2": "Read the full Privacy Policy",
    "finishLine": "These updates will take effect automatically on 28 Jul 2026 and will apply to your continued use of the Textmagic services."
  },
  "sidebarForms": {
    "contact": {
      "title": "Contact",
      "notAdded": {
        "title": "Number is not in your contacts",
        "text": "Add the number to contacts to properly manage related data."
      },
      "isBlocked": {
        "title": "This contact is blocked",
        "text": "To be able to exchange messages with this contact, unblock it first."
      },
      "isUnsubscribed": {
        "title": "This contact is unsubscribed",
        "text": "This contact has unsubscribed from your lists. No messages can be sent to this contact."
      },
      "actions": {
        "unblockContact": "Unblock contact",
        "resubscribeContact": "Resubscribe contact"
      }
    }
  },
  "tmFilterLastMessageSource": {
    "label": "Last reply status",
    "options": {
      "all": "All",
      "customer": "No agent reply",
      "agent": "No customer reply"
    }
  },
  "myContactsCreatedNotification": {
    "sendSms": "Send SMS"
  },
  "sidebarAlsoHere": {
    "alsoHere": "Also here:"
  },
  "tmSidebarFormContactEmailFieldPreview": {
    "resubscribe": "Resubscribe email"
  },
  "deletedEntity": {
    "contact": "Deleted contact",
    "segment": "Deleted segment",
    "list": "Deleted list",
    "flow": "Deleted flow"
  },
  "blockedContact": "Blocked contact",
  "emailEditor": {
    "addLink": "Add link",
    "editLink": "Update link",
    "table": {
      "table": "Table",
      "rows": "Rows",
      "columns": "Columns",
      "cells": "Cells",
      "insertTable": "Insert table",
      "tableSettings": "Table settings",
      "tableBorderColor": "Table border color",
      "tableBackgroundColor": "Table background color",
      "deleteTable": "Delete table",
      "addRowBelow": "Add row below",
      "addRowAbove": "Add row above",
      "removeRow": "Remove row",
      "addColumnAfter": "Add column after",
      "addColumnBefore": "Add column before",
      "removeColumn": "Remove column",
      "cellBorderColor": "Cell border color",
      "cellBackgroundColor": "Cell background color",
      "splitCell": "Split cell",
      "mergeCells": "Merge selected cells"
    },
    "insertSentEmail": "Insert sent email",
    "composeFooterContent": {
      "company": "This email was sent to you by {companyName}.",
      "companyPlaceholder": "[ENTER YOUR COMPANY NAME]",
      "addressPlaceholder": "[ENTER YOUR MAILING ADDRESS]",
      "unsubscribeText": "If you no longer wish to receive these emails, you can {unsubscribe} here.",
      "unsubscribe": "Unsubscribe"
    },
    "touchpointLink": "Generate email with AI"
  },
  "fieldTagsRecipient": {
    "contactHasBeenRemovedOrUnsubscribed": "This contact has been removed or unsubscribed. Please add a valid recipient."
  },
  "os": {
    "windows": "Windows",
    "macos": "Macos",
    "linux": "Linux",
    "android": "Android",
    "ios": "Ios"
  },
  "client": {
    "chrome": "Google Chrome",
    "edge": "Edge",
    "firefox": "Firefox",
    "safari": "Safari",
    "opera": "Opera",
    "gmail": "Gmail",
    "appleMail": "Apple mail"
  },
  "emailCampaignsPromoModal": {
    "newFeature": "NEW FEATURE",
    "title": "Send email campaigns to your contacts",
    "description": "You can now email your contacts just like you text them. Send updates, promotions, reminders, or alerts to many people at once.",
    "features": {
      "sendToThousands": "Send to thousands in one go",
      "trackMetrics": "Track opens, clicks, and bounces",
      "getReplies": "Get replies in your shared inbox",
      "designEmails": "Design beautiful emails with our editor"
    },
    "subtitle": "Fast setup. Works like texting - just with email.",
    "getStarted": "Get started now",
    "remindLater": "Remind me later"
  },
  "baseFieldTagsRecipient": {
    "youHaveReachedTheLimitForAddingSeparateRecipients": "You have reached the limit for adding separate recipients. For larger campaigns, please import your contacts, add them to a list, and select that list as recipients."
  },
  "contactsTagsTopBar": {
    "searchPlaceholder": "Search tags",
    "newTag": "New tag"
  },
  "contactsTagsTable": {
    "columns": {
      "title": "Tag name",
      "contactsCounter": "Contacts",
      "chatsCounter": "Chats",
      "ticketsCounter": "Tickets"
    }
  },
  "contactsTagsEmptyState": {
    "title": "There are no tags yet",
    "description": "Use tags to categorize contacts, conversations and organize work better.",
    "buttonTitle": "Create new tag"
  },
  "contactsTagsCreateEditModal": {
    "editTitle": "Rename tag",
    "createTitle": "New tag",
    "field": {
      "title": {
        "label": "Tag name",
        "placeholder": "Enter tag name"
      }
    },
    "tag": "tag"
  },
  "contactsTagsDeleteModal": {
    "title": "Delete tag",
    "text": "Are you sure you want to delete the tag “{tag}” from all entities? This action will not delete any entities associated with it.",
    "successText": "The tag has been successfully deleted."
  },
  "stripo": {
    "loading": {
      "title": "Loading editor",
      "description": "Please wait..."
    }
  },
  "automationMenu": {
    "automations": "Automations",
    "flows": "Flows",
    "templates": "Templates",
    "logs": "Logs"
  },
  "scheduledSideBar": {
    "scheduled": "Scheduled",
    "upcoming": "Upcoming",
    "paused": "Paused",
    "notSent": "Not sent",
    "completed": "Completed",
    "calendar": "Calendar",
    "details": "{which} message details"
  },
  "facebookDataDeletionStatus": {
    "title": {
      "processing": "Your Facebook-related data deletion request is being processed.",
      "success": "Your Facebook-related data has been permanently deleted.",
      "error": "Unable to process your Facebook data deletion request."
    },
    "description": {
      "processing": "We have received your request and are currently removing your Facebook-related information from our systems. This may take up to a few days.",
      "success": "We've removed all information associated with your Facebook account from our systems.",
      "error": "There was an issue processing your request. Please try again later or contact our support team."
    },
    "contactUs": "For more details, please contact us:"
  },
  "emailBonusTooltip": {
    "mainText": "Verify your domain to receive {emails} free emails and {emailLookups} email lookups. Bonus will be activated after approval. Further usage is billed on a pay-as-you-go basis.",
    "bonusToFirstVerifiedDomainText": "Bonus applies to the first verified domain only."
  },
  "emailBonusOptionWithTooltip": {
    "firstIsFree": "First {quantity} email free! | First {quantity} emails free!"
  },
  "emailBonusBadgeWithTooltip": {
    "firstIsFree": "First {quantity} email free | First {quantity} emails free",
    "firstIsFreeMobile": "{quantity} email free! | {quantity} emails free!",
    "getIsFreeEmailLookup": "Get {quantity} email lookup free | Get {quantity} email lookups free"
  },
  "registrationNumberType": {
    "EIN": "EIN",
    "CBN": "CBN",
    "NEQ": "NEQ",
    "PROVINCIAL_NUMBER": "Provincial nr."
  },
  "emailCampaignDomainEntriSell": {
    "notifications": {
      "purchaseAborted": "We couldn't complete your domain purchase due to an error. Please try again or contact support if the issue continues.",
      "purchaseSuccess": "Your domain has been purchased successfully. The setup is in progress and will complete automatically in a few moments."
    }
  },
  "redirect": {
    "shopify": {
      "status": {
        "connected": "Shopify has been connected",
        "disconnected": "Shopify has been disconnected",
        "error": "Failed to connect to Shopify"
      }
    },
    "hubSpot": {
      "setup": {
        "title": "Finish your HubSpot setup in Textmagic",
        "description": "After you approve access in HubSpot, you'll stay there. Come back to Textmagic to match your fields and start syncing contacts.",
        "steps": {
          "approveAccess": {
            "title": "Approve access in HubSpot",
            "description": "Choose your HubSpot account and connect the app."
          },
          "return": {
            "title": "Return to Textmagic",
            "description": "Go to {to}. You'll see it marked as:",
            "to": "Integrations › HubSpot"
          },
          "finish": {
            "title": "Finish setup",
            "description": "Click the integration, match your fields, and run the first sync."
          }
        },
        "contactsWonSync": "Contacts won't sync until {step} is done. We'll also email you a link to finish setup.",
        "step": "step {order}",
        "setupGuide": "Setup guide",
        "gotIt": "Got it, continue to HubSpot"
      }
    }
  },
  "dropdownLabelPicker": {
    "searchPlaceholder": "Search labels",
    "createNewLabel": "Create new label",
    "removeLabel": "Remove label"
  },
  "labelPickerForEntity": {
    "successAddedText": "The label has been successfully added."
  },
  "outboundEmailStatus": {
    "pending": "Pending",
    "sent": "Sent",
    "delivered": "Delivered",
    "rejected": "Suppressed",
    "failed": "Bounced",
    "opened": "Opened",
    "clicked": "Clicked",
    "unsubscribed": "Unsubscribed",
    "spam": "Spam"
  },
  "resendTimer": {
    "resend": "Resend code",
    "timer": "Resend code in {minutes}{seconds}",
    "minutes": "{minutes}m",
    "seconds": "{seconds}s",
    "clockFormat": "Send again in {minutes}:{seconds}"
  },
  "newAssignedToYouNotification": "New chat has been assigned to you | {count} chats have been assigned to you",
  "tmTokenField": {
    "token": "Token",
    "replace": "Replace",
    "enterNewToken": "Enter a new token",
    "keepCurrent": "Keep current",
    "storedSecurely": "Stored securely – we only keep a hint. Replace it to use a different token."
  }
}
